export default {
  'pages.application.error.create': 'Failed to create application',
  'pages.application.error.delete': 'Failed to delete application',
  'pages.application.error.org': 'Failed to get organization information',
  'pages.application.error.project': 'Failed to get project information',
  'pages.application.error.update': 'Failed to update application',
  'pages.application.error.user': 'Failed to get user information',
  'pages.application.form.code.exists': 'Application code already exists',
  'pages.application.form.code.label': 'Application Code',
  'pages.application.form.code.placeholder':
    'Please enter application code, e.g. CRM',
  'pages.application.form.code.required': 'Please enter application code',
  'pages.application.form.desc.label': 'Description',
  'pages.application.form.desc.placeholder': 'Please enter description',
  'pages.application.form.name.label': 'Application Name',
  'pages.application.form.name.placeholder': 'Please enter application name',
  'pages.application.form.name.required': 'Please enter application name',
  'pages.application.form.type.label': 'Application Type',
  'pages.application.form.type.placeholder':
    'Please enter application type, e.g. web',
  'pages.application.form.url.label': 'Home URL',
  'pages.application.list.columns.action': 'Action',
  'pages.application.list.columns.code': 'Application Code',
  'pages.application.list.columns.home': 'Home Page',
  'pages.application.list.columns.name': 'Application Name',
  'pages.application.list.columns.type': 'Type',
  'pages.application.list.columns.updatedAt': 'Updated At',
  'pages.application.list.create': 'Create Application',
  'pages.application.list.delete': 'Delete',
  'pages.application.list.deleteConfirm':
    'Are you sure you want to delete this application?',
  'pages.application.list.edit': 'Edit',
  'pages.workspace.list.title': 'ワークスペース管理',
  'pages.workspace.list.subTitle':
    'プロジェクト内のワークスペースとコード境界を管理',
  'pages.codebase.catalog.title': 'コードリポジトリ',
  'pages.codebase.catalog.subTitle':
    'プロジェクト内のコードリポジトリとワークスペース所属を管理',
  'pages.customerIntelligence.customerList.boolean.yes': 'はい',
  'pages.customerIntelligence.customerList.boolean.no': 'いいえ',
  'pages.customerIntelligence.customerList.placeholder.empty': '-',
  'pages.customerIntelligence.customerList.columns.name': '顧客名',
  'pages.customerIntelligence.customerList.columns.owner': '担当者',
  'pages.customerIntelligence.customerList.columns.mobile': '携帯番号',
  'pages.customerIntelligence.customerList.columns.email': 'メール',
  'pages.customerIntelligence.customerList.columns.followUpStatus':
    'フォロー状況',
  'pages.customerIntelligence.customerList.columns.lockStatus': 'ロック',
  'pages.customerIntelligence.customerList.columns.dealStatus': '成約',
  'pages.customerIntelligence.customerList.columns.contactLastTime':
    '最終連絡日時',
  'pages.customerIntelligence.customerList.columns.contactNextTime':
    '次回連絡日時',
  'pages.customerIntelligence.customerList.search.keyword': 'キーワード',
  'pages.customerIntelligence.customerList.alert.missingMember':
    '現在のアカウントはメンバーに紐付いていないため、顧客の閲覧や作成はできません。',
  'pages.customerIntelligence.customerList.alert.missingTenant':
    'テナントが選択されていません。顧客データを正常に読み込めない可能性があります。',
  'pages.customerIntelligence.customerList.create.button': '顧客を作成',
  'pages.customerIntelligence.customerList.create.success':
    '顧客を作成しました',
  'pages.customerIntelligence.customerList.create.error':
    '顧客の作成に失敗しました',
  'pages.customerIntelligence.customerList.create.modalTitle': '顧客を作成',
  'pages.customerIntelligence.customerList.create.form.name': '顧客名',
  'pages.customerIntelligence.customerList.create.form.name.required':
    '顧客名を入力してください',
  'pages.customerIntelligence.customerList.create.form.name.placeholder':
    '顧客名を入力してください',
  'pages.customerIntelligence.customerList.create.form.mobile': '携帯番号',
  'pages.customerIntelligence.customerList.create.form.telephone': '固定電話',
  'pages.customerIntelligence.customerList.create.form.email': 'メール',
  'pages.customerIntelligence.customerList.create.form.qq': 'QQ',
  'pages.customerIntelligence.customerList.create.form.wechat': 'WeChat',
  'pages.customerIntelligence.customerList.create.form.remark': '備考',
  'pages.customerIntelligence.customerList.empty': '顧客データがありません',
  'pages.customerIntelligence.customerList.detail.title': '顧客詳細',
  'pages.application.list.subTitle':
    'Manage all applications under the project',
  'pages.application.list.title': 'Application List',
  'pages.application.success.create': 'Application created successfully',
  'pages.application.success.delete': 'Application deleted successfully',
  'pages.application.success.update': 'Application updated successfully',
  'pages.assetLibrary.columns.action': 'Action',
  'pages.assetLibrary.columns.action.download': 'Download',
  'pages.assetLibrary.columns.action.preview': 'Preview',
  'pages.assetLibrary.columns.action.upload': 'Upload Asset',
  'pages.assetLibrary.columns.name': 'Asset Name',
  'pages.assetLibrary.columns.owner': 'Owner',
  'pages.assetLibrary.columns.size': 'Size',
  'pages.assetLibrary.columns.type': 'Type',
  'pages.assetLibrary.columns.updatedAt': 'Updated At',
  'pages.assetLibrary.folders': 'Folders',
  'pages.assetLibrary.folders.addSub': '新增子级文件夹',
  'pages.assetLibrary.folders.createSuccess': '文件夹创建成功',
  'pages.assetLibrary.folders.delete': '删除文件夹',
  'pages.assetLibrary.folders.deleteConfirm': '确定要删除该文件夹吗？',
  'pages.assetLibrary.folders.deleteSuccess': '文件夹删除成功',
  'pages.assetLibrary.folders.edit': '编辑文件夹',
  'pages.assetLibrary.folders.editSuccess': '文件夹更新成功',
  'pages.assetLibrary.list.subTitle':
    'Construction assets such as images and icons, with underlying file management integration',
  'pages.assetLibrary.list.title': 'Asset Library',
  'pages.assetLibrary.rootFolder': 'All Assets',
  'pages.assetLibrary.type.icon': 'Icon',
  'pages.assetLibrary.type.illustration': 'Illustration',
  'pages.assetLibrary.type.image': 'Image',
  'pages.auditLog.columns.action': 'Action',
  'pages.auditLog.columns.action.create': 'Create',
  'pages.auditLog.columns.action.delete': 'Delete',
  'pages.auditLog.columns.action.export': 'Export',
  'pages.auditLog.columns.action.import': 'Import',
  'pages.auditLog.columns.action.login': 'Login',
  'pages.auditLog.columns.action.logout': 'Logout',
  'pages.auditLog.columns.action.query': 'Query',
  'pages.auditLog.columns.action.update': 'Update',
  'pages.auditLog.columns.createdAt': 'Operation Time',
  'pages.auditLog.columns.description': 'Description',
  'pages.auditLog.columns.ip': 'IP Address',
  'pages.auditLog.columns.module': 'Module',
  'pages.auditLog.columns.modulePlaceholder': 'Enter module name',
  'pages.auditLog.columns.operation': 'Operation',
  'pages.auditLog.columns.operation.detail': 'Detail',
  'pages.auditLog.columns.resourceType': 'Resource Type',
  'pages.auditLog.columns.status': 'Status',
  'pages.auditLog.columns.status.failed': 'Failed',
  'pages.auditLog.columns.status.success': 'Success',
  'pages.auditLog.columns.username': 'User',
  'pages.auditLog.detail.errorMessage': 'Error Message',
  'pages.auditLog.detail.id': 'Operation ID',
  'pages.auditLog.detail.method': 'Request Method',
  'pages.auditLog.detail.path': 'Request Path',
  'pages.auditLog.detail.requestData': 'Request Data',
  'pages.auditLog.detail.resourceId': 'Resource ID',
  'pages.auditLog.detail.responseData': 'Response Data',
  'pages.auditLog.detail.title': 'Log Detail',
  'pages.auditLog.list.title': 'Operation Log List',
  'pages.callback.processing': 'ログイン処理中...',
  'pages.communication.columns.action': 'Action',
  'pages.communication.columns.content': 'Content',
  'pages.communication.columns.date': 'Date',
  'pages.communication.columns.leader': 'Leader',
  'pages.communication.columns.location': 'Location/Link',
  'pages.communication.columns.method': 'Method',
  'pages.communication.columns.participants': 'Participants',
  'pages.communication.columns.status': 'Status',
  'pages.communication.columns.title': 'Topic',
  'pages.communication.create': 'New',
  'pages.communication.delete': 'Delete',
  'pages.communication.edit': 'Edit',
  'pages.communication.error.create': 'Add failed, please try again!',
  'pages.communication.error.delete': 'Delete failed, please try again',
  'pages.communication.error.update': 'Configuration failed, please try again!',
  'pages.communication.list': 'Query Table',
  'pages.communication.loading.create': 'Adding...',
  'pages.communication.loading.delete': 'Deleting...',
  'pages.communication.loading.update': 'Configuring...',
  'pages.communication.placeholder.content': 'Please enter content',
  'pages.communication.placeholder.richContent':
    'Please enter communication content',
  'pages.communication.placeholder.title': 'Please enter topic',
  'pages.communication.required': 'This field is required',
  'pages.communication.subTitle': 'Manage Project Communication Records',
  'pages.communication.success.create': 'Added successfully',
  'pages.communication.success.delete': 'Deleted successfully, refreshing...',
  'pages.communication.success.update': 'Configured successfully',
  'pages.communication.title': 'Communication Records',
  'pages.defectManagement.columns.id': '不具合番号',
  'pages.defectManagement.columns.owner': '担当チーム',
  'pages.defectManagement.columns.severity': '重要度',
  'pages.defectManagement.columns.status': '状態',
  'pages.defectManagement.columns.title': '不具合内容',
  'pages.defectManagement.columns.updatedAt': '更新日時',
  'pages.defectManagement.mock.backendTeam': 'バックエンドチーム',
  'pages.defectManagement.mock.bug087.title': '通知センターの未読数更新が遅延',
  'pages.defectManagement.mock.bug099.title':
    '要件ドキュメント出力時のレイアウト崩れ',
  'pages.defectManagement.mock.bug101.title':
    '注文送信後に重複作成が断続的に発生',
  'pages.defectManagement.mock.frontendTeam': 'フロントエンドチーム',
  'pages.defectManagement.mock.platformTeam': 'プラットフォームチーム',
  'pages.defectManagement.severity.critical': '重大',
  'pages.defectManagement.severity.major': '中',
  'pages.defectManagement.severity.minor': '軽微',
  'pages.defectManagement.status.closed': 'クローズ済み',
  'pages.defectManagement.status.fixed': '検証待ち',
  'pages.defectManagement.status.open': '修正待ち',
  'pages.defectManagement.subTitle':
    '不具合の登録、割り当て、修正検証、クローズを追跡します',
  'pages.defectManagement.title': '不具合管理',
  'pages.defectManagement.status.new': '新規',
  'pages.defectManagement.status.assigned': '割り当て済み',
  'pages.defectManagement.status.inProgress': '対応中',
  'pages.defectManagement.status.resolved': '検証待ち',
  'pages.defectManagement.status.reopened': '再オープン',
  'pages.defectManagement.columns.priority': '優先度',
  'pages.defectManagement.columns.assignee': '担当者',
  'pages.defectManagement.columns.action': '操作',
  'pages.defectManagement.columns.createdAt': '作成日時',
  'pages.defectManagement.action.create': '不具合を作成',
  'pages.defectManagement.action.edit': '編集',
  'pages.defectManagement.action.view': '詳細',
  'pages.defectManagement.action.transition': '状態遷移',
  'pages.defectManagement.action.comment': 'コメント追加',
  'pages.defectManagement.detail.comments': 'コメント',
  'pages.defectManagement.detail.operations': '操作履歴',
  'pages.defectManagement.redirectTip':
    'テスト管理から遷移し、統一不具合ワークスペースを表示しています',
  'pages.forgotPassword.backToLogin': 'ログインに戻る',
  'pages.forgotPassword.code.placeholder': '認証コードを入力してください',
  'pages.forgotPassword.code.required': '認証コードを入力してください。',
  'pages.forgotPassword.codeSendFailed': '認証コードの送信に失敗しました。',
  'pages.forgotPassword.codeSent': '認証コードを送信しました。',
  'pages.forgotPassword.confirmPassword.placeholder':
    '新しいパスワードを再入力してください',
  'pages.forgotPassword.confirmPassword.required':
    '新しいパスワードを再入力してください。',
  'pages.forgotPassword.errorMessage': 'パスワード再設定に失敗しました',
  'pages.forgotPassword.failure':
    'パスワード再設定に失敗しました。もう一度お試しください。',
  'pages.forgotPassword.getCode': '認証コードを取得',
  'pages.forgotPassword.newPassword.minLength':
    'パスワードは6文字以上で入力してください。',
  'pages.forgotPassword.newPassword.placeholder':
    '新しいパスワードを入力してください',
  'pages.forgotPassword.newPassword.required':
    '新しいパスワードを入力してください。',
  'pages.forgotPassword.passwordMismatch':
    '2回入力したパスワードが一致しません。',
  'pages.forgotPassword.phone.invalid': '電話番号の形式が正しくありません。',
  'pages.forgotPassword.phone.placeholder': '電話番号を入力してください',
  'pages.forgotPassword.phone.required': '電話番号を入力してください。',
  'pages.forgotPassword.success':
    'パスワードの再設定が完了しました。再度ログインしてください。',
  'pages.forgotPassword.successMessage':
    'パスワード再設定が完了しました。ログイン画面へ移動します。',
  'pages.forgotPassword.title': 'パスワードを忘れた場合',
  'pages.knowledgeBase.category.manual': 'Operation Manual',
  'pages.knowledgeBase.category.specification': 'Specification',
  'pages.knowledgeBase.category.template': 'Template',
  'pages.knowledgeBase.columns.category': 'Category',
  'pages.knowledgeBase.columns.option': 'Option',
  'pages.knowledgeBase.columns.owner': 'Owner',
  'pages.knowledgeBase.columns.title': 'Document Title',
  'pages.knowledgeBase.columns.updatedAt': 'Updated At',
  'pages.knowledgeBase.columns.version': 'Version',
  'pages.knowledgeBase.option.edit': 'Edit',
  'pages.knowledgeBase.option.view': 'View',
  'pages.knowledgeBase.subTitle':
    'Enterprise Knowledge Management System (File Management)',
  'pages.knowledgeBase.title': 'Knowledge Base',
  'pages.knowledgeBase.toolBar.create': 'Create Knowledge',
  'pages.knowledgeBase.toolBar.upload': 'Upload Document',
  'pages.layouts.userLayout.title': 'こんにちは！',
  'pages.login.accountLogin.errorMessage':
    'ユーザー名/パスワードが正しくありません',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.captcha.placeholder': '確認コード',
  'pages.login.captcha.required': '確認コードを入力してください！',
  'pages.login.failure': 'ログインに失敗したら、もう一度試してください!',
  'pages.login.forgotPassword': 'パスワードをお忘れですか？',
  'pages.login.loginWith': 'その他のログイン方法：',
  'pages.login.password.placeholder': 'パスワード：ant.design',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.errorMessage': '検証コードエラー',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.redirecting': 'ログインページへリダイレクトしています...',
  'pages.login.redirectingHint':
    'しばらく遷移しない場合は、ブラウザのコンソールを確認してください。',
  'pages.login.registerAccount': 'アカウント登録',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.submit': 'ログイン',
  'pages.login.success': 'ログイン成功!',
  'pages.login.username.placeholder': 'ユーザー名：adminまたはuser',
  'pages.login.username.required': 'ユーザー名を入力してください！',
  'pages.prototypeDesign.columns.designer': 'Designer',
  'pages.prototypeDesign.columns.option': 'Operation',
  'pages.prototypeDesign.columns.pageName': 'Page Name',
  'pages.prototypeDesign.columns.reviewedAt': 'Review Time',
  'pages.prototypeDesign.columns.status': 'Status',
  'pages.prototypeDesign.columns.version': 'Version',
  'pages.prototypeDesign.mock.projectDetail': 'Project Detail Page',
  'pages.prototypeDesign.mock.projectList': 'Project List Page',
  'pages.prototypeDesign.mock.requirementDoc': 'Requirement Document Page',
  'pages.prototypeDesign.option.history': 'History',
  'pages.prototypeDesign.option.view': 'View',
  'pages.prototypeDesign.status.approved': 'Approved',
  'pages.prototypeDesign.status.draft': 'Draft',
  'pages.prototypeDesign.status.reviewing': 'Reviewing',
  'pages.prototypeDesign.subTitle':
    'Manage prototype versions, reviews and change records',
  'pages.prototypeDesign.title': 'Prototype Design',
  'pages.prototypeDesign.toolBar.create': 'New Prototype',
  'pages.prototypeDesign.toolBar.sync': 'Sync Design Platform',
  'pages.qualityManagement.columns.indicator': 'Indicator',
  'pages.qualityManagement.columns.score': 'Score',
  'pages.qualityManagement.columns.team': 'Responsible Team',
  'pages.qualityManagement.columns.trend': 'Trend',
  'pages.qualityManagement.columns.updatedAt': 'Updated At',
  'pages.qualityManagement.indicator.codeCompliance': 'Code Compliance Rate',
  'pages.qualityManagement.indicator.defectEscape': 'Defect Escape Rate',
  'pages.qualityManagement.indicator.testCoverage': 'Automation Test Coverage',
  'pages.qualityManagement.stats.closedIssues': 'Closed Issues',
  'pages.qualityManagement.stats.newIssues': 'New Issues This Week',
  'pages.qualityManagement.stats.overallScore': 'Overall Quality Score',
  'pages.qualityManagement.subTitle':
    'Quality Metrics, Check Results, and Continuous Improvement',
  'pages.qualityManagement.title': 'Quality Management',
  'pages.qualityManagement.trend.down': 'Down',
  'pages.qualityManagement.trend.flat': 'Flat',
  'pages.qualityManagement.trend.up': 'Up',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.config': '構成',
  'pages.getCaptchaSecondText': '秒',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.item': '項目',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.template.action.reset': 'リセット',
  'pages.template.action.submit': '送信',
  'pages.template.department.finance': '財務部',
  'pages.template.department.hr': '人事部',
  'pages.template.department.sales': '営業部',
  'pages.template.department.tech': '技術部',
  'pages.template.form.department': '部署',
  'pages.template.form.email': 'メール',
  'pages.template.form.joinDate': '入社日',
  'pages.template.form.name': '氏名',
  'pages.template.form.remarks': '備考',
  'pages.template.placeholder.department': '部署を選択してください',
  'pages.template.placeholder.email': 'メールを入力してください',
  'pages.template.placeholder.name': '氏名を入力してください',
  'pages.template.placeholder.remarks': '備考を入力してください',
  'pages.template.submit.success': 'フォームを送信しました！',
  'pages.template.title': 'テンプレート',
  'pages.template.validation.departmentRequired': '部署を選択してください',
  'pages.template.validation.emailInvalid': 'メール形式が正しくありません',
  'pages.template.validation.emailRequired': 'メールを入力してください',
  'pages.template.validation.joinDateRequired': '入社日を選択してください',
  'pages.template.validation.nameRequired': '氏名を入力してください',
  'pages.testManagement.columns.caseName': 'Test Case',
  'pages.testManagement.columns.executor': 'Executor',
  'pages.testManagement.columns.lastRunAt': 'Last Run',
  'pages.testManagement.columns.level': 'Level',
  'pages.testManagement.columns.option': 'Option',
  'pages.testManagement.columns.status': 'Result',
  'pages.testManagement.option.defect': 'Related Defects',
  'pages.testManagement.option.report': 'Test Report',
  'pages.testManagement.status.blocked': 'Blocked',
  'pages.testManagement.status.failed': 'Failed',
  'pages.testManagement.status.passed': 'Passed',
  'pages.testManagement.subTitle':
    'Manage test plans, test case execution and defect association',
  'pages.testManagement.title': 'Test Management',
  'pages.testManagement.toolBar.createPlan': 'New Test Plan',
  'pages.workbench.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.workbench.link': 'ようこそ',
  'auto.pages.pages.System.Menu.1': '工作台',
  'auto.pages.pages.System.Menu.2': '系统管理',
  'auto.pages.pages.System.Role.1': '管理员',
  'auto.pages.pages.System.Role.2': '系统管理员',
  'auto.pages.pages.System.Role.3': '普通用户',
  'auto.pages.pages.System.Role.4': '普通用户',
  'auto.pages.pages.System.User.1': '管理员',
  'auto.pages.pages.System.User.2': '管理员',
  'auto.pages.pages.System.User.3': '启用',
  'auto.pages.pages.System.User.4': '用户1',
  'auto.pages.pages.System.User.5': '普通用户',
  'auto.pages.pages.System.User.6': '启用',
  'auto.pages.pages.System.User.7': '管理员',
  'auto.pages.pages.System.User.8': '普通用户',
  'auto.pages.pages.System.User.9': '管理员',
  'auto.pages.pages.System.User.10': '普通用户',
  'auto.pages.pages.System.User.11': '启用',
  'auto.pages.pages.System.User.12': '禁用',
  'auto.pages.pages.System.User.13': '启用',
  'auto.pages.pages.System.User.14': '禁用',
  'auto.pages.pages.System.User.15': '启用',
  'auto.pages.pages.System.User.16': '管理员',
  'auto.pages.pages.System.User.17': '普通用户',
  'auto.pages.pages.System.User.18': '启用',
  'auto.pages.pages.System.User.19': '禁用',
  'auto.pages.pages.api-management.quick-debug.index.1': '接口快速调试',
  'auto.pages.pages.api-management.quick-debug.index.2':
    '快速验证接口请求与响应',
  'auto.pages.pages.api-management.quick-debug.index.3':
    '可在此配置请求参数、Header 与鉴权信息，快速调试接口。',
  'auto.pages.pages.api-management.quick-debug.index.4': '调试面板',
  'auto.pages.pages.api-management.quick-debug.index.5':
    '后续可接入接口选择、请求体编辑、响应结果查看与历史记录。',
  'auto.pages.pages.api-management.quick-debug.index.6':
    '接口快速调试功能建设中',
  'auto.component.pages.application.components.CreateAppModal.1': '创建应用',
  'auto.component.pages.application.components.CreateAppModal.2': '确定',
  'auto.component.pages.application.components.CreateAppModal.3': '取消',
  'auto.component.pages.application.components.CreateAppModal.4': '应用类型',
  'auto.component.pages.application.components.CreateAppModal.5': '应用名称',
  'auto.component.pages.application.components.CreateAppModal.6':
    '请输入应用名称',
  'auto.component.pages.application.components.CreateAppModal.7':
    '例如：我的应用',
  'auto.component.pages.application.components.CreateAppModal.8': '应用标识符',
  'auto.component.pages.application.components.CreateAppModal.9':
    '请输入应用标识符',
  'auto.component.pages.application.components.CreateAppModal.10':
    '例如：MyApp',
  'auto.component.pages.application.components.CreateAppModal.11':
    '组件框架（可选）',
  'auto.component.pages.application.components.CreateAppModal.12':
    '选择组件框架',
  'auto.component.pages.application.components.CreateAppModal.13':
    '应用描述（可选）',
  'auto.component.pages.application.components.CreateAppModal.14':
    '请输入应用描述',
  'auto.component.pages.application.components.CreateAppModal.15': '选择模板',
  'auto.component.pages.application.components.CreateAppModal.16':
    '暂无可用模板',
  'auto.component.pages.application.components.CreateAppModal.17':
    '请从左侧选择应用类型',
  'auto.pages.pages.application.constants.1': 'React Web应用',
  'auto.pages.pages.application.constants.2': '使用React框架开发的Web应用程序',
  'auto.pages.pages.application.constants.3': 'React管理后台模板',
  'auto.pages.pages.application.constants.4': '基于Ant Design的管理后台模板',
  'auto.pages.pages.application.constants.5': 'React电商模板',
  'auto.pages.pages.application.constants.6': '电商网站模板',
  'auto.pages.pages.application.constants.7': 'Vue3 Web应用',
  'auto.pages.pages.application.constants.8': '使用Vue3框架开发的Web应用程序',
  'auto.pages.pages.application.constants.9': 'Vue3管理后台模板',
  'auto.pages.pages.application.constants.10': '基于ElementPlus的管理后台模板',
  'auto.pages.pages.application.constants.11': 'Vue2 Web应用',
  'auto.pages.pages.application.constants.12': '使用Vue2框架开发的Web应用程序',
  'auto.pages.pages.application.constants.13': 'Next.js应用',
  'auto.pages.pages.application.constants.14':
    '使用Next.js框架开发的React应用程序',
  'auto.pages.pages.application.constants.15': '若依管理后台应用（Vu3）',
  'auto.pages.pages.application.constants.16':
    '基于 Vue3 + element-plus 实现的管理后台',
  'auto.pages.pages.application.constants.17': '前端 微应用',
  'auto.pages.pages.application.constants.18': '用于珊瑚云平台的前端微应用',
  'auto.pages.pages.application.constants.19': '后端 微应用',
  'auto.pages.pages.application.constants.20': '用于珊瑚云平台的后端微应用',
  'auto.pages.pages.application.constants.21': '微信小程序',
  'auto.pages.pages.application.constants.22': '微信平台上的轻量级应用',
  'auto.pages.pages.application.constants.23': '支付宝小程序',
  'auto.pages.pages.application.constants.24': '支付宝平台上的轻量级应用',
  'auto.pages.pages.application.constants.25': '百度小程序',
  'auto.pages.pages.application.constants.26': '百度平台上的轻量级应用',
  'auto.pages.pages.application.constants.27': 'Uniapp应用',
  'auto.pages.pages.application.constants.28':
    '使用Vue.js开发所有前端应用的框架',
  'auto.pages.pages.application.constants.29': 'Taro应用',
  'auto.pages.pages.application.constants.30': '开放式跨端跨框架解决方案',
  'auto.pages.pages.application.constants.31': 'iOS应用',
  'auto.pages.pages.application.constants.32': 'iOS原生应用开发',
  'auto.pages.pages.application.constants.33': 'Android应用',
  'auto.pages.pages.application.constants.34': 'Android原生应用开发',
  'auto.pages.pages.application.constants.35': 'Java应用',
  'auto.pages.pages.application.constants.36': 'Java后端应用开发',
  'auto.pages.pages.application.constants.37': 'Node.js应用',
  'auto.pages.pages.application.constants.38': 'Node.js后端应用开发',
  'auto.pages.pages.application.constants.39': 'Python应用',
  'auto.pages.pages.application.constants.40': 'Python后端应用开发',
  'auto.pages.pages.application.constants.41': 'C/C++应用',
  'auto.pages.pages.application.constants.42': 'C/C++应用开发',
  'auto.pages.pages.application.constants.43': '若依管理后台应用',
  'auto.pages.pages.application.constants.44': '基于 Spring Boot 多模块架构',
  'auto.pages.pages.application.constants.45': 'Electron应用',
  'auto.pages.pages.application.constants.46': '使用Electron开发的桌面应用程序',
  'auto.pages.pages.application.constants.47': '桌面应用',
  'auto.pages.pages.application.constants.48': '原生桌面应用程序',
  'auto.pages.pages.application.constants.49': 'RESTful API服务',
  'auto.pages.pages.application.constants.50': 'GraphQL API服务',
  'auto.pages.pages.application.constants.51': '微服务',
  'auto.pages.pages.application.constants.52': '微服务架构应用',
  'auto.pages.pages.application.constants.53': '前端',
  'auto.pages.pages.application.constants.54': '小程序',
  'auto.pages.pages.application.constants.55': '移动端',
  'auto.pages.pages.application.constants.56': '后端',
  'auto.pages.pages.application.constants.57': '桌面应用',
  'auto.pages.pages.application.constants.58': 'API服务',
  'auto.pages.pages.application.constants.59': '珊瑚礁',
  'auto.pages.pages.application.constants.60': '微服务',
  'auto.pages.pages.application.constants.61': '移动端微应用',
  'auto.pages.pages.application.constants.62': '用于珊瑚云平台的移动端微应用',
  'auto.pages.pages.application.constants.63': 'モバイルテンプレート',
  'auto.pages.pages.application.constants.64':
    'React Nativeベースのモバイルナビゲーションアプリテンプレート',
  'auto.pages.pages.application.constants.65': 'フロントエンドNPMパッケージ',
  'auto.pages.pages.application.constants.66':
    'フロントエンドコンポーネントを開発し、NPMパッケージを自动パブリッシュするためのStorybookアプリケーション',
  'auto.pages.pages.application.constants.67': 'プラグインアプリケーション',
  'auto.pages.pages.application.constants.68':
    '珊瑚礁プラットフォームのプラグイン拡張用アプリケーション',
  'auto.pages.pages.application.index.1': '加载应用列表失败',
  'auto.pages.pages.application.index.2': '暂无应用描述',
  'auto.pages.pages.application.index.3': '更新:',
  'auto.pages.pages.application.index.4': '开发应用',
  'auto.pages.pages.application.index.5': '预览应用',
  'auto.pages.pages.application.index.6': '编辑应用',
  'auto.pages.pages.application.index.7': '确定',
  'auto.pages.pages.application.index.8': '取消',
  'auto.pages.pages.application.index.9': '删除应用',
  'auto.pages.pages.application.index.10': '搜索应用名称/标识符',
  'auto.pages.pages.application.index.11': '共 {p1} 个应用',
  'auto.pages.pages.application.index.12': '暂无应用数据',
  'auto.pages.pages.architecture.api-management.index.1': '项目管理',
  'auto.pages.pages.architecture.api-management.index.2': '查询项目列表',
  'auto.pages.pages.architecture.api-management.index.3': '需求管理',
  'auto.pages.pages.architecture.api-management.index.4': '创建需求项',
  'auto.pages.pages.architecture.api-management.index.5': '公告管理',
  'auto.pages.pages.architecture.api-management.index.6': '发布项目公告',
  'auto.pages.pages.architecture.api-management.index.7': '模块',
  'auto.pages.pages.architecture.api-management.index.8': '接口名称',
  'auto.pages.pages.architecture.api-management.index.9': '状态',
  'auto.pages.pages.architecture.api-management.index.10': '设计中',
  'auto.pages.pages.architecture.api-management.index.11': '开发中',
  'auto.pages.pages.architecture.api-management.index.12': '已发布',
  'auto.pages.pages.architecture.api-management.index.13': '接口管理',
  'auto.pages.pages.architecture.api-management.index.14':
    '接口定义、状态跟踪与版本协同',
  'auto.pages.pages.architecture.code-management.index.1': '前端组',
  'auto.pages.pages.architecture.code-management.index.2': '后端组',
  'auto.pages.pages.architecture.code-management.index.3': '平台组',
  'auto.pages.pages.architecture.code-management.index.4': '代码仓库',
  'auto.pages.pages.architecture.code-management.index.5': '主分支',
  'auto.pages.pages.architecture.code-management.index.6': '责任团队',
  'auto.pages.pages.architecture.code-management.index.7': '最近更新',
  'auto.pages.pages.architecture.code-management.index.8': '代码管理',
  'auto.pages.pages.architecture.code-management.index.9':
    '代码仓库、分支策略与模块归属管理',
  'auto.pages.pages.architecture.detail.index.1': '获取项目列表',
  'auto.pages.pages.architecture.detail.index.2': '保存需求概要',
  'auto.pages.pages.architecture.detail.index.3': '同步沟通记录',
  'auto.pages.pages.architecture.detail.index.4': '接口',
  'auto.pages.pages.architecture.detail.index.5': '服务',
  'auto.pages.pages.architecture.detail.index.6': '详细设计',
  'auto.pages.pages.architecture.detail.index.7':
    '接口、数据结构与关键流程的可实施说明',
  'auto.pages.pages.architecture.detail.index.8': '核心设计参数',
  'auto.pages.pages.architecture.detail.index.9': '事件最终一致性',
  'auto.pages.pages.architecture.detail.index.10': 'Redis 10 分钟缓存',
  'auto.pages.pages.architecture.detail.index.11': '全链路操作审计',
  'auto.pages.pages.architecture.detail.index.12': '鉴权方案',
  'auto.pages.pages.architecture.detail.index.13': '一致性策略',
  'auto.pages.pages.architecture.detail.index.14': '缓存策略',
  'auto.pages.pages.architecture.detail.index.15': '审计方案',
  'auto.pages.pages.architecture.detail.index.16': '接口清单',
  'auto.pages.pages.architecture.overview.index.1': '概要设计',
  'auto.pages.pages.architecture.overview.index.2':
    '系统边界、核心模块与关键技术选型',
  'auto.pages.pages.architecture.overview.index.3':
    '本页为架构总览，重点聚焦模块边界和交互关系。',
  'auto.pages.pages.architecture.overview.index.4': '系统概要',
  'auto.pages.pages.architecture.overview.index.5':
    '项目管理平台 + 记录易 + 知识管理系统',
  'auto.pages.pages.architecture.overview.index.6':
    '外部平台限流与权限同步延迟',
  'auto.pages.pages.architecture.overview.index.7': '系统边界',
  'auto.pages.pages.architecture.overview.index.8': '技术栈',
  'auto.pages.pages.architecture.overview.index.9': '可用性目标',
  'auto.pages.pages.architecture.overview.index.10': '部署方式',
  'auto.pages.pages.architecture.overview.index.11': '集成方式',
  'auto.pages.pages.architecture.overview.index.12': '主要风险',
  'auto.pages.pages.architecture.overview.index.13': '模块划分',
  'auto.pages.pages.architecture.overview.index.14':
    '1. 项目域：项目列表、项目详情、项目统计。 2.\n          需求域：需求概要、功能清单、需求文档。 3.\n          交付域：原型、架构、测试、质量。 4. 资产域：知识库、素材库、文件管理。',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.1':
    '默认字幕',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.2':
    '此文件格式暂不支持直接预览。',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.3':
    '下载文件',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.4':
    '预览',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.5':
    '关闭',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.6':
    '下载',
  'auto.component.pages.asset-library.components.UploadMaterialModal.1':
    '请选择文件',
  'auto.component.pages.asset-library.components.UploadMaterialModal.2':
    '上传成功',
  'auto.component.pages.asset-library.components.UploadMaterialModal.3':
    '上传失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.4':
    '上传完成，但有 {p1} 个文件失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.5':
    '上传失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.6':
    '上传素材',
  'auto.component.pages.asset-library.components.UploadMaterialModal.7': '取消',
  'auto.component.pages.asset-library.components.UploadMaterialModal.8':
    '上传中',
  'auto.component.pages.asset-library.components.UploadMaterialModal.9':
    '开始上传',
  'auto.component.pages.asset-library.components.UploadMaterialModal.10':
    '上传目录',
  'auto.component.pages.asset-library.components.UploadMaterialModal.11':
    '选择上传目录',
  'auto.component.pages.asset-library.components.UploadMaterialModal.12':
    '存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.13':
    '请选择存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.14':
    '选择存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.15':
    '选择文件',
  'auto.component.pages.asset-library.components.UploadMaterialModal.16':
    '点击或拖拽文件到此区域上传',
  'auto.component.pages.asset-library.components.UploadMaterialModal.17':
    '支持批量上传',
  'auto.pages.pages.asset-library.index.1': '文件夹删除成功',
  'auto.pages.pages.asset-library.index.2': '删除失败',
  'auto.pages.pages.asset-library.index.3': '存储配置创建成功',
  'auto.pages.pages.asset-library.index.4': '创建存储配置失败',
  'auto.pages.pages.asset-library.index.5': '新增子集文件夹',
  'auto.pages.pages.asset-library.index.6': '编辑文件夹',
  'auto.pages.pages.asset-library.index.7': '确定要删除该文件夹吗？',
  'auto.pages.pages.asset-library.index.8': '删除文件夹',
  'auto.pages.pages.asset-library.index.9': '文件夹更新及排序成功',
  'auto.pages.pages.asset-library.index.10': '文件夹操作失败',
  'auto.pages.pages.asset-library.index.11': '文件夹更新成功',
  'auto.pages.pages.asset-library.index.12': '文件夹创建成功',
  'auto.pages.pages.asset-library.index.13': '操作失败',
  'auto.pages.pages.asset-library.index.14': '视频',
  'auto.pages.pages.asset-library.index.15': '文档',
  'auto.pages.pages.asset-library.index.16': '其他',
  'auto.pages.pages.asset-library.index.17': '预览',
  'auto.pages.pages.asset-library.index.18': '确认删除？',
  'auto.pages.pages.asset-library.index.19': '删除成功',
  'auto.pages.pages.asset-library.index.20': '删除',
  'auto.pages.pages.asset-library.index.21': '文件夹',
  'auto.pages.pages.asset-library.index.22': '取消选择',
  'auto.pages.pages.asset-library.index.23': '确认删除选中的 {p1} 个素材吗？',
  'auto.pages.pages.asset-library.index.24': '批量删除成功',
  'auto.pages.pages.asset-library.index.25': '批量删除失败',
  'auto.pages.pages.asset-library.index.26': '批量删除',
  'auto.pages.pages.asset-library.index.27': '编辑文件夹',
  'auto.pages.pages.asset-library.index.28': '新建文件夹',
  'auto.pages.pages.asset-library.index.29': '文件夹名称',
  'auto.pages.pages.asset-library.index.30': '请输入文件夹名称',
  'auto.pages.pages.asset-library.index.31': '请输入名称',
  'auto.pages.pages.asset-library.index.32': '上级文件夹',
  'auto.pages.pages.asset-library.index.33':
    '请选择上级文件夹（不选则为根目录）',
  'auto.pages.pages.asset-library.index.34': '排序',
  'auto.pages.pages.asset-library.index.35': '创建存储配置',
  'auto.pages.pages.asset-library.index.36': '配置名称',
  'auto.pages.pages.asset-library.index.37': '请输入配置名称',
  'auto.pages.pages.asset-library.index.38': '请输入配置名称',
  'auto.pages.pages.asset-library.index.39': '存储类型',
  'auto.pages.pages.asset-library.index.40': '请选择存储类型',
  'auto.pages.pages.asset-library.index.41': '请选择存储类型',
  'auto.pages.pages.asset-library.index.42': '端点地址',
  'auto.pages.pages.asset-library.index.43': '请输入端点地址',
  'auto.pages.pages.asset-library.index.44': '请输入端点地址',
  'auto.pages.pages.asset-library.index.45': '存储桶',
  'auto.pages.pages.asset-library.index.46': '请输入存储桶名称',
  'auto.pages.pages.asset-library.index.47': '请输入存储桶名称',
  'auto.pages.pages.asset-library.index.48': '区域',
  'auto.pages.pages.asset-library.index.49': '请输入区域（可选）',
  'auto.pages.pages.asset-library.index.50': '请输入 Access Key',
  'auto.pages.pages.asset-library.index.51': '请输入 Access Key',
  'auto.pages.pages.asset-library.index.52': '请输入 Secret Key',
  'auto.pages.pages.asset-library.index.53': '请输入 Secret Key',
  'auto.pages.pages.asset-library.index.54': '基础路径',
  'auto.pages.pages.asset-library.index.55': '请输入基础路径（可选）',
  'auto.pages.pages.asset-library.index.56': 'CDN 域名',
  'auto.pages.pages.asset-library.index.57': '请输入 CDN 域名（可选）',
  'auto.pages.pages.asset-library.index.58': '存储配额',
  'auto.pages.pages.asset-library.index.59': '请输入存储配额',
  'auto.pages.pages.asset-library.index.60': '单位',
  'auto.pages.pages.asset-library.index.61': '请选择单位',
  'auto.pages.pages.asset-library.index.62': '请选择单位',
  'auto.pages.pages.asset-library.index.63': '设为默认',
  'auto.pages.pages.asset-library.index.64': '管理员权限',
  'auto.pages.pages.asset-library.index.65': '只有管理员才能修改此配置',
  'auto.pages.pages.audit-log.index.1': '没有可导出的数据',
  'auto.pages.pages.audit-log.index.2': '导出成功',
  'auto.pages.pages.audit-log.index.3': '导出失败',
  'auto.pages.pages.audit-log.index.4': '导出为 XLSX',
  'auto.pages.pages.audit-log.index.5': '导出为 CSV',
  'auto.pages.pages.audit-log.index.6': '导出',
  'auto.pages.pages.code-management.dependency-analysis.index.1':
    '保持当前版本，定期关注安全公告',
  'auto.pages.pages.code-management.dependency-analysis.index.2':
    '建议升级至 4.17.21 以上以修复已知漏洞',
  'auto.pages.pages.code-management.dependency-analysis.index.3':
    '与团队规范版本统一，减少规则漂移',
  'auto.pages.pages.code-management.dependency-analysis.index.4': '依赖包',
  'auto.pages.pages.code-management.dependency-analysis.index.5': '版本',
  'auto.pages.pages.code-management.dependency-analysis.index.6': '类型',
  'auto.pages.pages.code-management.dependency-analysis.index.7': '生产依赖',
  'auto.pages.pages.code-management.dependency-analysis.index.8': '开发依赖',
  'auto.pages.pages.code-management.dependency-analysis.index.9': '风险等级',
  'auto.pages.pages.code-management.dependency-analysis.index.10': '高',
  'auto.pages.pages.code-management.dependency-analysis.index.11': '中',
  'auto.pages.pages.code-management.dependency-analysis.index.12': '低',
  'auto.pages.pages.code-management.dependency-analysis.index.13': '处理建议',
  'auto.pages.pages.code-management.dependency-analysis.index.14': '依赖分析',
  'auto.pages.pages.code-management.dependency-analysis.index.15':
    '分析项目依赖关系、风险等级与升级建议',
  'auto.pages.pages.communication-records.index.1': '会议',
  'auto.pages.pages.communication-records.index.2': '电话',
  'auto.pages.pages.communication-records.index.3': '邮件',
  'auto.pages.pages.communication-records.index.4': '微信',
  'auto.pages.pages.communication-records.index.5': '其他',
  'auto.pages.pages.communication-records.index.6': '待处理',
  'auto.pages.pages.communication-records.index.7': '进行中',
  'auto.pages.pages.communication-records.index.8': '已交付',
  'auto.pages.pages.communication-records.index.9': '已归档',
  'auto.pages.pages.communication-records.index.10': '待处理',
  'auto.pages.pages.communication-records.index.11': '进行中',
  'auto.pages.pages.communication-records.index.12': '已交付',
  'auto.pages.pages.communication-records.index.13': '已归档',
  'auto.pages.pages.communication-records.index.14': '会议',
  'auto.pages.pages.communication-records.index.15': '电话',
  'auto.pages.pages.communication-records.index.16': '邮件',
  'auto.pages.pages.communication-records.index.17': '微信',
  'auto.pages.pages.communication-records.index.18': '其他',
  'auto.pages.pages.communication-records.index.19': '待处理',
  'auto.pages.pages.communication-records.index.20': '进行中',
  'auto.pages.pages.communication-records.index.21': '已交付',
  'auto.pages.pages.communication-records.index.22': '已归档',
  'auto.pages.pages.communication-records.index.23': '会议',
  'auto.pages.pages.communication-records.index.24': '电话',
  'auto.pages.pages.communication-records.index.25': '邮件',
  'auto.pages.pages.communication-records.index.26': '微信',
  'auto.pages.pages.communication-records.index.27': '其他',
  'auto.pages.pages.communication-records.index.28': '待处理',
  'auto.pages.pages.communication-records.index.29': '进行中',
  'auto.pages.pages.communication-records.index.30': '已交付',
  'auto.pages.pages.communication-records.index.31': '已归档',
  'auto.pages.pages.daily-report-management.index.1': '张三',
  'auto.pages.pages.daily-report-management.index.2':
    '完成登录模块 SSO 对接并联调通过',
  'auto.pages.pages.daily-report-management.index.3': '待确认单点退出策略',
  'auto.pages.pages.daily-report-management.index.4': '李四',
  'auto.pages.pages.daily-report-management.index.5':
    '完成需求文档结构优化并同步评审意见',
  'auto.pages.pages.daily-report-management.index.6': '第三方接口返回字段变化',
  'auto.pages.pages.daily-report-management.index.7': '王五',
  'auto.pages.pages.daily-report-management.index.8':
    '推进核心流程自动化测试脚本编写',
  'auto.pages.pages.daily-report-management.index.9':
    '测试环境数据库数据不稳定',
  'auto.pages.pages.daily-report-management.index.10': '日期',
  'auto.pages.pages.daily-report-management.index.11': '汇报人',
  'auto.pages.pages.daily-report-management.index.12': '今日进展',
  'auto.pages.pages.daily-report-management.index.13': '风险/阻塞',
  'auto.pages.pages.daily-report-management.index.14': '状态',
  'auto.pages.pages.daily-report-management.index.15': '草稿',
  'auto.pages.pages.daily-report-management.index.16': '已提交',
  'auto.pages.pages.daily-report-management.index.17': '已审阅',
  'auto.pages.pages.daily-report-management.index.18': '日报管理',
  'auto.pages.pages.daily-report-management.index.19':
    '团队日报沉淀、风险同步与进展追踪',
  'auto.pages.pages.data-modeling.entity-management.index.1': '未命名项目',
  'auto.pages.pages.data-modeling.entity-management.index.2':
    '加载实体管理失败',
  'auto.pages.pages.data-modeling.entity-management.index.3':
    '当前未识别到项目，请先切换项目',
  'auto.pages.pages.data-modeling.entity-management.index.4': '保存成功',
  'auto.pages.pages.data-modeling.entity-management.index.5': '保存失败',
  'auto.pages.pages.data-modeling.entity-management.index.6':
    '当前未识别到项目，请先切换项目',
  'auto.pages.pages.data-modeling.entity-management.index.7': '已清空实体',
  'auto.pages.pages.data-modeling.entity-management.index.8': '清空失败',
  'auto.pages.pages.data-modeling.entity-management.index.9':
    '实体定义JSON中缺少 name（实体名称），无法保存',
  'auto.pages.pages.data-modeling.entity-management.index.10': '未填写',
  'auto.pages.pages.data-modeling.entity-management.index.11': '实体名称',
  'auto.pages.pages.data-modeling.entity-management.index.12': '未填写',
  'auto.pages.pages.data-modeling.entity-management.index.13': '实体标识符',
  'auto.pages.pages.data-modeling.entity-management.index.14': '应用UUID',
  'auto.pages.pages.data-modeling.entity-management.index.15': '实体UUID',
  'auto.pages.pages.data-modeling.entity-management.index.16': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.17': '操作',
  'auto.pages.pages.data-modeling.entity-management.index.18': '编辑',
  'auto.pages.pages.data-modeling.entity-management.index.19': '删除',
  'auto.pages.pages.data-modeling.entity-management.index.20': '实体管理',
  'auto.pages.pages.data-modeling.entity-management.index.21':
    '管理项目“{p1}”的实体定义',
  'auto.pages.pages.data-modeling.entity-management.index.22': '新增实体',
  'auto.pages.pages.data-modeling.entity-management.index.23': '保存',
  'auto.pages.pages.data-modeling.entity-management.index.24':
    '确认清空当前项目实体数据？',
  'auto.pages.pages.data-modeling.entity-management.index.25': '清空重置',
  'auto.pages.pages.data-modeling.entity-management.index.26': '删除选中（',
  'auto.pages.pages.data-modeling.entity-management.index.27':
    '暂无实体，点击“新增实体”开始',
  'auto.pages.pages.data-modeling.entity-management.index.28': '编辑实体',
  'auto.pages.pages.data-modeling.entity-management.index.29': '新增实体',
  'auto.pages.pages.data-modeling.entity-management.index.30': '确定',
  'auto.pages.pages.data-modeling.entity-management.index.31': '取消',
  'auto.pages.pages.data-modeling.entity-management.index.32':
    '应用UUID（可选）',
  'auto.pages.pages.data-modeling.entity-management.index.33': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.34':
    '请输入实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.35':
    'JSON 格式不合法',
  'auto.pages.pages.data-modeling.entity-management.index.36':
    '粘贴实体定义 JSON',
  'auto.pages.pages.data-modeling.entity-management.index.37':
    '提示：实体UUID、名称、标识符会在保存时从 JSON 自动解析。',
  'auto.pages.pages.data-modeling.entity-management.index.38': '失效 {p1}',
  'auto.pages.pages.data-modeling.entity-management.index.39': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.40': '关系定义',
  'auto.pages.pages.data-modeling.entity-management.index.41': '选择目标实体',
  'auto.pages.pages.data-modeling.entity-management.index.42': '关系名称',
  'auto.pages.pages.data-modeling.entity-management.index.43':
    '关系说明（可选）',
  'auto.pages.pages.data-modeling.entity-management.index.44': '新增关系',
  'auto.pages.pages.data-modeling.entity-management.index.45': '关系数',
  'auto.pages.pages.data-modeling.index.1': '未命名项目',
  'auto.pages.pages.data-modeling.index.2': '加载数据建模失败',
  'auto.pages.pages.data-modeling.index.3':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.4': '项目信息已保存',
  'auto.pages.pages.data-modeling.index.5': '保存项目信息失败',
  'auto.pages.pages.data-modeling.index.6':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.7':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.data-modeling.index.8': 'AI 生成失败',
  'auto.pages.pages.data-modeling.index.9':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.10': '请先勾选预览实体',
  'auto.pages.pages.data-modeling.index.11': '已添加并保存 {p1} 个实体',
  'auto.pages.pages.data-modeling.index.12': '添加失败',
  'auto.pages.pages.data-modeling.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.14': '保存成功',
  'auto.pages.pages.data-modeling.index.15': '保存失败',
  'auto.pages.pages.data-modeling.index.16':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.17': '已清空数据建模实体',
  'auto.pages.pages.data-modeling.index.18': '清空失败',
  'auto.pages.pages.data-modeling.index.19':
    '实体定义JSON中缺少 name（实体名称），无法保存',
  'auto.pages.pages.data-modeling.index.20': '未填写',
  'auto.pages.pages.data-modeling.index.21': '实体名称',
  'auto.pages.pages.data-modeling.index.22': '未填写',
  'auto.pages.pages.data-modeling.index.23': '实体标识符',
  'auto.pages.pages.data-modeling.index.24': '应用UUID',
  'auto.pages.pages.data-modeling.index.25': '实体UUID',
  'auto.pages.pages.data-modeling.index.26': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.27': '操作',
  'auto.pages.pages.data-modeling.index.28': '编辑',
  'auto.pages.pages.data-modeling.index.29': '删除',
  'auto.pages.pages.data-modeling.index.30': '实体名称',
  'auto.pages.pages.data-modeling.index.31': '未填写',
  'auto.pages.pages.data-modeling.index.32': '实体标识符',
  'auto.pages.pages.data-modeling.index.33': '应用UUID',
  'auto.pages.pages.data-modeling.index.34': '实体UUID',
  'auto.pages.pages.data-modeling.index.35': '实体管理',
  'auto.pages.pages.data-modeling.index.36': 'AI辅助建模',
  'auto.pages.pages.data-modeling.index.37': '管理项目“{p1}”下的实体定义(JSON)',
  'auto.pages.pages.data-modeling.index.38':
    '基于项目“{p1}”进行实体拆解与字段AI辅助建模',
  'auto.pages.pages.data-modeling.index.39': 'AIAI辅助建模',
  'auto.pages.pages.data-modeling.index.40': '新增实体',
  'auto.pages.pages.data-modeling.index.41': '保存',
  'auto.pages.pages.data-modeling.index.42': '确认清空当前项目实体数据？',
  'auto.pages.pages.data-modeling.index.43': '清空重置',
  'auto.pages.pages.data-modeling.index.44': '删除选中（',
  'auto.pages.pages.data-modeling.index.45':
    '暂无实体，点击“AIAI辅助建模”或“新增实体”开始',
  'auto.pages.pages.data-modeling.index.46': '暂无实体，点击“新增实体”开始',
  'auto.pages.pages.data-modeling.index.47': '编辑实体',
  'auto.pages.pages.data-modeling.index.48': '新增实体',
  'auto.pages.pages.data-modeling.index.49': '确定',
  'auto.pages.pages.data-modeling.index.50': '取消',
  'auto.pages.pages.data-modeling.index.51': '应用UUID（可选）',
  'auto.pages.pages.data-modeling.index.52': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.53': '请输入实体定义JSON',
  'auto.pages.pages.data-modeling.index.54': 'JSON 格式不合法',
  'auto.pages.pages.data-modeling.index.55': '粘贴实体定义 JSON',
  'auto.pages.pages.data-modeling.index.56':
    '提示：实体UUID、名称、标识符会在保存时从 JSON 自动解析。',
  'auto.pages.pages.data-modeling.index.57': 'AI AI辅助建模',
  'auto.pages.pages.data-modeling.index.58': '生成选项',
  'auto.pages.pages.data-modeling.index.59': '项目名称',
  'auto.pages.pages.data-modeling.index.60': '请输入项目名称',
  'auto.pages.pages.data-modeling.index.61': '请输入项目名称',
  'auto.pages.pages.data-modeling.index.62': '项目简介',
  'auto.pages.pages.data-modeling.index.63': '请输入项目简介',
  'auto.pages.pages.data-modeling.index.64': '提示信息（用于辅助生成）',
  'auto.pages.pages.data-modeling.index.65':
    '例如：重点分析主数据、交易数据、审计日志等实体',
  'auto.pages.pages.data-modeling.index.66': '拆解实体数量',
  'auto.pages.pages.data-modeling.index.67': '请输入拆解数量',
  'auto.pages.pages.data-modeling.index.68': '数量范围为 1-40',
  'auto.pages.pages.data-modeling.index.69':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.data-modeling.index.70': '保存项目信息',
  'auto.pages.pages.data-modeling.index.71': '取消',
  'auto.pages.pages.data-modeling.index.72': '生成预览',
  'auto.pages.pages.data-modeling.index.73': '预览结果',
  'auto.pages.pages.data-modeling.index.74': '勾选需要的实体后添加到列表',
  'auto.pages.pages.data-modeling.index.75': '点击“生成预览”后查看候选实体',
  'auto.pages.pages.data-modeling.index.76': '重名时覆盖已有实体',
  'auto.pages.pages.data-modeling.index.77': '添加选中到实体列表（',
  'auto.pages.pages.data-modeling.index.78': '失效 {p1}',
  'auto.pages.pages.data-modeling.index.79': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.80': '关系定义',
  'auto.pages.pages.data-modeling.index.81': '选择目标实体',
  'auto.pages.pages.data-modeling.index.82': '关系名称',
  'auto.pages.pages.data-modeling.index.83': '关系说明（可选）',
  'auto.pages.pages.data-modeling.index.84': '新增关系',
  'auto.pages.pages.data-modeling.index.85': '关系数',
  'auto.pages.pages.data-modeling.index.86': '实体总数',
  'auto.pages.pages.data-modeling.index.87': '关系总数',
  'auto.pages.pages.data-modeling.index.88': '字段总数',
  'auto.pages.pages.data-modeling.index.89': '失效关系数',
  'auto.pages.pages.data-modeling.index.90': '最近更新时间',
  'auto.pages.pages.data-modeling.index.91': 'AI辅助区',
  'auto.pages.pages.data-modeling.index.92':
    '通过AI拆解实体、分析字段并应用到下方实体列表。',
  'auto.pages.pages.data-modeling.modeling-assistant.index.1':
    '建议字段包括：{p1}。',
  'auto.pages.pages.data-modeling.modeling-assistant.index.2': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.3': '未识别项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.4':
    '加载建模辅助失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.5':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.6': '项目信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.7':
    '保存项目信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.8': '项目信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.9':
    '保存项目信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.10':
    '实体信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.11':
    '实体信息已保存到预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.12':
    '保存实体信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.14':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.data-modeling.modeling-assistant.index.15': 'AI 生成失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.16':
    '字段描述预览已生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.17':
    '生成字段描述失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.18':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.19':
    '请先生成字段描述预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.20':
    '缺少实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.21':
    '字段已保存：新增 {p1}，覆盖 {p2}，跳过 {p3}',
  'auto.pages.pages.data-modeling.modeling-assistant.index.22': '保存字段失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.23':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.24': '字段详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.25':
    '加载字段详情失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.26':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.27': '缺少实体名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.28':
    '请至少保留一个字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.29':
    '字段修改已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.30': '保存字段失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.31':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.32':
    '请先勾选预览实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.33':
    '已添加并保存 {p1} 个实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.34': '添加失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.35':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.36': '保存成功',
  'auto.pages.pages.data-modeling.modeling-assistant.index.37': '保存失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.38':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.39':
    '已清空建模辅助列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.40': '清空失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.41': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.42': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.43': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.44': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.45': '主要字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.46': '未生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.47': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.48': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.49': '查看字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.50': '编辑',
  'auto.pages.pages.data-modeling.modeling-assistant.index.51': '删除',
  'auto.pages.pages.data-modeling.modeling-assistant.index.52': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.53': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.54': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.55': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.56': '主要字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.57': '未生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.58': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.59': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.60': '建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.61':
    '基于项目名称、简介和功能清单，发现业务实体并逐个分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.62': 'AI建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.63': '新增实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.64': '保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.65':
    '确认清空当前建模辅助列表？',
  'auto.pages.pages.data-modeling.modeling-assistant.index.66': '清空重置',
  'auto.pages.pages.data-modeling.modeling-assistant.index.67': '删除选中（',
  'auto.pages.pages.data-modeling.modeling-assistant.index.68':
    '暂无建模实体，点击“AI建模辅助”或“新增实体”开始',
  'auto.pages.pages.data-modeling.modeling-assistant.index.69': '编辑实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.70': '新增实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.71': '确定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.72': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.73': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.74':
    '请输入实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.75': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.76': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.77': '主要字段描述',
  'auto.pages.pages.data-modeling.modeling-assistant.index.78':
    '例如：建议包含客户编号、状态、创建时间等字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.79': 'AI 建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.80': '生成选项',
  'auto.pages.pages.data-modeling.modeling-assistant.index.81': '项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.82':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.83':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.84': '项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.85':
    '请输入项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.86':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.87':
    '例如：重点补充主数据、交易实体、结算实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.88': '拆解实体数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.89':
    '请输入拆解数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.90':
    '数量范围为 1-40',
  'auto.pages.pages.data-modeling.modeling-assistant.index.91':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.92': '保存项目信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.93': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.94': '生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.95': '预览结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.96':
    '勾选需要的实体后添加到列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.97':
    '点击“生成预览”后查看候选实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.98':
    '重名时覆盖已有实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.99':
    '添加选中到实体列表（',
  'auto.pages.pages.data-modeling.modeling-assistant.index.100': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.101': '分析选项',
  'auto.pages.pages.data-modeling.modeling-assistant.index.102': '项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.103':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.104': '项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.105': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.106':
    '请输入实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.107': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.108': '实体简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.109': '主要字段描述',
  'auto.pages.pages.data-modeling.modeling-assistant.index.110':
    '提示信息（用于辅助分析）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.111':
    '例如：强调索引建议、状态流转字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.112': '数据库类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.113': '保存项目信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.114': '保存实体信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.115': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.116': '生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.117': '预览结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.118':
    '确认后存入独立字段分析表（不回写实体详细字段）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.119': '字段中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.120': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.121': '字段英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.122': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.123': 'MySQL类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.124': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.125': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.126': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.127': '必填',
  'auto.pages.pages.data-modeling.modeling-assistant.index.128': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.129': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.130': '未定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.131': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.132': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.133': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.134': '未定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.135':
    '点击“生成预览”后查看字段建议',
  'auto.pages.pages.data-modeling.modeling-assistant.index.136': '覆盖',
  'auto.pages.pages.data-modeling.modeling-assistant.index.137': '追加',
  'auto.pages.pages.data-modeling.modeling-assistant.index.138':
    '追加时覆盖已有重名字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.139': '保存到字段库',
  'auto.pages.pages.data-modeling.modeling-assistant.index.140':
    '{p1} - 字段详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.141': '新增字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.142': '保存字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.143':
    '字段加载中...',
  'auto.pages.pages.data-modeling.modeling-assistant.index.144':
    '暂无字段，请点击“新增字段”或先执行AI分析',
  'auto.pages.pages.data-modeling.modeling-assistant.index.145': '字段中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.146': '如：客户编号',
  'auto.pages.pages.data-modeling.modeling-assistant.index.147': '字段英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.148':
    '如：customerCode',
  'auto.pages.pages.data-modeling.modeling-assistant.index.149': 'MySQL类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.150':
    '如：varchar(255)',
  'auto.pages.pages.data-modeling.modeling-assistant.index.151': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.152': '字段说明',
  'auto.pages.pages.data-modeling.modeling-assistant.index.153': '必填',
  'auto.pages.pages.data-modeling.modeling-assistant.index.154': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.155': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.156': '下方插入',
  'auto.pages.pages.data-modeling.modeling-assistant.index.157': '删除',
  'auto.pages.pages.data-modeling.modeling-assistant.index.158':
    '请先输入至少一个实体名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.159':
    '人工录入完成，已生成 {p1} 个实体预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.160': '拆解模式',
  'auto.pages.pages.data-modeling.modeling-assistant.index.161': 'A、尽可能多',
  'auto.pages.pages.data-modeling.modeling-assistant.index.162': 'B、指定数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.163': 'C、人工录入',
  'auto.pages.pages.data-modeling.modeling-assistant.index.164': '人工录入实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.165':
    '每行输入一个实体名，提交后直接生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.166':
    '请输入人工录入内容',
  'auto.pages.pages.data-modeling.modeling-assistant.index.167':
    '例如：客户\n订单\n支付记录',
  'auto.pages.pages.data-modeling.modeling-assistant.index.168':
    '请先勾选至少一个实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.169':
    '批量拆解完成：成功 {p1} 个，失败 {p2} 个',
  'auto.pages.pages.data-modeling.modeling-assistant.index.170':
    '暂无可保存的批量字段结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.171':
    '批量保存完成：成功实体 {p1}，失败实体 {p2}，新增 {p3}，覆盖 {p4}，跳过 {p5}',
  'auto.pages.pages.data-modeling.modeling-assistant.index.172': '批量字段拆解',
  'auto.pages.pages.data-modeling.modeling-assistant.index.173':
    '批量字段拆解（{p1} 个实体）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.174': '本次批量实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.175':
    '已选择 {p1} 个实体进行字段拆解',
  'auto.pages.pages.data-modeling.modeling-assistant.index.176': '字段拆解模式',
  'auto.pages.pages.data-modeling.modeling-assistant.index.177': '字段数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.178':
    '请输入字段数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.179': '人工录入字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.180':
    '每行输入一个字段名，保存前可在字段详情继续编辑',
  'auto.pages.pages.data-modeling.modeling-assistant.index.181':
    '请输入人工录入字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.182':
    '例如：客户编号\n客户名称\n客户状态',
  'auto.pages.pages.data-modeling.modeling-assistant.index.183':
    '成功，字段数 {p1}',
  'auto.pages.pages.data-modeling.modeling-assistant.index.184': '字段拆解失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.185':
    '点击“生成预览”后查看批量字段结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.200':
    '统一管理项目“{p1}”下的实体、字段与关系',
  'auto.pages.pages.data-modeling.modeling-assistant.index.201': '实体列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.202': '实体详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.203':
    '请先在左侧选择一个实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.204': '字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.205': '新增字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.206': '刷新字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.207': '保存字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.208': '字段名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.209': '字段类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.210': '非空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.211': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.212': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.213': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.214': '字段说明',
  'auto.pages.pages.data-modeling.modeling-assistant.index.215': '关系',
  'auto.pages.pages.data-modeling.modeling-assistant.index.216': '新增关系',
  'auto.pages.pages.data-modeling.modeling-assistant.index.217':
    '暂无关系，点击“新增关系”开始',
  'auto.pages.pages.data-modeling.modeling-assistant.index.218': '关系数',
  'auto.pages.pages.data-modeling.modeling-assistant.index.219': '関連',
  'auto.pages.pages.data-modeling.modeling-assistant.index.220': '意味関連',
  'auto.pages.pages.data-modeling.modeling-assistant.index.221': '外キー意味',
  'auto.pages.pages.data-modeling.modeling-assistant.index.222': '通常項目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.223':
    '関連先エンティティ（任意）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.224':
    'オフ: 意味関連のみ。オン: 外キー意味フィールドを許可（実DB外キー制約は作成しない）。',
  'auto.pages.pages.data-modeling.modeling-assistant.index.225':
    '外キー項目を生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.230':
    'ルールを適用する',
  'auto.pages.pages.data-modeling.modeling-assistant.index.231':
    '関係候補はありません',
  'auto.pages.pages.data-modeling.modeling-assistant.index.232': '関係タイプ',
  'auto.pages.pages.data-modeling.modeling-assistant.index.233':
    '対象エンティティ',
  'auto.pages.pages.data-modeling.modeling-assistant.index.234': '関係名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.235':
    '項目は保存済みですが、関係保存に失敗しました',
  'auto.pages.pages.data-modeling.modeling-assistant.index.236':
    '関係保存: 追加 {p1}、スキップ {p2}、無効 {p3}',
  'auto.pages.pages.external-redirect.index.1': '正在跳转...',
  'auto.pages.pages.knowledge-base.index.1': '项目需求分析模板',
  'auto.pages.pages.knowledge-base.index.2': '架构评审规范',
  'auto.pages.pages.knowledge-base.index.3': '架构组',
  'auto.pages.pages.knowledge-base.index.4': '上线回滚预案',
  'auto.pages.pages.knowledge-base.index.5': '文档标题',
  'auto.pages.pages.knowledge-base.index.6': '分类',
  'auto.pages.pages.knowledge-base.index.7': '模板',
  'auto.pages.pages.knowledge-base.index.8': '规范',
  'auto.pages.pages.knowledge-base.index.9': '运行手册',
  'auto.pages.pages.knowledge-base.index.10': '维护人',
  'auto.pages.pages.knowledge-base.index.11': '版本',
  'auto.pages.pages.knowledge-base.index.12': '更新时间',
  'auto.pages.pages.knowledge-base.index.13': '操作',
  'auto.pages.pages.knowledge-base.index.14': '查看',
  'auto.pages.pages.knowledge-base.index.15': '编辑',
  'auto.pages.pages.knowledge-base.index.16': '知识库',
  'auto.pages.pages.knowledge-base.index.17':
    '对接企业知识管理系统（文件管理）',
  'auto.pages.pages.knowledge-base.index.18': '上传文档',
  'auto.pages.pages.knowledge-base.index.19': '新建知识',
  'auto.pages.pages.knowledge-base.reference-materials.index.1':
    '参考链接已添加',
  'auto.pages.pages.knowledge-base.reference-materials.index.2':
    '参考文字已记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.3': '参考资料',
  'auto.pages.pages.knowledge-base.reference-materials.index.4':
    '沉淀参考链接、文件/图片与文字记录（后续可对接记录易）',
  'auto.pages.pages.knowledge-base.reference-materials.index.5': '参考链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.6':
    '请输入链接标题',
  'auto.pages.pages.knowledge-base.reference-materials.index.7': '标题',
  'auto.pages.pages.knowledge-base.reference-materials.index.8':
    '请输入链接地址',
  'auto.pages.pages.knowledge-base.reference-materials.index.9':
    '请输入有效 URL（含 http/https）',
  'auto.pages.pages.knowledge-base.reference-materials.index.10': '添加链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.11':
    '暂无参考链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.12': '链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.13':
    '参考文件/图片',
  'auto.pages.pages.knowledge-base.reference-materials.index.14':
    '选择文件或图片',
  'auto.pages.pages.knowledge-base.reference-materials.index.15':
    '暂无已选择文件',
  'auto.pages.pages.knowledge-base.reference-materials.index.16': '文件',
  'auto.pages.pages.knowledge-base.reference-materials.index.17': '文字记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.18': '参考说明',
  'auto.pages.pages.knowledge-base.reference-materials.index.19': '请输入内容',
  'auto.pages.pages.knowledge-base.reference-materials.index.20':
    '记录参考点、竞品优缺点、适配建议等',
  'auto.pages.pages.knowledge-base.reference-materials.index.21': '保存记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.22':
    '暂无文字记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.23': '文字',
  'auto.pages.pages.knowledge-base.reference-products.index.1': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.2': '竞品',
  'auto.pages.pages.knowledge-base.reference-products.index.3': '可替代方案',
  'auto.pages.pages.knowledge-base.reference-products.index.4': '国内',
  'auto.pages.pages.knowledge-base.reference-products.index.5': '国外',
  'auto.pages.pages.knowledge-base.reference-products.index.6': '高',
  'auto.pages.pages.knowledge-base.reference-products.index.7': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.8': '低',
  'auto.pages.pages.knowledge-base.reference-products.index.9': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.10': '竞品',
  'auto.pages.pages.knowledge-base.reference-products.index.11': '可替代方案',
  'auto.pages.pages.knowledge-base.reference-products.index.12': '国内',
  'auto.pages.pages.knowledge-base.reference-products.index.13': '国外',
  'auto.pages.pages.knowledge-base.reference-products.index.14': '高',
  'auto.pages.pages.knowledge-base.reference-products.index.15': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.16': '低',
  'auto.pages.pages.knowledge-base.reference-products.index.17': '未命名项目',
  'auto.pages.pages.knowledge-base.reference-products.index.18':
    '加载参考产品失败',
  'auto.pages.pages.knowledge-base.reference-products.index.19':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.20':
    '项目信息已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.21':
    '保存项目信息失败',
  'auto.pages.pages.knowledge-base.reference-products.index.22':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.23':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.knowledge-base.reference-products.index.24': 'AI 生成失败',
  'auto.pages.pages.knowledge-base.reference-products.index.25':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.26':
    '请先勾选预览产品',
  'auto.pages.pages.knowledge-base.reference-products.index.27':
    '已添加并保存 {p1} 个参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.28': '添加失败',
  'auto.pages.pages.knowledge-base.reference-products.index.29':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.30': '保存成功',
  'auto.pages.pages.knowledge-base.reference-products.index.31': '保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.32':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.33':
    '已清空参考产品数据',
  'auto.pages.pages.knowledge-base.reference-products.index.34': '清空失败',
  'auto.pages.pages.knowledge-base.reference-products.index.35':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.36': '修改已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.37': '新增已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.38': '修改保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.39': '新增保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.40': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.41': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.42': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.43': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.44': '类型',
  'auto.pages.pages.knowledge-base.reference-products.index.45': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.46': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.47': '未区分',
  'auto.pages.pages.knowledge-base.reference-products.index.48': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.49': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.50': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.51': '官网',
  'auto.pages.pages.knowledge-base.reference-products.index.52': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.53': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.54': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.55': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.56': '收费模式',
  'auto.pages.pages.knowledge-base.reference-products.index.57': '备注',
  'auto.pages.pages.knowledge-base.reference-products.index.58': '操作',
  'auto.pages.pages.knowledge-base.reference-products.index.59': '编辑',
  'auto.pages.pages.knowledge-base.reference-products.index.60': '删除',
  'auto.pages.pages.knowledge-base.reference-products.index.61': '列显示',
  'auto.pages.pages.knowledge-base.reference-products.index.62': '重置',
  'auto.pages.pages.knowledge-base.reference-products.index.63': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.64': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.65': '类型',
  'auto.pages.pages.knowledge-base.reference-products.index.66': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.67': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.68': '未区分',
  'auto.pages.pages.knowledge-base.reference-products.index.69': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.70': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.71': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.72': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.73': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.74': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.75': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.76':
    '基于项目“{p1}”沉淀可借鉴产品与竞品分析',
  'auto.pages.pages.knowledge-base.reference-products.index.77': '搜索产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.78': 'AI分析',
  'auto.pages.pages.knowledge-base.reference-products.index.79': '新增',
  'auto.pages.pages.knowledge-base.reference-products.index.80': '保存',
  'auto.pages.pages.knowledge-base.reference-products.index.81':
    '确认清空当前项目参考产品数据？',
  'auto.pages.pages.knowledge-base.reference-products.index.82': '清空',
  'auto.pages.pages.knowledge-base.reference-products.index.83': '删除（',
  'auto.pages.pages.knowledge-base.reference-products.index.84': '刷新',
  'auto.pages.pages.knowledge-base.reference-products.index.85': '紧凑',
  'auto.pages.pages.knowledge-base.reference-products.index.86': '默认',
  'auto.pages.pages.knowledge-base.reference-products.index.87': '宽松',
  'auto.pages.pages.knowledge-base.reference-products.index.88': '调节蜜度',
  'auto.pages.pages.knowledge-base.reference-products.index.89': '列设置',
  'auto.pages.pages.knowledge-base.reference-products.index.90':
    '暂无参考产品数据，点击“AI参考产品分析”或“新增产品”开始',
  'auto.pages.pages.knowledge-base.reference-products.index.91': '共 {p1} 条',
  'auto.pages.pages.knowledge-base.reference-products.index.92': '编辑参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.93': '新增参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.94': '确定',
  'auto.pages.pages.knowledge-base.reference-products.index.95': '取消',
  'auto.pages.pages.knowledge-base.reference-products.index.96': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.97':
    '请输入产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.98':
    '例如：Jira Software',
  'auto.pages.pages.knowledge-base.reference-products.index.99': '产品类型',
  'auto.pages.pages.knowledge-base.reference-products.index.100':
    '请选择产品类型',
  'auto.pages.pages.knowledge-base.reference-products.index.101': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.102': '请选择区域',
  'auto.pages.pages.knowledge-base.reference-products.index.103': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.104':
    '请选择相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.105': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.106':
    '请选择关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.107': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.108':
    '例如：Atlassian',
  'auto.pages.pages.knowledge-base.reference-products.index.109': '官网链接',
  'auto.pages.pages.knowledge-base.reference-products.index.110': '产品定位',
  'auto.pages.pages.knowledge-base.reference-products.index.111': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.112': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.113': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.114': '收费模式',
  'auto.pages.pages.knowledge-base.reference-products.index.115':
    '例如：按用户订阅',
  'auto.pages.pages.knowledge-base.reference-products.index.116': '备注',
  'auto.pages.pages.knowledge-base.reference-products.index.117':
    'AI 参考产品分析',
  'auto.pages.pages.knowledge-base.reference-products.index.118': '生成选项',
  'auto.pages.pages.knowledge-base.reference-products.index.119': '项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.120':
    '请输入项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.121':
    '请输入项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.122': '项目简介',
  'auto.pages.pages.knowledge-base.reference-products.index.123':
    '请输入项目简介',
  'auto.pages.pages.knowledge-base.reference-products.index.124':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.knowledge-base.reference-products.index.125':
    '例如：重点覆盖国内可落地产品，并说明可借鉴能力',
  'auto.pages.pages.knowledge-base.reference-products.index.126':
    '推荐产品数量',
  'auto.pages.pages.knowledge-base.reference-products.index.127': '请输入数量',
  'auto.pages.pages.knowledge-base.reference-products.index.128':
    '数量范围为 1-20',
  'auto.pages.pages.knowledge-base.reference-products.index.129':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.knowledge-base.reference-products.index.130':
    '保存项目信息',
  'auto.pages.pages.knowledge-base.reference-products.index.131': '取消',
  'auto.pages.pages.knowledge-base.reference-products.index.132': '生成预览',
  'auto.pages.pages.knowledge-base.reference-products.index.133': '预览结果',
  'auto.pages.pages.knowledge-base.reference-products.index.134':
    '勾选需要的产品后添加到列表',
  'auto.pages.pages.knowledge-base.reference-products.index.135':
    '点击“生成预览”后查看候选产品',
  'auto.pages.pages.knowledge-base.reference-products.index.136':
    '重名时覆盖已有产品',
  'auto.pages.pages.knowledge-base.reference-products.index.137':
    '添加选中到产品列表（',
  'auto.pages.pages.project.layout.1': '未命名页面',
  'auto.pages.pages.project-home.index.1': '项目主页',
  'auto.pages.pages.project-home.index.2': '项目全局概览与最近动态',
  'auto.pages.pages.project-home.index.3': '应用数',
  'auto.pages.pages.project-home.index.4': '个',
  'auto.pages.pages.project-home.index.5': '代码总行数',
  'auto.pages.pages.project-home.index.6': '行',
  'auto.pages.pages.project-home.index.7': '生成代码总行数',
  'auto.pages.pages.project-home.index.8': '行',
  'auto.pages.pages.project-home.index.9': '代码行数较昨日新增',
  'auto.pages.pages.project-home.index.10': '行',
  'auto.pages.pages.project-home.index.11': '一级功能模块数',
  'auto.pages.pages.project-home.index.12': '个',
  'auto.pages.pages.project-home.index.13': '功能数',
  'auto.pages.pages.project-home.index.14': '个',
  'auto.pages.pages.project-home.index.15': '功能点数',
  'auto.pages.pages.project-home.index.16': '个',
  'auto.pages.pages.project-home.index.17': '角色数',
  'auto.pages.pages.project-home.index.18': '个',
  'auto.pages.pages.project-home.index.19': '概念数',
  'auto.pages.pages.project-home.index.20': '个',
  'auto.pages.pages.project-home.index.21': '项目概况',
  'auto.pages.pages.project-home.index.22': '项目名称',
  'auto.pages.pages.project-home.index.23': '英文名称',
  'auto.pages.pages.project-home.index.24': '标识符',
  'auto.pages.pages.project-home.index.25': '项目简介',
  'auto.pages.pages.project-home.index.26': '创建时间',
  'auto.pages.pages.project-home.index.27': '最近更新',
  'auto.pages.pages.project-home.index.28': '未设置',
  'auto.pages.pages.project-home.index.29': '项目约定',
  'auto.pages.pages.project-home.index.30':
    '当前项目启用中的目标愿景、原则要求与注意事项',
  'auto.pages.pages.project-home.index.31': '最近操作记录',
  'auto.pages.pages.project-home.index.32': '目标愿景',
  'auto.pages.pages.project-home.index.33': '原则要求',
  'auto.pages.pages.project-home.index.34': '注意事项',
  'auto.pages.pages.project-home.index.35': '验收标准',
  'auto.pages.pages.project-home.index.36': '暂无验收标准',
  'auto.pages.pages.project-home.index.37': '最近操作记录',
  'auto.pages.pages.project-home.index.38': '当前暂无最近操作记录',
  'auto.pages.pages.project-settings.developer-options.index.1': '开发者选项',
  'auto.pages.pages.project-settings.developer-options.index.2':
    '开发工具与扩展能力配置',
  'auto.pages.pages.project-settings.developer-options.index.3':
    '开发者选项页面建设中',
  'auto.pages.pages.project-settings.project-announcement.index.1': '项目公告',
  'auto.pages.pages.project-settings.project-announcement.index.2':
    '项目公告发布与历史公告管理',
  'auto.pages.pages.project-settings.project-announcement.index.3':
    '项目公告页面建设中',
  'auto.pages.pages.project-settings.project-collaboration.index.1': '项目协同',
  'auto.pages.pages.project-settings.project-collaboration.index.2':
    '项目协同规则与工作流设置',
  'auto.pages.pages.project-settings.project-collaboration.index.3':
    '项目协同设置页面建设中',
  'auto.pages.pages.project-settings.project-member.index.1': '项目与成员',
  'auto.pages.pages.project-settings.project-member.index.2':
    '项目基本信息与成员协作配置',
  'auto.pages.pages.project-settings.project-member.index.3':
    '项目与成员设置页面建设中',
  'auto.pages.pages.projects.data.1': '解析用户信息失败',
  'auto.pages.pages.projects.estimation-standards.detail.1':
    '估算标准不存在或已删除',
  'auto.pages.pages.projects.estimation-standards.detail.2': '加载标准详情失败',
  'auto.pages.pages.projects.estimation-standards.detail.3': 'AI已生成评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.4':
    'AI生成评分标准失败',
  'auto.pages.pages.projects.estimation-standards.detail.5': 'AI已调整角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.6':
    'AI调整角色比例失败',
  'auto.pages.pages.projects.estimation-standards.detail.7': 'AI已估算基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.8':
    'AI估算基准工时失败',
  'auto.pages.pages.projects.estimation-standards.detail.9':
    'AI标准生成完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.10':
    '批量AI生成评分标准失败',
  'auto.pages.pages.projects.estimation-standards.detail.11':
    'AI比例调整完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.12':
    '批量AI调整比例失败',
  'auto.pages.pages.projects.estimation-standards.detail.13':
    'AI工时估算完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.14':
    '批量AI估算工时失败',
  'auto.pages.pages.projects.estimation-standards.detail.15': '评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.16': '角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.17': '基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.18': '功能点类型代码',
  'auto.pages.pages.projects.estimation-standards.detail.19': '分类',
  'auto.pages.pages.projects.estimation-standards.detail.20': '基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.21':
    '角色比例(%)  P=产品 F=前端 B=后端 T=测试',
  'auto.pages.pages.projects.estimation-standards.detail.22': '操作',
  'auto.pages.pages.projects.estimation-standards.detail.23': '完成',
  'auto.pages.pages.projects.estimation-standards.detail.24': '改',
  'auto.pages.pages.projects.estimation-standards.detail.25':
    '确认删除 {p1} 配置吗？',
  'auto.pages.pages.projects.estimation-standards.detail.26':
    '已删除，保存后生效',
  'auto.pages.pages.projects.estimation-standards.detail.27': '删',
  'auto.pages.pages.projects.estimation-standards.detail.28': 'AI生成评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.29': 'AI标准',
  'auto.pages.pages.projects.estimation-standards.detail.30': 'AI调整角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.31': 'AI比例',
  'auto.pages.pages.projects.estimation-standards.detail.32': 'AI估算基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.33': 'AI工时',
  'auto.pages.pages.projects.estimation-standards.detail.34':
    '标准参数保存成功',
  'auto.pages.pages.projects.estimation-standards.detail.35':
    '保存标准参数失败',
  'auto.pages.pages.projects.estimation-standards.detail.36': '标准参数：{p1}',
  'auto.pages.pages.projects.estimation-standards.detail.37': '标准参数',
  'auto.pages.pages.projects.estimation-standards.detail.38': '版本 v{p1}',
  'auto.pages.pages.projects.estimation-standards.detail.39': '返回列表',
  'auto.pages.pages.projects.estimation-standards.detail.40': 'AI批量标准',
  'auto.pages.pages.projects.estimation-standards.detail.41': 'AI批量比例',
  'auto.pages.pages.projects.estimation-standards.detail.42': 'AI批量工时',
  'auto.pages.pages.projects.estimation-standards.detail.43': '保存参数',
  'auto.pages.pages.projects.estimation-standards.detail.44':
    '复杂度判定标准（可编辑）',
  'auto.pages.pages.projects.estimation-standards.detail.45': '备注',
  'auto.pages.pages.projects.estimation-standards.detail.46': '可选',
  'auto.pages.pages.projects.estimation-standards.detail.47': 'AI{p1}分析',
  'auto.pages.pages.projects.estimation-standards.detail.48': '开始分析',
  'auto.pages.pages.projects.estimation-standards.detail.49': '取消',
  'auto.pages.pages.projects.estimation-standards.detail.50': '目标：',
  'auto.pages.pages.projects.estimation-standards.detail.51': '全部 {p1} 项',
  'auto.pages.pages.projects.estimation-standards.detail.52':
    '请输入你的意见建议，例如：优先稳定性、强调后端性能、提高测试覆盖、避免复杂实现等',
  'auto.pages.pages.projects.estimation-standards.detail.53':
    'AI会在分析时优先考虑你输入的意见；不填则按系统默认规则分析。',
  'auto.pages.pages.projects.estimation-standards.index.1': '加载估算标准失败',
  'auto.pages.pages.projects.estimation-standards.index.2': '估算标准更新成功',
  'auto.pages.pages.projects.estimation-standards.index.3': '估算标准创建成功',
  'auto.pages.pages.projects.estimation-standards.index.4': '保存估算标准失败',
  'auto.pages.pages.projects.estimation-standards.index.5': '标准名称',
  'auto.pages.pages.projects.estimation-standards.index.6': '范围',
  'auto.pages.pages.projects.estimation-standards.index.7': '项目级',
  'auto.pages.pages.projects.estimation-standards.index.8': '全局',
  'auto.pages.pages.projects.estimation-standards.index.9': '状态',
  'auto.pages.pages.projects.estimation-standards.index.10': '启用',
  'auto.pages.pages.projects.estimation-standards.index.11': '禁用',
  'auto.pages.pages.projects.estimation-standards.index.12': '默认',
  'auto.pages.pages.projects.estimation-standards.index.13': '默认',
  'auto.pages.pages.projects.estimation-standards.index.14': '操作',
  'auto.pages.pages.projects.estimation-standards.index.15': '详情',
  'auto.pages.pages.projects.estimation-standards.index.16': '编辑',
  'auto.pages.pages.projects.estimation-standards.index.17':
    '确认删除此估算标准吗？',
  'auto.pages.pages.projects.estimation-standards.index.18': '删除成功',
  'auto.pages.pages.projects.estimation-standards.index.19': '删除',
  'auto.pages.pages.projects.estimation-standards.index.20': '工时评估标准管理',
  'auto.pages.pages.projects.estimation-standards.index.21': '标准列表',
  'auto.pages.pages.projects.estimation-standards.index.22': '刷新',
  'auto.pages.pages.projects.estimation-standards.index.23': '新建标准',
  'auto.pages.pages.projects.estimation-standards.index.24': '编辑估算标准',
  'auto.pages.pages.projects.estimation-standards.index.25': '新建估算标准',
  'auto.pages.pages.projects.estimation-standards.index.26': '标准名称',
  'auto.pages.pages.projects.estimation-standards.index.27': '请输入标准名称',
  'auto.pages.pages.projects.estimation-standards.index.28':
    '例如：中小企业轻量HR/ERP',
  'auto.pages.pages.projects.estimation-standards.index.29': '描述',
  'auto.pages.pages.projects.estimation-standards.index.30': '版本',
  'auto.pages.pages.projects.estimation-standards.index.31': '状态',
  'auto.pages.pages.projects.estimation-standards.index.32': '启用',
  'auto.pages.pages.projects.estimation-standards.index.33': '禁用',
  'auto.pages.pages.projects.estimation-standards.index.34':
    '项目UUID（空表示全局）',
  'auto.pages.pages.projects.estimation-standards.index.35': '可选',
  'auto.pages.pages.projects.estimation-standards.index.36': '设为默认',
  'auto.pages.pages.projects.index.1': '解析用户信息失败',
  'auto.pages.pages.projects.index.2': '项目列表加载失败',
  'auto.pages.pages.projects.index.3': '项目删除成功',
  'auto.pages.pages.projects.index.4': '项目删除失败',
  'auto.pages.pages.projects.index.5': '项目更新成功',
  'auto.pages.pages.projects.index.6': '项目创建成功',
  'auto.pages.pages.projects.index.7': '编辑',
  'auto.pages.pages.projects.index.8': '确认删除该项目吗？',
  'auto.pages.pages.projects.index.9': '删除',
  'auto.pages.pages.projects.index.10': '取消',
  'auto.pages.pages.projects.index.11': '删除',
  'auto.pages.pages.projects.index.12': '前缀',
  'auto.pages.pages.projects.index.13': '创建 {p1} ｜ 更新 {p2}',
  'auto.pages.pages.projects.index.14': '创建 {p1}',
  'auto.pages.pages.projects.index.15': '更新 {p1}',
  'auto.pages.pages.projects.index.16': '项目管理',
  'auto.pages.pages.projects.index.17': '选择一个项目进入详情工作台',
  'auto.pages.pages.projects.index.18': '搜索项目名称/中文名/标识符',
  'auto.pages.pages.projects.index.19': '刷新',
  'auto.pages.pages.projects.index.20': '新建项目',
  'auto.pages.pages.projects.index.21': '暂无项目数据',
  'auto.pages.pages.projects.index.22': '共 {p1} 个项目',
  'auto.pages.pages.projects.index.23': '编辑项目',
  'auto.pages.pages.projects.index.24': '新建项目',
  'auto.pages.pages.projects.index.25': '项目中文名',
  'auto.pages.pages.projects.index.26': '请输入项目中文名',
  'auto.pages.pages.projects.index.27': '请输入项目中文名',
  'auto.pages.pages.projects.index.28': '项目英文名',
  'auto.pages.pages.projects.index.29': '请输入项目英文名',
  'auto.pages.pages.projects.index.30': '项目标识符',
  'auto.pages.pages.projects.index.31': '请输入项目标识符',
  'auto.pages.pages.projects.index.32': '该标识符已存在',
  'auto.pages.pages.projects.index.33': '例如：PROJ-001',
  'auto.pages.pages.projects.index.34': '项目前缀',
  'auto.pages.pages.projects.index.35': '例如：PROJ',
  'auto.pages.pages.projects.index.36': '项目 Logo',
  'auto.pages.pages.projects.index.37': '请输入 Logo URL',
  'auto.pages.pages.projects.index.38': '项目描述',
  'auto.pages.pages.projects.index.39': '请输入项目描述',
  'auto.pages.pages.projects.index.40': 'グループ一括移動({p1})',
  'auto.pages.pages.projects.index.41': 'グループ管理',
  'auto.pages.pages.projects.index.42': 'タグ管理',
  'auto.pages.pages.projects.index.43': 'キーワード',
  'auto.pages.pages.projects.index.44': 'プロジェクトタグ',
  'auto.pages.pages.projects.index.45': 'プロジェクトタグを選択してください',
  'auto.pages.pages.projects.index.46': '並び替え項目',
  'auto.pages.pages.projects.index.47': '作成日時',
  'auto.pages.pages.projects.index.48': '更新日時',
  'auto.pages.pages.projects.index.49': '名称',
  'auto.pages.pages.projects.index.50': '状態',
  'auto.pages.pages.projects.index.51': '優先度',
  'auto.pages.pages.projects.index.52': 'グループ',
  'auto.pages.pages.projects.index.53': '並び替え項目を選択してください',
  'auto.pages.pages.projects.index.54': '並び順',
  'auto.pages.pages.projects.index.55': '並び順を選択してください',
  'auto.pages.pages.projects.index.56': '展開',
  'auto.pages.pages.projects.index.57': '折りたたむ',
  'auto.pages.pages.projects.index.58': '新規グループ',
  'auto.pages.pages.projects.index.59': '先にプロジェクト名を入力してください',
  'auto.pages.pages.projects.index.60': 'プロジェクト識別子を生成しました',
  'auto.pages.pages.projects.index.61':
    'AI によるプロジェクト識別子の生成に失敗しました。しばらくしてから再試行してください',
  'auto.pages.pages.projects.index.62': 'AIで識別子生成',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.1': '未填写',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.2':
    '加载页面设计列表失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.3': '保存成功',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.4': '保存失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.5': '示例项目',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.6':
    '一个现代化的项目管理平台',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.7':
    'AI 已识别 {p1} 个功能点，并建议了 {p2} 个页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.8':
    '生成页面建议失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.9':
    '页面组件方案生成完成',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.10':
    '页面组件方案生成失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.11':
    '分析结果已保存',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.12': '包含：{p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.13':
    '应用分析结果失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.14':
    '获取组件详情失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.15':
    '请先分析该页面的组件方案，再查看草图',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.16':
    '生成原型草图失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.17': '删除成功',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.18': '删除失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.19':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.20': '页面设计',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.21':
    '页面设计导出_{p1}.xlsx',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.22':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.23':
    '# 页面设计导出\n\n| 页面名称 | 页面描述 | 核心组件概括 |\n| --- | --- | --- |\n',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.24':
    '页面设计导出_{p1}.md',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.25':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.26':
    '页面设计方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.27': '页面设计',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.28': '核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.29': '核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.30':
    '页面设计导出_{p1}.xmind',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.31':
    '导出 XMind 失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.32': '导出 Excel',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.33':
    '导出 Markdown',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.34': '导出 XMind',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.35': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.36': '页面描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.37':
    '核心组件概括',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.38': '未分析',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.39': '操作',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.40': '分析组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.41': '查看草图',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.42': '编辑',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.43':
    '确定删除吗？',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.44': '删除',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.45':
    'AI 生成页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.46': '手工添加',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.47':
    '保存当前列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.48': '批量导出',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.49': '清空列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.50':
    'AI 辅助设计方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.51':
    '确认并保存到项目',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.52': '需求场景',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.53': '项目名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.54':
    '输入项目名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.55': '项目描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.56':
    '描述核心功能、目标用户...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.57':
    '建议页面数量',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.58':
    'AI 补充指令',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.59':
    '例如：偏重移动端、采用极简风格、需要深色模式建议...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.60':
    '开始 AI 生成',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.61':
    '建议页面列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.62': '页面名',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.63': '描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.64':
    '点击左侧开始生成页面方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.65':
    'AI 页面组件分析',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.66': '关闭',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.67':
    '应用并保存结果',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.68': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.69':
    '补充分析需求',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.70':
    '例如：分析需要包含哪些具体交互逻辑...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.71':
    '一键分析核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.72': '组件名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.73': '组件类型',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.74': '功能描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.75':
    '页面组件详情 - {p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.76': '名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.77': '类型',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.78': '描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.79':
    '页面原型草图 - {p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.80': '关闭',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.81':
    '代码已复制到剪贴板',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.82': '复制代码',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.83':
    'AI 正在极速生成原型草图代码...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.84':
    '未能生成有效代码',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.85': '编辑页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.86': '新增页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.87': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.88': '页面描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.89': '组件概要',
  'auto.pages.pages.prototype-design.index.1': '项目列表页',
  'auto.pages.pages.prototype-design.index.2': '项目详情页',
  'auto.pages.pages.prototype-design.index.3': '需求文档页',
  'auto.pages.pages.prototype-design.index.4': '页面',
  'auto.pages.pages.prototype-design.index.5': '版本',
  'auto.pages.pages.prototype-design.index.6': '设计师',
  'auto.pages.pages.prototype-design.index.7': '评审时间',
  'auto.pages.pages.prototype-design.index.8': '状态',
  'auto.pages.pages.prototype-design.index.9': '草稿',
  'auto.pages.pages.prototype-design.index.10': '评审中',
  'auto.pages.pages.prototype-design.index.11': '已通过',
  'auto.pages.pages.prototype-design.index.12': '操作',
  'auto.pages.pages.prototype-design.index.13': '查看',
  'auto.pages.pages.prototype-design.index.14': '历史版本',
  'auto.pages.pages.prototype-design.index.15': '页面设计',
  'auto.pages.pages.prototype-design.index.16': '管理原型版本、评审与变更记录',
  'auto.pages.pages.prototype-design.index.17': '新建原型',
  'auto.pages.pages.prototype-design.index.18': '同步设计平台',
  'auto.pages.pages.prototype-design.theme-design.index.1': '主色',
  'auto.pages.pages.prototype-design.theme-design.index.2': '成功色',
  'auto.pages.pages.prototype-design.theme-design.index.3': '警告色',
  'auto.pages.pages.prototype-design.theme-design.index.4': '错误色',
  'auto.pages.pages.prototype-design.theme-design.index.5': '圆角',
  'auto.pages.pages.prototype-design.theme-design.index.6': '基础字号',
  'auto.pages.pages.prototype-design.theme-design.index.7': '字体',
  'auto.pages.pages.prototype-design.theme-design.index.8': '紧凑模式',
  'auto.pages.pages.prototype-design.theme-design.index.9': '启用阴影',
  'auto.pages.pages.prototype-design.theme-design.index.10':
    'Ant Design 主题配置已保存（示例）',
  'auto.pages.pages.prototype-design.theme-design.index.11': '保存主题',
  'auto.pages.pages.prototype-design.theme-design.index.12': '重置',
  'auto.pages.pages.prototype-design.theme-design.index.13': '实时预览',
  'auto.pages.pages.prototype-design.theme-design.index.14': '项目管理工作台',
  'auto.pages.pages.prototype-design.theme-design.index.15':
    '基于 Token 的主题展示，支持主色、字号、圆角与阴影开关。',
  'auto.pages.pages.prototype-design.theme-design.index.16':
    'Element Plus 变量',
  'auto.pages.pages.prototype-design.theme-design.index.17':
    '主色 --el-color-primary',
  'auto.pages.pages.prototype-design.theme-design.index.18':
    '成功色 --el-color-success',
  'auto.pages.pages.prototype-design.theme-design.index.19':
    '警告色 --el-color-warning',
  'auto.pages.pages.prototype-design.theme-design.index.20':
    '危险色 --el-color-danger',
  'auto.pages.pages.prototype-design.theme-design.index.21':
    '信息色 --el-color-info',
  'auto.pages.pages.prototype-design.theme-design.index.22':
    '圆角 --el-border-radius-base',
  'auto.pages.pages.prototype-design.theme-design.index.23':
    '字体 --el-font-family',
  'auto.pages.pages.prototype-design.theme-design.index.24': '深色菜单',
  'auto.pages.pages.prototype-design.theme-design.index.25':
    'Element Plus 主题配置已保存（示例）',
  'auto.pages.pages.prototype-design.theme-design.index.26': '保存主题',
  'auto.pages.pages.prototype-design.theme-design.index.27': '实时预览',
  'auto.pages.pages.prototype-design.theme-design.index.28':
    '使用 CSS 变量映射 Element Plus\n              主题：`--el-color-primary`、`--el-font-family` 等。',
  'auto.pages.pages.prototype-design.theme-design.index.29': '主题设计',
  'auto.pages.pages.prototype-design.theme-design.index.30':
    '辅助设计系统主题（颜色、字体、圆角等），提供 Ant Design 与 Element Plus 两套配置',
  'auto.pages.pages.prototype-design.theme-design.index.31':
    'Ant Design 主题编辑器',
  'auto.pages.pages.quality-management.index.1': '代码规范符合率',
  'auto.pages.pages.quality-management.index.2': '前端组',
  'auto.pages.pages.quality-management.index.3': '需求缺陷逃逸率',
  'auto.pages.pages.quality-management.index.4': '产品组',
  'auto.pages.pages.quality-management.index.5': '自动化测试覆盖率',
  'auto.pages.pages.quality-management.index.6': '测试组',
  'auto.pages.pages.quality-management.index.7': '指标',
  'auto.pages.pages.quality-management.index.8': '责任团队',
  'auto.pages.pages.quality-management.index.9': '得分',
  'auto.pages.pages.quality-management.index.10': '更新时间',
  'auto.pages.pages.quality-management.index.11': '趋势',
  'auto.pages.pages.quality-management.index.12': '上升',
  'auto.pages.pages.quality-management.index.13': '下降',
  'auto.pages.pages.quality-management.index.14': '持平',
  'auto.pages.pages.quality-management.index.15': '质量管理',
  'auto.pages.pages.quality-management.index.16':
    '质量度量、检查结果与持续改进闭环',
  'auto.pages.pages.quality-management.index.17': '综合质量分',
  'auto.pages.pages.quality-management.index.18': '本周新增问题',
  'auto.pages.pages.quality-management.index.19': '已关闭问题',
  'auto.pages.pages.quote-management.index.1': '华东零售集团',
  'auto.pages.pages.quote-management.index.2': '北方制造有限公司',
  'auto.pages.pages.quote-management.index.3': '华南物流科技',
  'auto.pages.pages.quote-management.index.4': '报价单号',
  'auto.pages.pages.quote-management.index.5': '客户名称',
  'auto.pages.pages.quote-management.index.6': '报价金额',
  'auto.pages.pages.quote-management.index.7': '版本',
  'auto.pages.pages.quote-management.index.8': '状态',
  'auto.pages.pages.quote-management.index.9': '草稿',
  'auto.pages.pages.quote-management.index.10': '已提交',
  'auto.pages.pages.quote-management.index.11': '已确认',
  'auto.pages.pages.quote-management.index.12': '更新时间',
  'auto.pages.pages.quote-management.index.13': '报价管理',
  'auto.pages.pages.quote-management.index.14':
    '生成报价单并跟踪报价版本与状态',
  'auto.pages.pages.quote-management.index.15': '本月报价单',
  'auto.pages.pages.quote-management.index.16': '待确认报价',
  'auto.pages.pages.quote-management.index.17': '报价转化率',
  'auto.pages.pages.quote-management.index.18': 'チャネル開拓',
  'auto.pages.pages.quote-management.index.19': '重点顧客推進',
  'auto.pages.pages.quote-management.index.20': '既存顧客更新',
  'auto.pages.pages.quote-management.index.21': '初回接触',
  'auto.pages.pages.quote-management.index.22': '提案評価',
  'auto.pages.pages.quote-management.index.23': '商談交渉',
  'auto.pages.pages.quote-management.index.24': 'パイプライン',
  'auto.pages.pages.quote-management.index.25': '段階',
  'auto.pages.pages.requirements.application-analysis.index.1': 'Web',
  'auto.pages.pages.requirements.application-analysis.index.2': 'iOS端',
  'auto.pages.pages.requirements.application-analysis.index.3': 'Android',
  'auto.pages.pages.requirements.application-analysis.index.4':
    'ミニプログラム',
  'auto.pages.pages.requirements.application-analysis.index.5': 'デスクトップ',
  'auto.pages.pages.requirements.application-analysis.index.6': '組み込み',
  'auto.pages.pages.requirements.application-analysis.index.7': '车载端',
  'auto.pages.pages.requirements.application-analysis.index.8': 'TV',
  'auto.pages.pages.requirements.application-analysis.index.9': 'IoT端',
  'auto.pages.pages.requirements.application-analysis.index.10': '开放API端',
  'auto.pages.pages.requirements.application-analysis.index.11': 'その他',
  'auto.pages.pages.requirements.application-analysis.index.12':
    '未命名プロジェクト',
  'auto.pages.pages.requirements.application-analysis.index.13':
    '読み込み適用分析失敗',
  'auto.pages.pages.requirements.application-analysis.index.14':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.application-analysis.index.15':
    'プロジェクト信息已保存',
  'auto.pages.pages.requirements.application-analysis.index.16':
    'プロジェクト情報を保存に失敗しました',
  'auto.pages.pages.requirements.application-analysis.index.17':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.application-analysis.index.18':
    'AI 生成完了（参考機能件 {p1} 条）, 選択してください后添加',
  'auto.pages.pages.requirements.application-analysis.index.19': 'AI 生成失敗',
  'auto.pages.pages.requirements.application-analysis.index.20':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.application-analysis.index.21':
    '请先勾选プレビュー端',
  'auto.pages.pages.requirements.application-analysis.index.22':
    '已添加并保存 {p1} 个端',
  'auto.pages.pages.requirements.application-analysis.index.23': '添加失敗',
  'auto.pages.pages.requirements.application-analysis.index.24':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.application-analysis.index.25': '保存しました',
  'auto.pages.pages.requirements.application-analysis.index.26':
    '保存に失敗しました',
  'auto.pages.pages.requirements.application-analysis.index.27':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.application-analysis.index.28':
    '已クリア適用端分析数据',
  'auto.pages.pages.requirements.application-analysis.index.29':
    'クリアに失敗しました',
  'auto.pages.pages.requirements.application-analysis.index.30': '未入力',
  'auto.pages.pages.requirements.application-analysis.index.31': '端名称',
  'auto.pages.pages.requirements.application-analysis.index.32': '未入力',
  'auto.pages.pages.requirements.application-analysis.index.33': '端类型',
  'auto.pages.pages.requirements.application-analysis.index.34': '未入力',
  'auto.pages.pages.requirements.application-analysis.index.35': '英語名',
  'auto.pages.pages.requirements.application-analysis.index.36': '缩写',
  'auto.pages.pages.requirements.application-analysis.index.37': '目标用户',
  'auto.pages.pages.requirements.application-analysis.index.38': '核心场景',
  'auto.pages.pages.requirements.application-analysis.index.39': '核心能力',
  'auto.pages.pages.requirements.application-analysis.index.40': '运行环境',
  'auto.pages.pages.requirements.application-analysis.index.41': '交互方式',
  'auto.pages.pages.requirements.application-analysis.index.42': '集成依赖',
  'auto.pages.pages.requirements.application-analysis.index.43': '非機能要求',
  'auto.pages.pages.requirements.application-analysis.index.44': '优先级',
  'auto.pages.pages.requirements.application-analysis.index.45': '阶段',
  'auto.pages.pages.requirements.application-analysis.index.46': 'ステータス',
  'auto.pages.pages.requirements.application-analysis.index.47': '操作',
  'auto.pages.pages.requirements.application-analysis.index.48': '編集',
  'auto.pages.pages.requirements.application-analysis.index.49': '削除',
  'auto.pages.pages.requirements.application-analysis.index.50': '端名称',
  'auto.pages.pages.requirements.application-analysis.index.51': '未入力',
  'auto.pages.pages.requirements.application-analysis.index.52': '端类型',
  'auto.pages.pages.requirements.application-analysis.index.53': '未入力',
  'auto.pages.pages.requirements.application-analysis.index.54': '目标用户',
  'auto.pages.pages.requirements.application-analysis.index.55': '核心场景',
  'auto.pages.pages.requirements.application-analysis.index.56': '核心能力',
  'auto.pages.pages.requirements.application-analysis.index.57': '优先级',
  'auto.pages.pages.requirements.application-analysis.index.58': '阶段',
  'auto.pages.pages.requirements.application-analysis.index.59':
    'アプリケーション分析',
  'auto.pages.pages.requirements.application-analysis.index.60':
    'プロジェクト「{p1}」に必要なクライアント（{p2}）を識別します',
  'auto.pages.pages.requirements.application-analysis.index.61': 'AI適用分析',
  'auto.pages.pages.requirements.application-analysis.index.62': '新增端',
  'auto.pages.pages.requirements.application-analysis.index.63': '保存',
  'auto.pages.pages.requirements.application-analysis.index.64':
    '確認クリア現在プロジェクト適用端分析数据？',
  'auto.pages.pages.requirements.application-analysis.index.65': 'クリア重置',
  'auto.pages.pages.requirements.application-analysis.index.66': '削除选中（',
  'auto.pages.pages.requirements.application-analysis.index.67':
    '暂无適用端分析数据, 点击“AI適用分析”或“新增端”開始',
  'auto.pages.pages.requirements.application-analysis.index.68': '編集適用端',
  'auto.pages.pages.requirements.application-analysis.index.69': '新增適用端',
  'auto.pages.pages.requirements.application-analysis.index.70': '确定',
  'auto.pages.pages.requirements.application-analysis.index.71': 'キャンセル',
  'auto.pages.pages.requirements.application-analysis.index.72':
    '端名称（中文）',
  'auto.pages.pages.requirements.application-analysis.index.73': '请输入端名称',
  'auto.pages.pages.requirements.application-analysis.index.74':
    '例: Web管理端、iOS移动端、车载端',
  'auto.pages.pages.requirements.application-analysis.index.75': '端类型',
  'auto.pages.pages.requirements.application-analysis.index.76': '请选择端类型',
  'auto.pages.pages.requirements.application-analysis.index.77': '发布优先级',
  'auto.pages.pages.requirements.application-analysis.index.78': '（ ）',
  'auto.pages.pages.requirements.application-analysis.index.79':
    '例: Web Admin Console',
  'auto.pages.pages.requirements.application-analysis.index.80': '端简称',
  'auto.pages.pages.requirements.application-analysis.index.81': '例: WAC',
  'auto.pages.pages.requirements.application-analysis.index.82': '目标用户',
  'auto.pages.pages.requirements.application-analysis.index.83': '核心场景',
  'auto.pages.pages.requirements.application-analysis.index.84': '核心能力',
  'auto.pages.pages.requirements.application-analysis.index.85':
    '运行环境/平台约束',
  'auto.pages.pages.requirements.application-analysis.index.86': '交互方式',
  'auto.pages.pages.requirements.application-analysis.index.87': '集成依赖',
  'auto.pages.pages.requirements.application-analysis.index.88': '非機能要求',
  'auto.pages.pages.requirements.application-analysis.index.89': '发布阶段',
  'auto.pages.pages.requirements.application-analysis.index.90':
    '例: MVP、Phase-2',
  'auto.pages.pages.requirements.application-analysis.index.91': 'ステータス',
  'auto.pages.pages.requirements.application-analysis.index.92': 'AI 適用分析',
  'auto.pages.pages.requirements.application-analysis.index.93': '生成选件',
  'auto.pages.pages.requirements.application-analysis.index.94':
    'プロジェクト名',
  'auto.pages.pages.requirements.application-analysis.index.95':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.application-analysis.index.96':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.application-analysis.index.97':
    'プロジェクト概要',
  'auto.pages.pages.requirements.application-analysis.index.98':
    'プロジェクト概要を入力してください',
  'auto.pages.pages.requirements.application-analysis.index.99':
    'ヒント信息（用于辅助生成）',
  'auto.pages.pages.requirements.application-analysis.index.100':
    '例: 重点考虑外勤、供应链、车载设备和管理后台等多端协同场景',
  'auto.pages.pages.requirements.application-analysis.index.101': '分解端数量',
  'auto.pages.pages.requirements.application-analysis.index.102':
    '分解数を入力してください',
  'auto.pages.pages.requirements.application-analysis.index.103':
    '数量範囲为 1-20',
  'auto.pages.pages.requirements.application-analysis.index.104':
    '参考機能一覧（若プロジェクト已有機能一覧）',
  'auto.pages.pages.requirements.application-analysis.index.105':
    'プロジェクト情報を保存',
  'auto.pages.pages.requirements.application-analysis.index.106': 'キャンセル',
  'auto.pages.pages.requirements.application-analysis.index.107':
    '生成プレビュー',
  'auto.pages.pages.requirements.application-analysis.index.108':
    'プレビュー结果',
  'auto.pages.pages.requirements.application-analysis.index.109':
    '勾选需要的端后添加到列表',
  'auto.pages.pages.requirements.application-analysis.index.110':
    '点击“生成プレビュー”后查看候选端',
  'auto.pages.pages.requirements.application-analysis.index.111':
    '重名时覆盖已有端',
  'auto.pages.pages.requirements.application-analysis.index.112':
    '添加选中到端列表（',
  'auto.pages.pages.requirements.application-analysis.index.113':
    '端名を1件以上入力してください（1行1件）',
  'auto.pages.pages.requirements.application-analysis.index.114':
    '手動入力から {p1} 件の端プレビューを生成しました',
  'auto.pages.pages.requirements.application-analysis.index.115':
    '分解モード：できるだけ多く（上限20）',
  'auto.pages.pages.requirements.application-analysis.index.116':
    '分解モード：指定件数（{p1}）',
  'auto.pages.pages.requirements.application-analysis.index.117': '分解モード',
  'auto.pages.pages.requirements.application-analysis.index.118':
    'A、できるだけ多く',
  'auto.pages.pages.requirements.application-analysis.index.119': 'B、指定件数',
  'auto.pages.pages.requirements.application-analysis.index.120': 'C、手動入力',
  'auto.pages.pages.requirements.application-analysis.index.121': '手動入力',
  'auto.pages.pages.requirements.application-analysis.index.122':
    '手動の端一覧を入力してください',
  'auto.pages.pages.requirements.application-analysis.index.123':
    '1行に1つの端名を入力してください',
  'auto.pages.pages.requirements.application-analysis.index.124':
    '例：\nWeb管理端\niOSモバイル端\nミニプログラム端',
  'auto.pages.pages.requirements.application-analysis.index.125':
    '任意：追加の分解指示を入力するとAIの理解精度が上がります',
  'auto.pages.pages.requirements.application-analysis.index.126':
    'プロジェクト情報（任意）',
  'auto.pages.pages.requirements.application-analysis.index.127':
    '手動入力をプレビュー',
  'auto.pages.pages.requirements.application-analysis.index.128':
    '参考資料（任意）',
  'auto.pages.pages.requirements.application-analysis.index.129':
    '背景情報、制約条件、過去事例などを貼り付けると、AI分解の精度が向上します',
  'auto.pages.pages.requirements.application-analysis.index.130':
    '例：\n- 端末方針：管理はWeb優先、外勤はモバイル優先\n- ベンチマーク：XXシステムはWeb+App+ミニプログラムの3端連携',
  'auto.pages.pages.requirements.application-analysis.index.131': '削除',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.1':
    'プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.2':
    '承载要件、適用与交付活动的业务单元',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.3': '適用',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.4':
    'プロジェクト下可独立管理与发布的機能系统',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.5': '要件条目',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.6':
    '可被追踪和验收的具体业务要件',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.7': '概念分析',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.8':
    '统一核心术语定义, 降低沟通歧义',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.9': '概念',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.10': '定义',
  'auto.pages.pages.requirements.concept-analysis.index.1':
    '未命名プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.index.2':
    '読み込み概念分析失敗',
  'auto.pages.pages.requirements.concept-analysis.index.3':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.concept-analysis.index.4':
    'プロジェクト信息已保存',
  'auto.pages.pages.requirements.concept-analysis.index.5':
    'プロジェクト情報を保存に失敗しました',
  'auto.pages.pages.requirements.concept-analysis.index.6':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.concept-analysis.index.7':
    'AI 生成完了（参考機能件 {p1} 条）, 選択してください后添加',
  'auto.pages.pages.requirements.concept-analysis.index.8': 'AI 生成失敗',
  'auto.pages.pages.requirements.concept-analysis.index.9':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.concept-analysis.index.10':
    '请先勾选プレビュー概念',
  'auto.pages.pages.requirements.concept-analysis.index.11':
    '已添加并保存 {p1} 个概念',
  'auto.pages.pages.requirements.concept-analysis.index.12': '添加失敗',
  'auto.pages.pages.requirements.concept-analysis.index.13':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.concept-analysis.index.14': '保存しました',
  'auto.pages.pages.requirements.concept-analysis.index.15':
    '保存に失敗しました',
  'auto.pages.pages.requirements.concept-analysis.index.16':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.concept-analysis.index.17': '已クリア概念数据',
  'auto.pages.pages.requirements.concept-analysis.index.18':
    'クリアに失敗しました',
  'auto.pages.pages.requirements.concept-analysis.index.19': '未入力',
  'auto.pages.pages.requirements.concept-analysis.index.20': '概念中国語名',
  'auto.pages.pages.requirements.concept-analysis.index.21': '未入力',
  'auto.pages.pages.requirements.concept-analysis.index.22': '概念英語名',
  'auto.pages.pages.requirements.concept-analysis.index.23': '缩写',
  'auto.pages.pages.requirements.concept-analysis.index.24': '释义',
  'auto.pages.pages.requirements.concept-analysis.index.25': '同义词',
  'auto.pages.pages.requirements.concept-analysis.index.26': '关联機能範囲',
  'auto.pages.pages.requirements.concept-analysis.index.27': '边界说明',
  'auto.pages.pages.requirements.concept-analysis.index.28': '示例',
  'auto.pages.pages.requirements.concept-analysis.index.29': '上位概念',
  'auto.pages.pages.requirements.concept-analysis.index.30': '下位概念',
  'auto.pages.pages.requirements.concept-analysis.index.31': 'ステータス',
  'auto.pages.pages.requirements.concept-analysis.index.32': '操作',
  'auto.pages.pages.requirements.concept-analysis.index.33': '編集',
  'auto.pages.pages.requirements.concept-analysis.index.34': '削除',
  'auto.pages.pages.requirements.concept-analysis.index.35': '概念中国語名',
  'auto.pages.pages.requirements.concept-analysis.index.36': '未入力',
  'auto.pages.pages.requirements.concept-analysis.index.37': '概念英語名',
  'auto.pages.pages.requirements.concept-analysis.index.38': '缩写',
  'auto.pages.pages.requirements.concept-analysis.index.39': '释义',
  'auto.pages.pages.requirements.concept-analysis.index.40': '同义词',
  'auto.pages.pages.requirements.concept-analysis.index.41': '关联機能範囲',
  'auto.pages.pages.requirements.concept-analysis.index.42': '边界说明',
  'auto.pages.pages.requirements.concept-analysis.index.43': '概念分析',
  'auto.pages.pages.requirements.concept-analysis.index.44':
    '基于プロジェクト“{p1}”自动提炼并维护统一术语概念',
  'auto.pages.pages.requirements.concept-analysis.index.45': 'AI',
  'auto.pages.pages.requirements.concept-analysis.index.46': '新增概念',
  'auto.pages.pages.requirements.concept-analysis.index.47': '保存',
  'auto.pages.pages.requirements.concept-analysis.index.48':
    '確認クリア現在プロジェクト概念数据？',
  'auto.pages.pages.requirements.concept-analysis.index.49': 'クリア重置',
  'auto.pages.pages.requirements.concept-analysis.index.50': '削除选中（',
  'auto.pages.pages.requirements.concept-analysis.index.51':
    '暂无概念分析数据, 点击“AI概念分析”或“新增概念”開始',
  'auto.pages.pages.requirements.concept-analysis.index.52': '編集概念',
  'auto.pages.pages.requirements.concept-analysis.index.53': '新增概念',
  'auto.pages.pages.requirements.concept-analysis.index.54': '确定',
  'auto.pages.pages.requirements.concept-analysis.index.55': 'キャンセル',
  'auto.pages.pages.requirements.concept-analysis.index.56': '概念中国語名',
  'auto.pages.pages.requirements.concept-analysis.index.57':
    '请输入概念中国語名',
  'auto.pages.pages.requirements.concept-analysis.index.58': '例: 要件条目',
  'auto.pages.pages.requirements.concept-analysis.index.59': '概念英語名',
  'auto.pages.pages.requirements.concept-analysis.index.60': '例: 要件項目',
  'auto.pages.pages.requirements.concept-analysis.index.61': '缩写',
  'auto.pages.pages.requirements.concept-analysis.index.62': '例: RI',
  'auto.pages.pages.requirements.concept-analysis.index.63': '释义',
  'auto.pages.pages.requirements.concept-analysis.index.64': '请输入概念释义',
  'auto.pages.pages.requirements.concept-analysis.index.65': '（ ）',
  'auto.pages.pages.requirements.concept-analysis.index.66': '关联機能範囲',
  'auto.pages.pages.requirements.concept-analysis.index.67': '边界说明',
  'auto.pages.pages.requirements.concept-analysis.index.68': '示例',
  'auto.pages.pages.requirements.concept-analysis.index.69': '上位概念',
  'auto.pages.pages.requirements.concept-analysis.index.70': '（ ）',
  'auto.pages.pages.requirements.concept-analysis.index.71': 'ステータス',
  'auto.pages.pages.requirements.concept-analysis.index.72': 'AI',
  'auto.pages.pages.requirements.concept-analysis.index.73': '生成选件',
  'auto.pages.pages.requirements.concept-analysis.index.74': 'プロジェクト名',
  'auto.pages.pages.requirements.concept-analysis.index.75':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.concept-analysis.index.76':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.concept-analysis.index.77': 'プロジェクト概要',
  'auto.pages.pages.requirements.concept-analysis.index.78':
    'プロジェクト概要を入力してください',
  'auto.pages.pages.requirements.concept-analysis.index.79':
    'ヒント信息（用于辅助生成）',
  'auto.pages.pages.requirements.concept-analysis.index.80':
    '例: 请重点输出业务术语边界、同义词和常见混淆点',
  'auto.pages.pages.requirements.concept-analysis.index.81': '分解概念数量',
  'auto.pages.pages.requirements.concept-analysis.index.82':
    '分解数を入力してください',
  'auto.pages.pages.requirements.concept-analysis.index.83': '数量範囲为 1-50',
  'auto.pages.pages.requirements.concept-analysis.index.84':
    '参考機能一覧（若プロジェクト已有機能一覧）',
  'auto.pages.pages.requirements.concept-analysis.index.85':
    'プロジェクト情報を保存',
  'auto.pages.pages.requirements.concept-analysis.index.86': 'キャンセル',
  'auto.pages.pages.requirements.concept-analysis.index.87': '生成プレビュー',
  'auto.pages.pages.requirements.concept-analysis.index.88': 'プレビュー结果',
  'auto.pages.pages.requirements.concept-analysis.index.89':
    '勾选需要的概念后添加到列表',
  'auto.pages.pages.requirements.concept-analysis.index.90':
    '点击“生成プレビュー”后查看候选概念',
  'auto.pages.pages.requirements.concept-analysis.index.91':
    '重名时覆盖已有概念',
  'auto.pages.pages.requirements.concept-analysis.index.92':
    '添加选中到概念列表（',
  'auto.pages.pages.requirements.document.index.1': '要件文档',
  'auto.pages.pages.requirements.document.index.2': '面向客户的标准版要件文档',
  'auto.pages.pages.requirements.document.index.3': '文档概览',
  'auto.pages.pages.requirements.document.index.4': '空白プロジェクト111',
  'auto.pages.pages.requirements.document.index.5': '产品负责人',
  'auto.pages.pages.requirements.document.index.6': '客户代表',
  'auto.pages.pages.requirements.document.index.7': '评审中',
  'auto.pages.pages.requirements.document.index.8': '文档编号',
  'auto.pages.pages.requirements.document.index.9': '所属プロジェクト',
  'auto.pages.pages.requirements.document.index.10': '负责人',
  'auto.pages.pages.requirements.document.index.11': '评审人',
  'auto.pages.pages.requirements.document.index.12': 'バージョン',
  'auto.pages.pages.requirements.document.index.13': 'ステータス',
  'auto.pages.pages.requirements.document.index.14': '评审中',
  'auto.pages.pages.requirements.document.index.15': '文档交付流程',
  'auto.pages.pages.requirements.document.index.16': '要件確認',
  'auto.pages.pages.requirements.document.index.17': '確認结论',
  'auto.pages.pages.requirements.document.index.18': '完了要件範囲確認',
  'auto.pages.pages.requirements.document.index.19': '客户评审',
  'auto.pages.pages.requirements.document.index.20': '评审意见',
  'auto.pages.pages.requirements.document.index.21': '需补充数据字典章节',
  'auto.pages.pages.requirements.document.index.22': '交付归档',
  'auto.pages.pages.requirements.document.index.23': '归档编号',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.1':
    '読み込みマインドマップ数据失敗:',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.2':
    '読み込みマインドマップ数据失敗',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.3':
    '機能要件',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.4':
    'タイトルは必須です',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.5':
    '节点已更新',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.6':
    '更新节点失敗:',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.7':
    '更新节点失敗',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.8':
    '一键展开',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.9':
    '一键折叠',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.10':
    '編集节点',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.11':
    'タイトル',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.12':
    '请输入タイトル',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.13':
    '请输入节点タイトル',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.14':
    '説明',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.15':
    '请输入节点説明',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.1':
    '完了',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.2':
    '進行中',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.3':
    '下書き',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.4':
    '読み込み表格数据失敗:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.5':
    '読み込み表格数据失敗',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.6':
    '読み込み機能ポイントタイプ失敗:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.7':
    '読み込み見積基準パラメータ失敗:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.8':
    'モジュール',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.9':
    '機能',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.10':
    '機能ポイント',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.11':
    '機能ポイントタイプ',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.12':
    '機能ポイント复杂度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.13':
    '見積工数',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.14':
    '説明',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.15':
    'ステータス',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.16':
    '下書き',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.17':
    '進行中',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.18':
    '確認済み',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.19':
    '完了',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.20':
    'ステータスのみサポート: 下書き/進行中/完了（或 0/1/2）',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.21':
    '仅機能ポイント支持編集見積工数',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.22':
    '見積工数必须为非负数字',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.23':
    '保存に失敗しました {p1} 件',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.24':
    '单元格内容已保存',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.25':
    '仅機能ポイント支持編集機能ポイントタイプ与复杂度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.26':
    '已更新',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.27':
    '更新に失敗しました',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.28':
    'タイトルは必須です',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.29':
    '请先选中一行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.30':
    '新行已插入并保存',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.31':
    '插入新行失敗:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.32':
    '插入新行失敗',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.33':
    '请先选中一行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.34':
    '未找到选中件',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.35':
    '削除確認',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.36':
    '确定削除“{p1}”吗？',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.37':
    '削除しました',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.38':
    '请先选中一行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.39':
    '未找到选中件',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.40':
    '{p1}（ ）',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.41':
    '复制成功',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.42':
    '复制失敗:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.43':
    '复制失敗',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.44':
    '新增モジュール行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.45':
    '选中件下方插入同级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.46':
    '选中件下新增子级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.47':
    '复制行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.48':
    '削除行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.49':
    '正在読み込み表格数据...',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.50':
    '現在暂无要件数据',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.51':
    '复制行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.52':
    '削除行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.53':
    '拖拽调整表格高度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.54':
    '新增モジュール行',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.55':
    '在选中件下方插入同级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.56':
    '在选中件下新增子级',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.57':
    'タイトル',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.58':
    '请输入タイトル',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.59':
    '请输入要件項目タイトル',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.60':
    '説明',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.61':
    '要件項目説明を入力してください',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.62':
    '編集機能ポイントタイプ',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.63':
    '編集复杂度',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.64':
    '请选择機能ポイントタイプ',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.65':
    '请选择复杂度',
  'auto.pages.pages.requirements.feature-list.index.1': '完了',
  'auto.pages.pages.requirements.feature-list.index.2': '進行中',
  'auto.pages.pages.requirements.feature-list.index.3': '下書き',
  'auto.pages.pages.requirements.feature-list.index.4': 'モジュール',
  'auto.pages.pages.requirements.feature-list.index.5': 'サブモジュール',
  'auto.pages.pages.requirements.feature-list.index.6': '機能',
  'auto.pages.pages.requirements.feature-list.index.7': 'サブ機能',
  'auto.pages.pages.requirements.feature-list.index.8': '機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.9': 'タスク',
  'auto.pages.pages.requirements.feature-list.index.10': '按需要',
  'auto.pages.pages.requirements.feature-list.index.11': '按タイトル',
  'auto.pages.pages.requirements.feature-list.index.12': '按添加时间',
  'auto.pages.pages.requirements.feature-list.index.13': '按修改时间',
  'auto.pages.pages.requirements.feature-list.index.14': '升序',
  'auto.pages.pages.requirements.feature-list.index.15': '降序',
  'auto.pages.pages.requirements.feature-list.index.16': 'プロジェクト',
  'auto.pages.pages.requirements.feature-list.index.17': 'モジュール',
  'auto.pages.pages.requirements.feature-list.index.18': '第1階層モジュール',
  'auto.pages.pages.requirements.feature-list.index.19': 'モジュール名称',
  'auto.pages.pages.requirements.feature-list.index.20': '機能',
  'auto.pages.pages.requirements.feature-list.index.21': '二级機能',
  'auto.pages.pages.requirements.feature-list.index.22': '機能名称',
  'auto.pages.pages.requirements.feature-list.index.23': '機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.24': '三级機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.25': '機能ポイント名称',
  'auto.pages.pages.requirements.feature-list.index.26': 'モジュール説明',
  'auto.pages.pages.requirements.feature-list.index.27':
    '第1階層モジュール説明',
  'auto.pages.pages.requirements.feature-list.index.28': '機能説明',
  'auto.pages.pages.requirements.feature-list.index.29': '二级機能説明',
  'auto.pages.pages.requirements.feature-list.index.30': '機能ポイント説明',
  'auto.pages.pages.requirements.feature-list.index.31': '三级機能ポイント説明',
  'auto.pages.pages.requirements.feature-list.index.32': '説明',
  'auto.pages.pages.requirements.feature-list.index.33': '说明',
  'auto.pages.pages.requirements.feature-list.index.34': '機能要件',
  'auto.pages.pages.requirements.feature-list.index.35':
    '読み込み機能ポイントタイプ字典失敗:',
  'auto.pages.pages.requirements.feature-list.index.36':
    '読み込み見積基準失敗:',
  'auto.pages.pages.requirements.feature-list.index.37':
    '先に見積基準を選択してください',
  'auto.pages.pages.requirements.feature-list.index.38':
    '将評価该件下機能ポイント的工数, 仅做工数評価, 不会进行機能分解',
  'auto.pages.pages.requirements.feature-list.index.39':
    '已評価下位機能ポイント工数: 成功 {p1}, 失敗 {p2}, 跳过 {p3}',
  'auto.pages.pages.requirements.feature-list.index.40':
    '下位機能ポイント評価失敗:',
  'auto.pages.pages.requirements.feature-list.index.41':
    '下位機能ポイント評価失敗',
  'auto.pages.pages.requirements.feature-list.index.42':
    '仅機能ポイント支持单件工数評価',
  'auto.pages.pages.requirements.feature-list.index.43':
    '已評価: {p1} = {p2}h（{p3} / L{p4}）',
  'auto.pages.pages.requirements.feature-list.index.44': '该件已跳过',
  'auto.pages.pages.requirements.feature-list.index.45': '该件評価失敗',
  'auto.pages.pages.requirements.feature-list.index.46': '单件工数評価失敗:',
  'auto.pages.pages.requirements.feature-list.index.47': '单件工数評価失敗',
  'auto.pages.pages.requirements.feature-list.index.48':
    '先に要件一覧を作成してください',
  'auto.pages.pages.requirements.feature-list.index.49':
    '先に見積基準を選択してください',
  'auto.pages.pages.requirements.feature-list.index.50':
    '请先在页面中选择一个モジュール',
  'auto.pages.pages.requirements.feature-list.index.51':
    '先にページで機能を選択してください',
  'auto.pages.pages.requirements.feature-list.index.52': '正在准备評価...',
  'auto.pages.pages.requirements.feature-list.index.53': '正在評価中...',
  'auto.pages.pages.requirements.feature-list.index.54':
    '没有可評価的機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.55':
    '预统计一括評価候选件失敗:',
  'auto.pages.pages.requirements.feature-list.index.56':
    '一括評価完了: 成功 {p1}, 失敗 {p2}, 跳过 {p3}',
  'auto.pages.pages.requirements.feature-list.index.57':
    '読み込み统计数据失敗:',
  'auto.pages.pages.requirements.feature-list.index.58':
    '読み込みプロジェクト详情失敗:',
  'auto.pages.pages.requirements.feature-list.index.59':
    '読み込み指定要件一覧失敗:',
  'auto.pages.pages.requirements.feature-list.index.60':
    'URL指定要件一覧不存在或不可用:',
  'auto.pages.pages.requirements.feature-list.index.61':
    '読み込み機能一覧失敗:',
  'auto.pages.pages.requirements.feature-list.index.62': '読み込み機能一覧失敗',
  'auto.pages.pages.requirements.feature-list.index.63': '[デフォルト]',
  'auto.pages.pages.requirements.feature-list.index.64':
    '不足プロジェクトID, 无法作成一覧',
  'auto.pages.pages.requirements.feature-list.index.65': 'プロジェクト',
  'auto.pages.pages.requirements.feature-list.index.66':
    '先に一覧を選択してください',
  'auto.pages.pages.requirements.feature-list.index.67':
    '不足プロジェクトID, 无法保存一覧',
  'auto.pages.pages.requirements.feature-list.index.68':
    '先に一覧を選択してください',
  'auto.pages.pages.requirements.feature-list.index.69':
    '入力してください完整一覧名称和バージョン',
  'auto.pages.pages.requirements.feature-list.index.70': '一覧作成しました',
  'auto.pages.pages.requirements.feature-list.index.71': '一覧更新しました',
  'auto.pages.pages.requirements.feature-list.index.72': '保存要件一覧失敗:',
  'auto.pages.pages.requirements.feature-list.index.73': '保存要件一覧失敗',
  'auto.pages.pages.requirements.feature-list.index.74': '切替要件一覧失敗:',
  'auto.pages.pages.requirements.feature-list.index.75': '切替要件一覧失敗',
  'auto.pages.pages.requirements.feature-list.index.76':
    '現在一覧已是デフォルト一覧',
  'auto.pages.pages.requirements.feature-list.index.77':
    '已设置为デフォルト一覧',
  'auto.pages.pages.requirements.feature-list.index.78':
    '设置デフォルト一覧失敗:',
  'auto.pages.pages.requirements.feature-list.index.79':
    '设置デフォルト一覧失敗',
  'auto.pages.pages.requirements.feature-list.index.80':
    'デフォルト一覧不允许削除, 请先切替其它一覧为デフォルト',
  'auto.pages.pages.requirements.feature-list.index.81': '一覧削除しました',
  'auto.pages.pages.requirements.feature-list.index.82': '削除一覧失敗:',
  'auto.pages.pages.requirements.feature-list.index.83': '削除一覧失敗',
  'auto.pages.pages.requirements.feature-list.index.84':
    '読み込み機能列表失敗:',
  'auto.pages.pages.requirements.feature-list.index.85': '読み込み機能列表失敗',
  'auto.pages.pages.requirements.feature-list.index.86':
    '読み込み機能ポイント列表失敗:',
  'auto.pages.pages.requirements.feature-list.index.87':
    '読み込み機能ポイント列表失敗',
  'auto.pages.pages.requirements.feature-list.index.88':
    '先に要件一覧を作成してください',
  'auto.pages.pages.requirements.feature-list.index.89':
    'クリア完了: 削除 {p1} 件',
  'auto.pages.pages.requirements.feature-list.index.90':
    '按範囲クリアに失敗しました:',
  'auto.pages.pages.requirements.feature-list.index.91': 'クリアに失敗しました',
  'auto.pages.pages.requirements.feature-list.index.92':
    '将削除範囲内所有要件項目及其下位, 削除后元に戻せません.',
  'auto.pages.pages.requirements.feature-list.index.93': 'クリア',
  'auto.pages.pages.requirements.feature-list.index.94': 'キャンセル',
  'auto.pages.pages.requirements.feature-list.index.95':
    'プロジェクト情報が不足しています',
  'auto.pages.pages.requirements.feature-list.index.96':
    'プロジェクト名は必須です',
  'auto.pages.pages.requirements.feature-list.index.97':
    'プロジェクト信息已保存',
  'auto.pages.pages.requirements.feature-list.index.98':
    'プロジェクト情報を保存失敗:',
  'auto.pages.pages.requirements.feature-list.index.99':
    'プロジェクト情報を保存失敗',
  'auto.pages.pages.requirements.feature-list.index.100':
    '要件一覧情報が不足しています',
  'auto.pages.pages.requirements.feature-list.index.101':
    '機能ポイント层级はサポートされていません继续分解',
  'auto.pages.pages.requirements.feature-list.index.102':
    '現在のみサポート分解到機能ポイント层级',
  'auto.pages.pages.requirements.feature-list.index.103':
    '手動入力で少なくとも1行入力してください',
  'auto.pages.pages.requirements.feature-list.index.104': '已录入 {p1} 个下位',
  'auto.pages.pages.requirements.feature-list.index.105':
    'プロジェクト名: {p1}\\nプロジェクト概要: {p2}',
  'auto.pages.pages.requirements.feature-list.index.106':
    '请结合プロジェクト名称、プロジェクト简介与上位機能, 尽可能全面地分解出更多合理下位機能, 覆盖主流程、支撑流程、异常流程和管理能力.\\\\n{p1}',
  'auto.pages.pages.requirements.feature-list.index.107':
    'AI分解に失敗しました',
  'auto.pages.pages.requirements.feature-list.index.108':
    'AI分解に失敗しました',
  'auto.pages.pages.requirements.feature-list.index.109':
    'AI分解結果が返されませんでした',
  'auto.pages.pages.requirements.feature-list.index.110':
    '成功分解出 {p1} 个新的要件項目',
  'auto.pages.pages.requirements.feature-list.index.111':
    'AI分解完了, 请查看结果',
  'auto.pages.pages.requirements.feature-list.index.112':
    '要件一覧情報が不足しています',
  'auto.pages.pages.requirements.feature-list.index.113':
    '確認可能な分解結果がありません',
  'auto.pages.pages.requirements.feature-list.index.114': '分解成功',
  'auto.pages.pages.requirements.feature-list.index.115':
    '未生成可保存的要件項目',
  'auto.pages.pages.requirements.feature-list.index.116':
    '成功適用 {p1} 个分解结果',
  'auto.pages.pages.requirements.feature-list.index.117': '適用分解结果失敗:',
  'auto.pages.pages.requirements.feature-list.index.118': '保存分解结果失敗',
  'auto.pages.pages.requirements.feature-list.index.119':
    '先に要件一覧を選択してください',
  'auto.pages.pages.requirements.feature-list.index.120': 'モジュール',
  'auto.pages.pages.requirements.feature-list.index.121': '機能',
  'auto.pages.pages.requirements.feature-list.index.122': '機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.123': '説明',
  'auto.pages.pages.requirements.feature-list.index.124': '機能ポイント复杂度',
  'auto.pages.pages.requirements.feature-list.index.125': '工数見積',
  'auto.pages.pages.requirements.feature-list.index.126': 'ステータス',
  'auto.pages.pages.requirements.feature-list.index.127': '機能一覧',
  'auto.pages.pages.requirements.feature-list.index.128': '機能一覧-{p1}.xlsx',
  'auto.pages.pages.requirements.feature-list.index.129':
    'Excel文件エクスポート成功',
  'auto.pages.pages.requirements.feature-list.index.130':
    'エクスポートExcel失敗:',
  'auto.pages.pages.requirements.feature-list.index.131':
    'エクスポートExcel失敗',
  'auto.pages.pages.requirements.feature-list.index.132':
    '先に要件一覧を選択してください',
  'auto.pages.pages.requirements.feature-list.index.133': '機能一覧-{p1}.xmind',
  'auto.pages.pages.requirements.feature-list.index.134':
    'マインドマップ文件エクスポート成功',
  'auto.pages.pages.requirements.feature-list.index.135':
    'エクスポートマインドマップ失敗:',
  'auto.pages.pages.requirements.feature-list.index.136':
    'エクスポートマインドマップ失敗',
  'auto.pages.pages.requirements.feature-list.index.137':
    '先に要件一覧を選択してください',
  'auto.pages.pages.requirements.feature-list.index.138':
    '\\n <html>\\n <head>\\n <meta charset="UTF-8">\\n <style>\\n body {{\\n  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;\\n  font-size: 14pt; /* 四号 */\\n  line-height: 1.75;\\n  color: #111;\\n  }}\\n h1, h2, h3, h4 {{\\n  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;\\n  font-weight: 700;\\n  margin: 16pt 0 8pt 0;\\n  text-indent: 0;\\n  line-height: 1.4;\\n  }}\\n h1 {{ font-size: 22pt; }}\\n h2 {{ font-size: 18pt; }}\\n h3 {{ font-size: 16pt; }}\\n h4 {{ font-size: 15pt; }}\\n p {{\\n  margin: 6pt 0;\\n  text-indent: 2em;\\n  font-size: 14pt;\\n  line-height: 150%;\\n  mso-line-height-rule: exactly;\\n  mso-line-height-alt: 150%;\\n  text-align: justify;\\n  text-justify: inter-ideograph;\\n  }}\\n </style>\\n </head>\\n <body>\\n <h1>機能要件</h1>\\n {p1}\\n </body>\\n </html>',
  'auto.pages.pages.requirements.feature-list.index.139': '機能一覧-{p1}.doc',
  'auto.pages.pages.requirements.feature-list.index.140':
    'Word文件エクスポート成功',
  'auto.pages.pages.requirements.feature-list.index.141':
    'エクスポートWord失敗:',
  'auto.pages.pages.requirements.feature-list.index.142':
    'エクスポートWord失敗',
  'auto.pages.pages.requirements.feature-list.index.143': '読み込み文件失敗',
  'auto.pages.pages.requirements.feature-list.index.144': '{p1} 列 - {p2}',
  'auto.pages.pages.requirements.feature-list.index.145': '()',
  'auto.pages.pages.requirements.feature-list.index.146':
    '先に要件一覧を作成し、選択してください',
  'auto.pages.pages.requirements.feature-list.index.147': '下書き',
  'auto.pages.pages.requirements.feature-list.index.148': '進行中',
  'auto.pages.pages.requirements.feature-list.index.149': '確認済み',
  'auto.pages.pages.requirements.feature-list.index.150': '完了',
  'auto.pages.pages.requirements.feature-list.index.151':
    'インポート完了: 新增モジュール {p1}, 新增機能 {p2}, 新增機能ポイント {p3}, 説明更新 {p4}（智能合并 {p5}）, 续行拼接 {p6}, 不足モジュール跳过 {p7}, 无效行 {p8}',
  'auto.pages.pages.requirements.feature-list.index.152':
    'Excelインポートに失敗しました:',
  'auto.pages.pages.requirements.feature-list.index.153':
    'Excelインポートに失敗しました',
  'auto.pages.pages.requirements.feature-list.index.154':
    '先に要件一覧を作成し、選択してください',
  'auto.pages.pages.requirements.feature-list.index.155':
    '.xlsx / .xls ファイルのみ対応しています',
  'auto.pages.pages.requirements.feature-list.index.156':
    'Excel にインポート可能なデータがありません',
  'auto.pages.pages.requirements.feature-list.index.157': '読み込みExcel失敗:',
  'auto.pages.pages.requirements.feature-list.index.158': '読み込みExcel失敗',
  'auto.pages.pages.requirements.feature-list.index.159':
    '先に Excel ファイルをアップロードしてください',
  'auto.pages.pages.requirements.feature-list.index.160':
    '無視行数超出範囲, 調整してください再試行してください',
  'auto.pages.pages.requirements.feature-list.index.161':
    '请先配置モジュール列マッピング',
  'auto.pages.pages.requirements.feature-list.index.162':
    'Excel にインポート可能なデータがありません',
  'auto.pages.pages.requirements.feature-list.index.163': 'タイトルは必須です',
  'auto.pages.pages.requirements.feature-list.index.164': '要件項目已更新',
  'auto.pages.pages.requirements.feature-list.index.165': '更新要件項目失敗:',
  'auto.pages.pages.requirements.feature-list.index.166': '更新要件項目失敗',
  'auto.pages.pages.requirements.feature-list.index.167':
    '並び替え更新しました',
  'auto.pages.pages.requirements.feature-list.index.168':
    '並び替え更新に失敗しました:',
  'auto.pages.pages.requirements.feature-list.index.169':
    '並び替え更新に失敗しました',
  'auto.pages.pages.requirements.feature-list.index.170': 'タイトルは必須です',
  'auto.pages.pages.requirements.feature-list.index.171':
    '已在下方插入新要件項目',
  'auto.pages.pages.requirements.feature-list.index.172': '下方插入失敗:',
  'auto.pages.pages.requirements.feature-list.index.173': '下方插入失敗',
  'auto.pages.pages.requirements.feature-list.index.174':
    '要件一覧情報が不足しています',
  'auto.pages.pages.requirements.feature-list.index.175':
    '请先选择モジュール, 或在弹窗中选择“全プロジェクト機能”',
  'auto.pages.pages.requirements.feature-list.index.176':
    '現在の列に分解可能な要件項目がありません',
  'auto.pages.pages.requirements.feature-list.index.177':
    '機能ポイント层级はサポートされていません继续分解',
  'auto.pages.pages.requirements.feature-list.index.178':
    '現在のみサポート分解到機能ポイント层级',
  'auto.pages.pages.requirements.feature-list.index.179':
    '请先按核心业务对象将CRUD拆为独立機能件（新增/查询/修改/削除分别成点, 禁止“XX CRUD”）, 再补充流程与治理能力; 若現在モジュール非典型CRUD, 请使用“配置-查询-分析-エクスポート-订阅/告警-审计”模板并在説明中说明原因.',
  'auto.pages.pages.requirements.feature-list.index.180':
    'AI分解に失敗しました',
  'auto.pages.pages.requirements.feature-list.index.181':
    'AI分解結果が返されませんでした',
  'auto.pages.pages.requirements.feature-list.index.182': '分解成功',
  'auto.pages.pages.requirements.feature-list.index.183':
    '未生成可保存的要件項目',
  'auto.pages.pages.requirements.feature-list.index.184': '一括分解失敗: {p1}',
  'auto.pages.pages.requirements.feature-list.index.185':
    '一括分解完了: 成功 {p1} 件, 失敗 {p2} 件',
  'auto.pages.pages.requirements.feature-list.index.186':
    '要件一覧情報が不足しています',
  'auto.pages.pages.requirements.feature-list.index.187':
    '已削除 {p1} 个要件項目（含下位）',
  'auto.pages.pages.requirements.feature-list.index.188': '削除要件項目失敗:',
  'auto.pages.pages.requirements.feature-list.index.189': '削除要件項目失敗',
  'auto.pages.pages.requirements.feature-list.index.190': '削除「{p1}」？',
  'auto.pages.pages.requirements.feature-list.index.191':
    '将同时削除该件及其所有下位要件項目, 削除后元に戻せません.',
  'auto.pages.pages.requirements.feature-list.index.192': '削除',
  'auto.pages.pages.requirements.feature-list.index.193': 'キャンセル',
  'auto.pages.pages.requirements.feature-list.index.194': '機能类型:',
  'auto.pages.pages.requirements.feature-list.index.195': '複雑度: L',
  'auto.pages.pages.requirements.feature-list.index.196': '見積工数:',
  'auto.pages.pages.requirements.feature-list.index.197': '先頭へ',
  'auto.pages.pages.requirements.feature-list.index.198': '上へ',
  'auto.pages.pages.requirements.feature-list.index.199': '下へ',
  'auto.pages.pages.requirements.feature-list.index.200': '末尾へ',
  'auto.pages.pages.requirements.feature-list.index.201': '削除',
  'auto.pages.pages.requirements.feature-list.index.202': '評価',
  'auto.pages.pages.requirements.feature-list.index.203': '下方插入',
  'auto.pages.pages.requirements.feature-list.index.204': '分解',
  'auto.pages.pages.requirements.feature-list.index.205': '機能一覧',
  'auto.pages.pages.requirements.feature-list.index.206':
    '分析プロジェクト的機能要件和实现方案, 通过层级分解确保機能覆盖完整',
  'auto.pages.pages.requirements.feature-list.index.207': '选择機能一覧',
  'auto.pages.pages.requirements.feature-list.index.208': '作成一覧',
  'auto.pages.pages.requirements.feature-list.index.209': 'モジュール数:',
  'auto.pages.pages.requirements.feature-list.index.210': '待分解モジュール:',
  'auto.pages.pages.requirements.feature-list.index.211': '機能数:',
  'auto.pages.pages.requirements.feature-list.index.212': '待分解機能:',
  'auto.pages.pages.requirements.feature-list.index.213': '機能ポイント数:',
  'auto.pages.pages.requirements.feature-list.index.214': '待評価機能ポイント:',
  'auto.pages.pages.requirements.feature-list.index.215': '見積工数:',
  'auto.pages.pages.requirements.feature-list.index.216':
    '口径: 仅统计機能ポイント工数',
  'auto.pages.pages.requirements.feature-list.index.217': '选择見積基準',
  'auto.pages.pages.requirements.feature-list.index.218': '[デフォルト]',
  'auto.pages.pages.requirements.feature-list.index.219': '一括評価',
  'auto.pages.pages.requirements.feature-list.index.220':
    '先に一覧を作成してください',
  'auto.pages.pages.requirements.feature-list.index.221': '分解開始',
  'auto.pages.pages.requirements.feature-list.index.222': '確認クリア',
  'auto.pages.pages.requirements.feature-list.index.223':
    '确定要クリア現在要件一覧的所有機能件吗？',
  'auto.pages.pages.requirements.feature-list.index.224':
    '已クリア所有機能要件項目',
  'auto.pages.pages.requirements.feature-list.index.225': 'クリア',
  'auto.pages.pages.requirements.feature-list.index.226': 'Excelインポート',
  'auto.pages.pages.requirements.feature-list.index.227': 'エクスポート Excel',
  'auto.pages.pages.requirements.feature-list.index.228': 'エクスポート Word',
  'auto.pages.pages.requirements.feature-list.index.229':
    'エクスポートマインドマップ',
  'auto.pages.pages.requirements.feature-list.index.230': 'エクスポート',
  'auto.pages.pages.requirements.feature-list.index.231': '編集一覧',
  'auto.pages.pages.requirements.feature-list.index.232': '削除一覧',
  'auto.pages.pages.requirements.feature-list.index.233': '削除一覧「{p1}」？',
  'auto.pages.pages.requirements.feature-list.index.234':
    '削除后元に戻せません, 请確認是否继续.',
  'auto.pages.pages.requirements.feature-list.index.235': '削除',
  'auto.pages.pages.requirements.feature-list.index.236': 'キャンセル',
  'auto.pages.pages.requirements.feature-list.index.237':
    '设置为デフォルト一覧',
  'auto.pages.pages.requirements.feature-list.index.238': '機能解析',
  'auto.pages.pages.requirements.feature-list.index.239':
    '現在プロジェクト还没有機能一覧',
  'auto.pages.pages.requirements.feature-list.index.240': '作成一覧',
  'auto.pages.pages.requirements.feature-list.index.241': '機能モジュール',
  'auto.pages.pages.requirements.feature-list.index.242':
    '確認クリアすべてモジュール？',
  'auto.pages.pages.requirements.feature-list.index.243': 'クリア',
  'auto.pages.pages.requirements.feature-list.index.244': 'さらに分解',
  'auto.pages.pages.requirements.feature-list.index.245': '一括分解',
  'auto.pages.pages.requirements.feature-list.index.246': '正在読み込み...',
  'auto.pages.pages.requirements.feature-list.index.247': '个サブ機能',
  'auto.pages.pages.requirements.feature-list.index.248':
    '現在还没有機能モジュール, 请点击“開始分解”',
  'auto.pages.pages.requirements.feature-list.index.249': 'さらに分解',
  'auto.pages.pages.requirements.feature-list.index.250': '機能',
  'auto.pages.pages.requirements.feature-list.index.251':
    'クリア本モジュール下機能',
  'auto.pages.pages.requirements.feature-list.index.252':
    '確認クリアモジュール「{p1}」下すべて機能？',
  'auto.pages.pages.requirements.feature-list.index.253': 'クリア所有機能',
  'auto.pages.pages.requirements.feature-list.index.254':
    '確認クリア全一覧所有機能？',
  'auto.pages.pages.requirements.feature-list.index.255': 'クリア',
  'auto.pages.pages.requirements.feature-list.index.256': 'さらに分解',
  'auto.pages.pages.requirements.feature-list.index.257': '一括分解',
  'auto.pages.pages.requirements.feature-list.index.258':
    '正在読み込み機能列表...',
  'auto.pages.pages.requirements.feature-list.index.259': '个機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.260':
    '現在モジュール暂无機能',
  'auto.pages.pages.requirements.feature-list.index.261':
    '请先选择機能モジュール',
  'auto.pages.pages.requirements.feature-list.index.262': 'さらに分解',
  'auto.pages.pages.requirements.feature-list.index.263': '機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.264':
    'クリア本機能下機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.265':
    '確認クリア機能「{p1}」下すべて機能ポイント？',
  'auto.pages.pages.requirements.feature-list.index.266':
    'クリア所有機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.267':
    '確認クリア全一覧所有機能ポイント？',
  'auto.pages.pages.requirements.feature-list.index.268': 'クリア',
  'auto.pages.pages.requirements.feature-list.index.269': '一括評価',
  'auto.pages.pages.requirements.feature-list.index.270':
    '正在読み込み機能ポイント列表...',
  'auto.pages.pages.requirements.feature-list.index.271':
    '現在機能暂无機能ポイント',
  'auto.pages.pages.requirements.feature-list.index.272':
    '先に機能を選択してください',
  'auto.pages.pages.requirements.feature-list.index.273': 'テーブルビュー',
  'auto.pages.pages.requirements.feature-list.index.274': 'マインドマップ',
  'auto.pages.pages.requirements.feature-list.index.275': '作成一覧',
  'auto.pages.pages.requirements.feature-list.index.276': '編集一覧',
  'auto.pages.pages.requirements.feature-list.index.277': '作成',
  'auto.pages.pages.requirements.feature-list.index.278': '保存',
  'auto.pages.pages.requirements.feature-list.index.279': '一覧名称',
  'auto.pages.pages.requirements.feature-list.index.280':
    '一覧名を入力してください',
  'auto.pages.pages.requirements.feature-list.index.281':
    '一覧名称不能超过 200 个字符',
  'auto.pages.pages.requirements.feature-list.index.282':
    '一覧名を入力してください',
  'auto.pages.pages.requirements.feature-list.index.283': 'バージョン',
  'auto.pages.pages.requirements.feature-list.index.284': '请输入バージョン',
  'auto.pages.pages.requirements.feature-list.index.285':
    'バージョン不能超过 50 个字符',
  'auto.pages.pages.requirements.feature-list.index.286': '例: 1.0.0',
  'auto.pages.pages.requirements.feature-list.index.287': '説明',
  'auto.pages.pages.requirements.feature-list.index.288':
    '一覧説明を入力してください',
  'auto.pages.pages.requirements.feature-list.index.289':
    'Excel インポート配置{p1}',
  'auto.pages.pages.requirements.feature-list.index.290': 'インポート中...',
  'auto.pages.pages.requirements.feature-list.index.291': '確認インポート',
  'auto.pages.pages.requirements.feature-list.index.292': '無視前几行',
  'auto.pages.pages.requirements.feature-list.index.293': '请输入無視行数',
  'auto.pages.pages.requirements.feature-list.index.294':
    '第 N+1 行作为ヘッダー候选.現在总行数: {p1}',
  'auto.pages.pages.requirements.feature-list.index.295': 'モジュール列',
  'auto.pages.pages.requirements.feature-list.index.296':
    '请配置モジュール列マッピング',
  'auto.pages.pages.requirements.feature-list.index.297': '请选择モジュール列',
  'auto.pages.pages.requirements.feature-list.index.298': '機能列',
  'auto.pages.pages.requirements.feature-list.index.299':
    '機能列を選択してください（任意）',
  'auto.pages.pages.requirements.feature-list.index.300': '機能ポイント列',
  'auto.pages.pages.requirements.feature-list.index.301':
    '请选择機能ポイント列（任意）',
  'auto.pages.pages.requirements.feature-list.index.302': 'モジュール説明列',
  'auto.pages.pages.requirements.feature-list.index.303':
    '请选择モジュール説明列（任意）',
  'auto.pages.pages.requirements.feature-list.index.304': '機能説明列',
  'auto.pages.pages.requirements.feature-list.index.305':
    '请选择機能説明列（任意）',
  'auto.pages.pages.requirements.feature-list.index.306': '機能ポイント説明列',
  'auto.pages.pages.requirements.feature-list.index.307':
    '请选择機能ポイント説明列（任意）',
  'auto.pages.pages.requirements.feature-list.index.308':
    'ヘッダープレビュー（第',
  'auto.pages.pages.requirements.feature-list.index.309': '）',
  'auto.pages.pages.requirements.feature-list.index.310':
    '現在ヘッダー行为空, 調整してください無視行数',
  'auto.pages.pages.requirements.feature-list.index.311':
    'マッピング后プレビュー（最多 8 行）',
  'auto.pages.pages.requirements.feature-list.index.312':
    '正在解析プレビュー...',
  'auto.pages.pages.requirements.feature-list.index.313':
    '配置マッピング后将显示プレビュー',
  'auto.pages.pages.requirements.feature-list.index.314': '一括工数見積もり',
  'auto.pages.pages.requirements.feature-list.index.315': '評価中...',
  'auto.pages.pages.requirements.feature-list.index.316': '開始評価',
  'auto.pages.pages.requirements.feature-list.index.317': '見積基準',
  'auto.pages.pages.requirements.feature-list.index.318':
    '見積基準を選択してください',
  'auto.pages.pages.requirements.feature-list.index.319': '[デフォルト]',
  'auto.pages.pages.requirements.feature-list.index.320':
    '見積基準を選択してください',
  'auto.pages.pages.requirements.feature-list.index.321': '見積範囲',
  'auto.pages.pages.requirements.feature-list.index.322':
    '評価範囲を選択してください',
  'auto.pages.pages.requirements.feature-list.index.323':
    '一覧内の全リーフ項目',
  'auto.pages.pages.requirements.feature-list.index.324':
    '現在のモジュールサブツリー',
  'auto.pages.pages.requirements.feature-list.index.325':
    '現在の機能サブツリー',
  'auto.pages.pages.requirements.feature-list.index.326':
    '工数未入力項目のみ見積',
  'auto.pages.pages.requirements.feature-list.index.327': '評価ヒント',
  'auto.pages.pages.requirements.feature-list.index.328':
    '任意: 输入本次評価偏好, 例如优先稳定性、降低复杂度、强调后端性能等',
  'auto.pages.pages.requirements.feature-list.index.329': '進捗:',
  'auto.pages.pages.requirements.feature-list.index.330': ', 成功',
  'auto.pages.pages.requirements.feature-list.index.331': ', 失敗',
  'auto.pages.pages.requirements.feature-list.index.332': ',',
  'auto.pages.pages.requirements.feature-list.index.333': '処理中:',
  'auto.pages.pages.requirements.feature-list.index.334':
    '正在后台逐件評価, 完了数量将在タスク終了后更新',
  'auto.pages.pages.requirements.feature-list.index.335': '下に要件項目を挿入',
  'auto.pages.pages.requirements.feature-list.index.336': 'タイトル',
  'auto.pages.pages.requirements.feature-list.index.337': '请输入タイトル',
  'auto.pages.pages.requirements.feature-list.index.338':
    '请输入要件項目タイトル',
  'auto.pages.pages.requirements.feature-list.index.339': '説明',
  'auto.pages.pages.requirements.feature-list.index.340':
    '要件項目説明を入力してください',
  'auto.pages.pages.requirements.feature-list.index.341': '意味タイプ',
  'auto.pages.pages.requirements.feature-list.index.342': '请选择意味タイプ',
  'auto.pages.pages.requirements.feature-list.index.343':
    '请选择機能ポイント技术类型',
  'auto.pages.pages.requirements.feature-list.index.344': '複雑度レベル（1-5）',
  'auto.pages.pages.requirements.feature-list.index.345': '見積工数（小时）',
  'auto.pages.pages.requirements.feature-list.index.346': '実績工数（小时）',
  'auto.pages.pages.requirements.feature-list.index.347': 'タスク分解',
  'auto.pages.pages.requirements.feature-list.index.348':
    '按タスク分解大致实现逻辑, 例如: 1) 搭建接口 2) 完了页面联调 3) 回归测试',
  'auto.pages.pages.requirements.feature-list.index.349': '一括分解設定 - {p1}',
  'auto.pages.pages.requirements.feature-list.index.350': '機能モジュール列',
  'auto.pages.pages.requirements.feature-list.index.351': '機能列',
  'auto.pages.pages.requirements.feature-list.index.352': '执行中...',
  'auto.pages.pages.requirements.feature-list.index.353': '完了并閉じる',
  'auto.pages.pages.requirements.feature-list.index.354': '開始一括分解',
  'auto.pages.pages.requirements.feature-list.index.355': '分解モード',
  'auto.pages.pages.requirements.feature-list.index.356': 'A、尽可能多',
  'auto.pages.pages.requirements.feature-list.index.357': 'B、指定数量',
  'auto.pages.pages.requirements.feature-list.index.358':
    'デフォルト分解的要件数量',
  'auto.pages.pages.requirements.feature-list.index.359':
    '分解数を入力してください',
  'auto.pages.pages.requirements.feature-list.index.360': '分解ヒント',
  'auto.pages.pages.requirements.feature-list.index.361':
    '任意: 给一括分解一个通用ヒント',
  'auto.pages.pages.requirements.feature-list.index.362':
    '例: 优先覆盖核心业务流程和关键异常场景',
  'auto.pages.pages.requirements.feature-list.index.363': '機能列分解範囲',
  'auto.pages.pages.requirements.feature-list.index.364':
    '将遍历所有モジュール下的機能件进行一括分解',
  'auto.pages.pages.requirements.feature-list.index.365':
    '仅分解現在选中モジュール下的機能件',
  'auto.pages.pages.requirements.feature-list.index.366':
    '現在のモジュール機能',
  'auto.pages.pages.requirements.feature-list.index.367': '全プロジェクト機能',
  'auto.pages.pages.requirements.feature-list.index.368':
    '本プロジェクト要件概要を参照する',
  'auto.pages.pages.requirements.feature-list.index.369':
    '是否同名要件を上書き',
  'auto.pages.pages.requirements.feature-list.index.370':
    '子項目のない要件のみ分解する',
  'auto.pages.pages.requirements.feature-list.index.371': '進捗:',
  'auto.pages.pages.requirements.feature-list.index.372': ', 成功',
  'auto.pages.pages.requirements.feature-list.index.373': ', 失敗',
  'auto.pages.pages.requirements.feature-list.index.374': '処理中:',
  'auto.pages.pages.requirements.feature-list.index.375': '要件項目を編集',
  'auto.pages.pages.requirements.feature-list.index.376': 'タイトル',
  'auto.pages.pages.requirements.feature-list.index.377': '请输入タイトル',
  'auto.pages.pages.requirements.feature-list.index.378':
    '请输入要件項目タイトル',
  'auto.pages.pages.requirements.feature-list.index.379': '説明',
  'auto.pages.pages.requirements.feature-list.index.380':
    '要件項目説明を入力してください',
  'auto.pages.pages.requirements.feature-list.index.381': '意味タイプ',
  'auto.pages.pages.requirements.feature-list.index.382': '请选择意味タイプ',
  'auto.pages.pages.requirements.feature-list.index.383':
    '请选择機能ポイント技术类型',
  'auto.pages.pages.requirements.feature-list.index.384': '複雑度レベル（1-5）',
  'auto.pages.pages.requirements.feature-list.index.385': '見積工数（小时）',
  'auto.pages.pages.requirements.feature-list.index.386': '実績工数（小时）',
  'auto.pages.pages.requirements.feature-list.index.387': 'タスク分解',
  'auto.pages.pages.requirements.feature-list.index.388':
    '按タスク分解大致实现逻辑, 例如: 1) 搭建接口 2) 完了页面联调 3) 回归测试',
  'auto.pages.pages.requirements.feature-list.index.389': 'AI智能分解',
  'auto.pages.pages.requirements.feature-list.index.390': 'キャンセル',
  'auto.pages.pages.requirements.feature-list.index.391': '同名要件を上書き',
  'auto.pages.pages.requirements.feature-list.index.392': '確認適用 (',
  'auto.pages.pages.requirements.feature-list.index.393': '分解パラメータ',
  'auto.pages.pages.requirements.feature-list.index.394': '現在プロジェクト',
  'auto.pages.pages.requirements.feature-list.index.395': 'プロジェクト名称',
  'auto.pages.pages.requirements.feature-list.index.396': 'プロジェクト简介',
  'auto.pages.pages.requirements.feature-list.index.397':
    'プロジェクト情報を保存',
  'auto.pages.pages.requirements.feature-list.index.398': '分解モード',
  'auto.pages.pages.requirements.feature-list.index.399': 'A、尽可能多',
  'auto.pages.pages.requirements.feature-list.index.400': 'B、指定数量',
  'auto.pages.pages.requirements.feature-list.index.401': 'C、人工录入',
  'auto.pages.pages.requirements.feature-list.index.402': '分解数量',
  'auto.pages.pages.requirements.feature-list.index.403':
    '分解数を入力してください',
  'auto.pages.pages.requirements.feature-list.index.404':
    '人工录入（每行一个下位）',
  'auto.pages.pages.requirements.feature-list.index.405':
    '少なくとも1行入力してください',
  'auto.pages.pages.requirements.feature-list.index.406':
    '例: \\n用户画像\\n标签管理\\n客户分群',
  'auto.pages.pages.requirements.feature-list.index.407': '分解ヒント',
  'auto.pages.pages.requirements.feature-list.index.408':
    '任意: 提供额外的分解指导, 帮助AI更好地理解要件',
  'auto.pages.pages.requirements.feature-list.index.409':
    '例: 重点关注用户交互、数据流程、业务规则等',
  'auto.pages.pages.requirements.feature-list.index.410':
    '参考本プロジェクト要件概要',
  'auto.pages.pages.requirements.feature-list.index.411': '入力結果を追加',
  'auto.pages.pages.requirements.feature-list.index.412': '分解開始',
  'auto.pages.pages.requirements.feature-list.index.413': '入力を追加',
  'auto.pages.pages.requirements.feature-list.index.414': 'さらに分解',
  'auto.pages.pages.requirements.feature-list.index.415':
    '再分解が完了しました',
  'auto.pages.pages.requirements.feature-list.index.416': '重新分解',
  'auto.pages.pages.requirements.feature-list.index.417': '分解结果',
  'auto.pages.pages.requirements.feature-list.index.418': '合計',
  'auto.pages.pages.requirements.feature-list.index.419': '件',
  'auto.pages.pages.requirements.feature-list.index.420': ':',
  'auto.pages.pages.requirements.feature-list.index.421': '複雑度: L',
  'auto.pages.pages.requirements.feature-list.index.422':
    '点击“分解開始”生成结果',
  'auto.pages.pages.requirements.overview.index.1': 'SaaS 管理系统',
  'auto.pages.pages.requirements.overview.index.2':
    '适用于中后台管理、工作流与权限协同类系统',
  'auto.pages.pages.requirements.overview.index.3':
    '# 要件概要\\n\\n## プロジェクト背景与目标\\n### 业务背景\\n### 核心目标\\n### 成功指标\\n\\n## 範囲定义\\n### 本期範囲（In 範囲）\\n### 非本期範囲（Out of 範囲）\\n### 边界与约束\\n\\n## 用户与场景\\n### 角色定义\\n### 关键业务场景\\n### 核心用户旅程\\n\\n## 機能要件概要\\n### 核心機能モジュール\\n### 关键流程说明\\n### 异常与兜底策略\\n\\n## 非機能要件\\n### 性能与容量\\n### 安全与权限\\n### 可用性与可观测性\\n\\n## 依赖与风险\\n### 外部依赖\\n### 主要风险\\n### 风险应对策略\\n\\n## 里程碑与验收\\n### 阶段规划\\n### 验收标准',
  'auto.pages.pages.requirements.overview.index.4': '移动適用产品',
  'auto.pages.pages.requirements.overview.index.5':
    '适用于 App、小程序、移动端服务类产品',
  'auto.pages.pages.requirements.overview.index.6':
    '# 要件概要\\n\\n## 产品定位\\n### 目标用户\\n### 核心价值主张\\n### 竞品与差异化\\n\\n## 业务範囲\\n### MVP 範囲\\n### 版本演进规划\\n### 不做件说明\\n\\n## 核心体验流程\\n### 首次使用流程\\n### 高频タスク路径\\n### 关键转化路径\\n\\n## 機能要件概要\\n### 账户与身份\\n### 内容/服务主流程\\n### 消息与提醒\\n\\n## 质量与技术要求\\n### 启动与响应性能\\n### 弱网与离线策略\\n### 终端兼容性\\n\\n## 商业与运营约束\\n### 转化与留存指标\\n### 增长与活动支持\\n### 合规要求\\n\\n## 发布与验收\\n### 发布节奏\\n### 验收口径',
  'auto.pages.pages.requirements.overview.index.7': '/',
  'auto.pages.pages.requirements.overview.index.8':
    '适用于数据采集、建模、分析与报表平台',
  'auto.pages.pages.requirements.overview.index.9':
    '# 要件概要\\n\\n## 建设目标\\n### 业务问题定义\\n### 数据化目标\\n### 指标体系範囲\\n\\n## 数据範囲与边界\\n### 数据源与采集範囲\\n### 数据时效要求\\n### 数据质量边界\\n\\n## 核心能力要件\\n### 数据接入与处理\\n### 指标建模与口径管理\\n### 查询分析与可视化\\n\\n## 用户与使用场景\\n### 分析师场景\\n### 业务方场景\\n### 管理层场景\\n\\n## 非機能要件\\n### 数据准确性与一致性\\n### 性能与成本控制\\n### 权限与数据安全\\n\\n## 风险与依赖\\n### 上游系统依赖\\n### 口径争议风险\\n### 上线风险与预案\\n\\n## 里程碑与验收\\n### 交付阶段\\n### 验收标准',
  'auto.pages.pages.requirements.overview.index.109': '产品构思',
  'auto.pages.pages.requirements.overview.index.110':
    '适用于新产品方向探索与概念设计阶段',
  'auto.pages.pages.requirements.overview.index.111':
    '# 产品构思\\n\\n## 产品基本説明\\n### 产品定位\\n### 目标用户\\n### 用户痛点与要件\\n\\n## 核心機能\\n### 核心機能一覧\\n### 关键用户流程\\n### MVP 機能边界\\n\\n## 核心创新点\\n### 创新能力说明\\n### 差异化价值\\n### 可验证假设与验证方式\\n\\n## 商业与落地\\n### 商业模式初步设想\\n### 资源与实施约束\\n### 阶段目标与里程碑',
  'auto.pages.pages.requirements.overview.index.10':
    '你好, 我可以和你讨论現在概要内容.\\n切到 Agent 模式后, 我会在讨论后直接修改正文.',
  'auto.pages.pages.requirements.overview.index.11': '先に 保存 開始',
  'auto.pages.pages.requirements.overview.index.12':
    '对话失敗, 请稍再試行してください',
  'auto.pages.pages.requirements.overview.index.13':
    '调用对话接口失敗, 请检查后端服务与登录ステータス.',
  'auto.pages.pages.requirements.overview.index.14': '已撤销上一次 Agent 修改.',
  'auto.pages.pages.requirements.overview.index.15':
    '全屏切替失敗, 请检查浏览器权限',
  'auto.pages.pages.requirements.overview.index.16': '重置',
  'auto.pages.pages.requirements.overview.index.17': '保存版本',
  'auto.pages.pages.requirements.overview.index.18': '保存',
  'auto.pages.pages.requirements.overview.index.19': '折叠左侧大纲',
  'auto.pages.pages.requirements.overview.index.20': '展开左侧大纲',
  'auto.pages.pages.requirements.overview.index.21': '大纲',
  'auto.pages.pages.requirements.overview.index.22': '折叠右侧对话',
  'auto.pages.pages.requirements.overview.index.23': '展开右侧对话',
  'auto.pages.pages.requirements.overview.index.24': '对话',
  'auto.pages.pages.requirements.overview.index.25': '一键Zen',
  'auto.pages.pages.requirements.overview.index.26': '退出全屏',
  'auto.pages.pages.requirements.overview.index.27': '全屏',
  'auto.pages.pages.requirements.overview.index.28': '大纲',
  'auto.pages.pages.requirements.overview.index.29': '展开',
  'auto.pages.pages.requirements.overview.index.30': '折叠',
  'auto.pages.pages.requirements.overview.index.31':
    '暂无タイトル, 输入 # / ## / ### 生成大纲',
  'auto.pages.pages.requirements.overview.index.32': '对话',
  'auto.pages.pages.requirements.overview.index.33': '讨论',
  'auto.pages.pages.requirements.overview.index.34': '你',
  'auto.pages.pages.requirements.overview.index.35': '讨论助手',
  'auto.pages.pages.requirements.overview.index.36': '...',
  'auto.pages.pages.requirements.overview.index.37': '（ , ）',
  'auto.pages.pages.requirements.overview.index.38':
    '输入要件（将自动修改正文）',
  'auto.pages.pages.requirements.overview.index.39': '撤销Agent修改',
  'auto.pages.pages.requirements.overview.index.40': '发送',
  'auto.pages.pages.requirements.overview.index.41':
    '# 要件概要\\n\\n## 目标\\n- 建立プロジェクト级管理工作台\\n\\n## 範囲\\n- プロジェクト列表\\n- プロジェクト详情与菜单\\n\\n## 风险\\n- 外部系统接口待联调',
  'auto.pages.pages.requirements.overview.index.42': '読み込み概要要件失敗',
  'auto.pages.pages.requirements.overview.index.43': '请先选择プロジェクト',
  'auto.pages.pages.requirements.overview.index.44': '请输入概要内容',
  'auto.pages.pages.requirements.overview.index.45': '先に 作成 要件',
  'auto.pages.pages.requirements.overview.index.46': '概要已更新',
  'auto.pages.pages.requirements.overview.index.47': '保存概要要件失敗',
  'auto.pages.pages.requirements.overview.index.48': '请先选择プロジェクト',
  'auto.pages.pages.requirements.overview.index.49':
    '要件概要已作成并关联到現在プロジェクト',
  'auto.pages.pages.requirements.overview.index.50': '作成要件概要失敗',
  'auto.pages.pages.requirements.overview.index.51': '概要已削除',
  'auto.pages.pages.requirements.overview.index.52': '削除概要要件失敗',
  'auto.pages.pages.requirements.overview.index.53': '已重置到最近保存内容',
  'auto.pages.pages.requirements.overview.index.54': '版本快照已保存',
  'auto.pages.pages.requirements.overview.index.55': '请先选择プロジェクト',
  'auto.pages.pages.requirements.overview.index.56': '请先选择プロジェクト',
  'auto.pages.pages.requirements.overview.index.57':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.overview.index.58': '请选择或输入模板内容',
  'auto.pages.pages.requirements.overview.index.59':
    '未生成有效内容, 調整してくださいヒント信息再試行してください',
  'auto.pages.pages.requirements.overview.index.60': '已生成概要下書き{p1}',
  'auto.pages.pages.requirements.overview.index.61':
    'AI生成失敗, 请稍再試行してください',
  'auto.pages.pages.requirements.overview.index.62': '请先选择プロジェクト',
  'auto.pages.pages.requirements.overview.index.63':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.overview.index.64': 'プロジェクト信息已保存',
  'auto.pages.pages.requirements.overview.index.65':
    'プロジェクト情報を保存に失敗しました',
  'auto.pages.pages.requirements.overview.index.66': '要件概要',
  'auto.pages.pages.requirements.overview.index.67':
    '先形成粗粒度 Markdown 文档, 用于確認方向与範囲',
  'auto.pages.pages.requirements.overview.index.68': 'AI',
  'auto.pages.pages.requirements.overview.index.69': '作成要件概要',
  'auto.pages.pages.requirements.overview.index.70': '削除確認現在概要？',
  'auto.pages.pages.requirements.overview.index.71': '削除概要',
  'auto.pages.pages.requirements.overview.index.72': '概要文档信息',
  'auto.pages.pages.requirements.overview.index.73': '系统录入',
  'auto.pages.pages.requirements.overview.index.74': '暂无',
  'auto.pages.pages.requirements.overview.index.75': '自定义 Markdown',
  'auto.pages.pages.requirements.overview.index.76': '尚未作成概要',
  'auto.pages.pages.requirements.overview.index.77': '已保存',
  'auto.pages.pages.requirements.overview.index.78': '未作成',
  'auto.pages.pages.requirements.overview.index.79': '来源',
  'auto.pages.pages.requirements.overview.index.80': '模板',
  'auto.pages.pages.requirements.overview.index.81': '负责人',
  'auto.pages.pages.requirements.overview.index.82': 'バージョン',
  'auto.pages.pages.requirements.overview.index.83': 'ステータス',
  'auto.pages.pages.requirements.overview.index.84': '未作成',
  'auto.pages.pages.requirements.overview.index.85': '更新时间',
  'auto.pages.pages.requirements.overview.index.86': 'AI',
  'auto.pages.pages.requirements.overview.index.87': 'プロジェクト名',
  'auto.pages.pages.requirements.overview.index.88':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.overview.index.89': 'プロジェクト概要',
  'auto.pages.pages.requirements.overview.index.90':
    'プロジェクト概要を入力してください',
  'auto.pages.pages.requirements.overview.index.91':
    'ヒント信息（用于辅助生成）',
  'auto.pages.pages.requirements.overview.index.92':
    '例: 重点补充权限模型、外部系统依赖与验收标准',
  'auto.pages.pages.requirements.overview.index.93': 'プロジェクト情報を保存',
  'auto.pages.pages.requirements.overview.index.94': 'キャンセル',
  'auto.pages.pages.requirements.overview.index.95': '生成',
  'auto.pages.pages.requirements.overview.index.96': '概要要件模板',
  'auto.pages.pages.requirements.overview.index.97':
    '模板大纲（Markdown, 可編集）',
  'auto.pages.pages.requirements.overview.index.98': '请选择模板后可直接編集',
  'auto.pages.pages.requirements.overview.index.99': 'Markdown 概要',
  'auto.pages.pages.requirements.overview.index.100':
    '現在プロジェクト还没有要件概要',
  'auto.pages.pages.requirements.overview.index.101': '作成要件概要',
  'auto.pages.pages.requirements.overview.index.102': '保存并更新',
  'auto.pages.pages.requirements.overview.index.103': '作成概要',
  'auto.pages.pages.requirements.overview.index.104': '重置',
  'auto.pages.pages.requirements.overview.index.105': '概要内容',
  'auto.pages.pages.requirements.overview.index.106': '请输入概要内容',
  'auto.pages.pages.requirements.overview.index.107':
    '请输入概要内容（支持段落、列表、代码块等）',
  'auto.pages.pages.requirements.overview.index.108':
    '可基于模板自动生成初稿, 再人工修订.現在内容将与后端的概要要件エンティティ同步.',
  'auto.pages.pages.requirements.requirement-pool.index.1': '客户访谈',
  'auto.pages.pages.requirements.requirement-pool.index.2': '产品评审',
  'auto.pages.pages.requirements.requirement-pool.index.3': '运营反馈',
  'auto.pages.pages.requirements.requirement-pool.index.4': '销售反馈',
  'auto.pages.pages.requirements.requirement-pool.index.5': '研发建议',
  'auto.pages.pages.requirements.requirement-pool.index.6': '内部优化',
  'auto.pages.pages.requirements.requirement-pool.index.7': 'AI',
  'auto.pages.pages.requirements.requirement-pool.index.8': '高',
  'auto.pages.pages.requirements.requirement-pool.index.9': '中',
  'auto.pages.pages.requirements.requirement-pool.index.10': '低',
  'auto.pages.pages.requirements.requirement-pool.index.11': '待評価',
  'auto.pages.pages.requirements.requirement-pool.index.12': '待处理',
  'auto.pages.pages.requirements.requirement-pool.index.13': '評価中',
  'auto.pages.pages.requirements.requirement-pool.index.14': '已纳入',
  'auto.pages.pages.requirements.requirement-pool.index.15': '已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.16': '编号',
  'auto.pages.pages.requirements.requirement-pool.index.17': '要件項目',
  'auto.pages.pages.requirements.requirement-pool.index.18': '来源',
  'auto.pages.pages.requirements.requirement-pool.index.19': '提出人',
  'auto.pages.pages.requirements.requirement-pool.index.20': '价值評価',
  'auto.pages.pages.requirements.requirement-pool.index.21': '处理ステータス',
  'auto.pages.pages.requirements.requirement-pool.index.22': '更新时间',
  'auto.pages.pages.requirements.requirement-pool.index.23': '作成时间',
  'auto.pages.pages.requirements.requirement-pool.index.24': '操作',
  'auto.pages.pages.requirements.requirement-pool.index.25': '标记为已纳入',
  'auto.pages.pages.requirements.requirement-pool.index.26': '标记为已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.27': '标记为評価中',
  'auto.pages.pages.requirements.requirement-pool.index.28': '編集',
  'auto.pages.pages.requirements.requirement-pool.index.29':
    '削除確認该要件項目？',
  'auto.pages.pages.requirements.requirement-pool.index.30': '削除后无法恢复',
  'auto.pages.pages.requirements.requirement-pool.index.31': '削除',
  'auto.pages.pages.requirements.requirement-pool.index.32': 'キャンセル',
  'auto.pages.pages.requirements.requirement-pool.index.33': '削除中...',
  'auto.pages.pages.requirements.requirement-pool.index.34':
    '削除に失敗しました',
  'auto.pages.pages.requirements.requirement-pool.index.35': '削除しました',
  'auto.pages.pages.requirements.requirement-pool.index.36': '削除',
  'auto.pages.pages.requirements.requirement-pool.index.37': '...',
  'auto.pages.pages.requirements.requirement-pool.index.38':
    '更新に失敗しました',
  'auto.pages.pages.requirements.requirement-pool.index.39': 'ステータス已更新',
  'auto.pages.pages.requirements.requirement-pool.index.40': '更多',
  'auto.pages.pages.requirements.requirement-pool.index.41': 'すべて ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.42': '({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.43': '評価中 ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.44': '({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.45': '({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.46': '先に 要件項目',
  'auto.pages.pages.requirements.requirement-pool.index.47': '一括处理失敗',
  'auto.pages.pages.requirements.requirement-pool.index.48':
    '已处理 {p1} 条要件',
  'auto.pages.pages.requirements.requirement-pool.index.49': '確認一括{p1}？',
  'auto.pages.pages.requirements.requirement-pool.index.50':
    '本次将处理 {p1} 条要件',
  'auto.pages.pages.requirements.requirement-pool.index.51': '確認',
  'auto.pages.pages.requirements.requirement-pool.index.52': 'キャンセル',
  'auto.pages.pages.requirements.requirement-pool.index.53': '要件池',
  'auto.pages.pages.requirements.requirement-pool.index.54':
    '快速记录候选要件, 完了評価、清洗与纳入决策',
  'auto.pages.pages.requirements.requirement-pool.index.55': '关键词',
  'auto.pages.pages.requirements.requirement-pool.index.56':
    'タイトル/要件池编号/提出人',
  'auto.pages.pages.requirements.requirement-pool.index.57': '要件来源',
  'auto.pages.pages.requirements.requirement-pool.index.58': '请选择',
  'auto.pages.pages.requirements.requirement-pool.index.59': '价值評価',
  'auto.pages.pages.requirements.requirement-pool.index.60': '请选择',
  'auto.pages.pages.requirements.requirement-pool.index.61': '处理ステータス',
  'auto.pages.pages.requirements.requirement-pool.index.62': '请选择',
  'auto.pages.pages.requirements.requirement-pool.index.63': '重置',
  'auto.pages.pages.requirements.requirement-pool.index.64': '查询',
  'auto.pages.pages.requirements.requirement-pool.index.65': '收起',
  'auto.pages.pages.requirements.requirement-pool.index.66': '展开',
  'auto.pages.pages.requirements.requirement-pool.index.67': '刷新',
  'auto.pages.pages.requirements.requirement-pool.index.68': '标记为評価中',
  'auto.pages.pages.requirements.requirement-pool.index.69': '一括評価',
  'auto.pages.pages.requirements.requirement-pool.index.70': '标记为已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.71': '一括清洗',
  'auto.pages.pages.requirements.requirement-pool.index.72': '新增',
  'auto.pages.pages.requirements.requirement-pool.index.73': '已选择',
  'auto.pages.pages.requirements.requirement-pool.index.74': '件',
  'auto.pages.pages.requirements.requirement-pool.index.75': 'クリア选择',
  'auto.pages.pages.requirements.requirement-pool.index.76': '标记为已纳入',
  'auto.pages.pages.requirements.requirement-pool.index.77': '一括纳入',
  'auto.pages.pages.requirements.requirement-pool.index.78': '标记为已清洗',
  'auto.pages.pages.requirements.requirement-pool.index.79': '一括清洗',
  'auto.pages.pages.requirements.requirement-pool.index.80': '合計 {p1} 条',
  'auto.pages.pages.requirements.requirement-pool.index.81': '要件項目を編集',
  'auto.pages.pages.requirements.requirement-pool.index.82': '新增要件項目',
  'auto.pages.pages.requirements.requirement-pool.index.83': '内部优化',
  'auto.pages.pages.requirements.requirement-pool.index.84': '产品经理',
  'auto.pages.pages.requirements.requirement-pool.index.85': '保存',
  'auto.pages.pages.requirements.requirement-pool.index.86': 'キャンセル',
  'auto.pages.pages.requirements.requirement-pool.index.87':
    '保存に失敗しました',
  'auto.pages.pages.requirements.requirement-pool.index.88': '更新しました',
  'auto.pages.pages.requirements.requirement-pool.index.89': '新增成功',
  'auto.pages.pages.requirements.requirement-pool.index.90': '要件項目',
  'auto.pages.pages.requirements.requirement-pool.index.91':
    '请输入要件タイトル',
  'auto.pages.pages.requirements.requirement-pool.index.92': '请输入要件項目',
  'auto.pages.pages.requirements.requirement-pool.index.93': '要件来源',
  'auto.pages.pages.requirements.requirement-pool.index.94': '请选择要件来源',
  'auto.pages.pages.requirements.requirement-pool.index.95': '提出人',
  'auto.pages.pages.requirements.requirement-pool.index.96': '请输入提出人',
  'auto.pages.pages.requirements.requirement-pool.index.97': '请输入提出人',
  'auto.pages.pages.requirements.requirement-pool.index.98': '价值評価',
  'auto.pages.pages.requirements.requirement-pool.index.99': '请选择价值評価',
  'auto.pages.pages.requirements.requirement-pool.index.100': '处理ステータス',
  'auto.pages.pages.requirements.requirement-pool.index.101':
    '请选择处理ステータス',
  'auto.pages.pages.requirements.requirement-pool.index.102': '备注',
  'auto.pages.pages.requirements.requirement-pool.index.103':
    '补充評価结论或上下文',
  'auto.pages.pages.requirements.role-analysis.index.1': '未命名プロジェクト',
  'auto.pages.pages.requirements.role-analysis.index.2': '読み込み角色分析失敗',
  'auto.pages.pages.requirements.role-analysis.index.3':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.role-analysis.index.4':
    'プロジェクト信息已保存',
  'auto.pages.pages.requirements.role-analysis.index.5':
    'プロジェクト情報を保存に失敗しました',
  'auto.pages.pages.requirements.role-analysis.index.6':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.role-analysis.index.7':
    'AI 生成完了（参考機能件 {p1} 条）, 選択してください后添加',
  'auto.pages.pages.requirements.role-analysis.index.8': 'AI 生成失敗',
  'auto.pages.pages.requirements.role-analysis.index.9':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.role-analysis.index.10':
    '请先勾选プレビュー角色',
  'auto.pages.pages.requirements.role-analysis.index.11':
    '已添加并保存 {p1} 个角色',
  'auto.pages.pages.requirements.role-analysis.index.12': '添加失敗',
  'auto.pages.pages.requirements.role-analysis.index.13':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.role-analysis.index.14': '保存しました',
  'auto.pages.pages.requirements.role-analysis.index.15': '保存に失敗しました',
  'auto.pages.pages.requirements.role-analysis.index.16':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.role-analysis.index.17': '已クリア角色数据',
  'auto.pages.pages.requirements.role-analysis.index.18':
    'クリアに失敗しました',
  'auto.pages.pages.requirements.role-analysis.index.19': '未入力',
  'auto.pages.pages.requirements.role-analysis.index.20': '角色',
  'auto.pages.pages.requirements.role-analysis.index.21': '未入力',
  'auto.pages.pages.requirements.role-analysis.index.22': '职责',
  'auto.pages.pages.requirements.role-analysis.index.23': '核心诉求',
  'auto.pages.pages.requirements.role-analysis.index.24': '关注機能範囲',
  'auto.pages.pages.requirements.role-analysis.index.25': '产出交付物',
  'auto.pages.pages.requirements.role-analysis.index.26': '人名',
  'auto.pages.pages.requirements.role-analysis.index.27': '汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.28': '操作',
  'auto.pages.pages.requirements.role-analysis.index.29': '編集',
  'auto.pages.pages.requirements.role-analysis.index.30': '削除確認该角色吗？',
  'auto.pages.pages.requirements.role-analysis.index.31': '確認',
  'auto.pages.pages.requirements.role-analysis.index.32': 'キャンセル',
  'auto.pages.pages.requirements.role-analysis.index.33': '削除',
  'auto.pages.pages.requirements.role-analysis.index.34': 'クリア重置',
  'auto.pages.pages.requirements.role-analysis.index.35': '角色',
  'auto.pages.pages.requirements.role-analysis.index.36': '未入力',
  'auto.pages.pages.requirements.role-analysis.index.37': '职责',
  'auto.pages.pages.requirements.role-analysis.index.38': '核心诉求',
  'auto.pages.pages.requirements.role-analysis.index.39': '关注機能範囲',
  'auto.pages.pages.requirements.role-analysis.index.40': '产出交付物',
  'auto.pages.pages.requirements.role-analysis.index.41': '角色分析',
  'auto.pages.pages.requirements.role-analysis.index.42': 'プロジェクト: {p1}',
  'auto.pages.pages.requirements.role-analysis.index.43': '关键字',
  'auto.pages.pages.requirements.role-analysis.index.44':
    '角色/职责/诉求/機能/交付物',
  'auto.pages.pages.requirements.role-analysis.index.45': '角色名称',
  'auto.pages.pages.requirements.role-analysis.index.46': '请输入角色名称',
  'auto.pages.pages.requirements.role-analysis.index.47': '对应人名',
  'auto.pages.pages.requirements.role-analysis.index.48': '请输入对应人名',
  'auto.pages.pages.requirements.role-analysis.index.49': '汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.50': '请输入汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.51': '职责关键字',
  'auto.pages.pages.requirements.role-analysis.index.52': '请输入职责关键字',
  'auto.pages.pages.requirements.role-analysis.index.53': '重置',
  'auto.pages.pages.requirements.role-analysis.index.54': '查询',
  'auto.pages.pages.requirements.role-analysis.index.55': '折叠',
  'auto.pages.pages.requirements.role-analysis.index.56': '展开',
  'auto.pages.pages.requirements.role-analysis.index.57': '({p1})',
  'auto.pages.pages.requirements.role-analysis.index.58': '({p1})',
  'auto.pages.pages.requirements.role-analysis.index.59': 'すべて({p1})',
  'auto.pages.pages.requirements.role-analysis.index.60': '刷新',
  'auto.pages.pages.requirements.role-analysis.index.61': '新增',
  'auto.pages.pages.requirements.role-analysis.index.62':
    '削除確認选中的 {p1} 条数据吗？',
  'auto.pages.pages.requirements.role-analysis.index.63': '確認',
  'auto.pages.pages.requirements.role-analysis.index.64': 'キャンセル',
  'auto.pages.pages.requirements.role-analysis.index.65': '一括削除（',
  'auto.pages.pages.requirements.role-analysis.index.66': 'AI',
  'auto.pages.pages.requirements.role-analysis.index.67': '保存',
  'auto.pages.pages.requirements.role-analysis.index.68':
    '確認クリア現在プロジェクト角色数据？',
  'auto.pages.pages.requirements.role-analysis.index.69': '確認',
  'auto.pages.pages.requirements.role-analysis.index.70': 'キャンセル',
  'auto.pages.pages.requirements.role-analysis.index.71': '更多',
  'auto.pages.pages.requirements.role-analysis.index.72':
    '暂无角色分析数据, 点击“新增”或“AI角色分析”開始',
  'auto.pages.pages.requirements.role-analysis.index.73': ':',
  'auto.pages.pages.requirements.role-analysis.index.74': '宽松',
  'auto.pages.pages.requirements.role-analysis.index.75': 'デフォルト',
  'auto.pages.pages.requirements.role-analysis.index.76': '紧凑',
  'auto.pages.pages.requirements.role-analysis.index.77': '列设置',
  'auto.pages.pages.requirements.role-analysis.index.78': '合計 {p1} 条',
  'auto.pages.pages.requirements.role-analysis.index.79': '編集角色',
  'auto.pages.pages.requirements.role-analysis.index.80': '新增角色',
  'auto.pages.pages.requirements.role-analysis.index.81': '确定',
  'auto.pages.pages.requirements.role-analysis.index.82': 'キャンセル',
  'auto.pages.pages.requirements.role-analysis.index.83': '角色名称',
  'auto.pages.pages.requirements.role-analysis.index.84': '请输入角色名称',
  'auto.pages.pages.requirements.role-analysis.index.85':
    '例: 产品经理、测试工程师',
  'auto.pages.pages.requirements.role-analysis.index.86': '职责',
  'auto.pages.pages.requirements.role-analysis.index.87': '请输入职责説明',
  'auto.pages.pages.requirements.role-analysis.index.88': '核心诉求',
  'auto.pages.pages.requirements.role-analysis.index.89': '关注機能範囲',
  'auto.pages.pages.requirements.role-analysis.index.90': '产出交付物',
  'auto.pages.pages.requirements.role-analysis.index.91': '对应人名',
  'auto.pages.pages.requirements.role-analysis.index.92': '例: 张三',
  'auto.pages.pages.requirements.role-analysis.index.93': '汇报对象',
  'auto.pages.pages.requirements.role-analysis.index.94':
    '例: プロジェクト总监',
  'auto.pages.pages.requirements.role-analysis.index.95': 'AI',
  'auto.pages.pages.requirements.role-analysis.index.96': '生成选件',
  'auto.pages.pages.requirements.role-analysis.index.97': 'プロジェクト名',
  'auto.pages.pages.requirements.role-analysis.index.98':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.role-analysis.index.99':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.role-analysis.index.100': 'プロジェクト概要',
  'auto.pages.pages.requirements.role-analysis.index.101':
    'プロジェクト概要を入力してください',
  'auto.pages.pages.requirements.role-analysis.index.102':
    'ヒント信息（用于辅助生成）',
  'auto.pages.pages.requirements.role-analysis.index.103':
    '例: 重点补充权限模型、外部系统依赖与验收标准',
  'auto.pages.pages.requirements.role-analysis.index.104': '分解角色数量',
  'auto.pages.pages.requirements.role-analysis.index.105':
    '分解数を入力してください',
  'auto.pages.pages.requirements.role-analysis.index.106': '数量範囲为 1-20',
  'auto.pages.pages.requirements.role-analysis.index.107':
    '参考機能一覧（若プロジェクト已有機能一覧）',
  'auto.pages.pages.requirements.role-analysis.index.108':
    'プロジェクト情報を保存',
  'auto.pages.pages.requirements.role-analysis.index.109': 'キャンセル',
  'auto.pages.pages.requirements.role-analysis.index.110': '生成プレビュー',
  'auto.pages.pages.requirements.role-analysis.index.111': 'プレビュー结果',
  'auto.pages.pages.requirements.role-analysis.index.112':
    '勾选需要的角色后添加到列表',
  'auto.pages.pages.requirements.role-analysis.index.113':
    '点击“生成プレビュー”后查看候选角色',
  'auto.pages.pages.requirements.role-analysis.index.114': '重名时覆盖已有角色',
  'auto.pages.pages.requirements.role-analysis.index.115':
    '添加选中到角色列表（',
  'auto.pages.pages.requirements.system-integration.index.1': '第三方系统',
  'auto.pages.pages.requirements.system-integration.index.2': '硬件设备',
  'auto.pages.pages.requirements.system-integration.index.3': '云服务',
  'auto.pages.pages.requirements.system-integration.index.4': '政务平台',
  'auto.pages.pages.requirements.system-integration.index.5': '支付平台',
  'auto.pages.pages.requirements.system-integration.index.6': '物流平台',
  'auto.pages.pages.requirements.system-integration.index.7': '其他',
  'auto.pages.pages.requirements.system-integration.index.8':
    '未命名プロジェクト',
  'auto.pages.pages.requirements.system-integration.index.9':
    '読み込み系统对接分析失敗',
  'auto.pages.pages.requirements.system-integration.index.10':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.system-integration.index.11':
    'プロジェクト信息已保存',
  'auto.pages.pages.requirements.system-integration.index.12':
    'プロジェクト情報を保存に失敗しました',
  'auto.pages.pages.requirements.system-integration.index.13':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.system-integration.index.14':
    'AI 生成完了（参考機能件 {p1} 条）, 選択してください后添加',
  'auto.pages.pages.requirements.system-integration.index.15': 'AI 生成失敗',
  'auto.pages.pages.requirements.system-integration.index.16':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.system-integration.index.17':
    '请先勾选プレビュー对接件',
  'auto.pages.pages.requirements.system-integration.index.18':
    '已添加并保存 {p1} 个对接件',
  'auto.pages.pages.requirements.system-integration.index.19': '添加失敗',
  'auto.pages.pages.requirements.system-integration.index.20':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.system-integration.index.21': '保存しました',
  'auto.pages.pages.requirements.system-integration.index.22':
    '保存に失敗しました',
  'auto.pages.pages.requirements.system-integration.index.23':
    'プロジェクトが認識されていません.左側でプロジェクトを切り替えてください.',
  'auto.pages.pages.requirements.system-integration.index.24':
    '已クリア系统对接分析数据',
  'auto.pages.pages.requirements.system-integration.index.25':
    'クリアに失敗しました',
  'auto.pages.pages.requirements.system-integration.index.26': '未入力',
  'auto.pages.pages.requirements.system-integration.index.27': '/',
  'auto.pages.pages.requirements.system-integration.index.28': '未入力',
  'auto.pages.pages.requirements.system-integration.index.29': '类别',
  'auto.pages.pages.requirements.system-integration.index.30': '未入力',
  'auto.pages.pages.requirements.system-integration.index.31': '对接方式',
  'auto.pages.pages.requirements.system-integration.index.32': '协议类型',
  'auto.pages.pages.requirements.system-integration.index.33': '/',
  'auto.pages.pages.requirements.system-integration.index.34': '认证方式',
  'auto.pages.pages.requirements.system-integration.index.35': '数据方向',
  'auto.pages.pages.requirements.system-integration.index.36': '难度',
  'auto.pages.pages.requirements.system-integration.index.37': '()',
  'auto.pages.pages.requirements.system-integration.index.38': '接口ステータス',
  'auto.pages.pages.requirements.system-integration.index.39': '是否收费',
  'auto.pages.pages.requirements.system-integration.index.40': '是',
  'auto.pages.pages.requirements.system-integration.index.41': '否',
  'auto.pages.pages.requirements.system-integration.index.42': '费用情况',
  'auto.pages.pages.requirements.system-integration.index.43': '供应商',
  'auto.pages.pages.requirements.system-integration.index.44': '对接人',
  'auto.pages.pages.requirements.system-integration.index.45': '对接电话',
  'auto.pages.pages.requirements.system-integration.index.46': '对接邮箱',
  'auto.pages.pages.requirements.system-integration.index.47': '风险与限制',
  'auto.pages.pages.requirements.system-integration.index.48': '备注',
  'auto.pages.pages.requirements.system-integration.index.49': 'ステータス',
  'auto.pages.pages.requirements.system-integration.index.50': '操作',
  'auto.pages.pages.requirements.system-integration.index.51': '編集',
  'auto.pages.pages.requirements.system-integration.index.52': '削除',
  'auto.pages.pages.requirements.system-integration.index.53': '/',
  'auto.pages.pages.requirements.system-integration.index.54': '未入力',
  'auto.pages.pages.requirements.system-integration.index.55': '类别',
  'auto.pages.pages.requirements.system-integration.index.56': '对接方式',
  'auto.pages.pages.requirements.system-integration.index.57': '协议类型',
  'auto.pages.pages.requirements.system-integration.index.58': '难度',
  'auto.pages.pages.requirements.system-integration.index.59': '工作量',
  'auto.pages.pages.requirements.system-integration.index.60': '接口ステータス',
  'auto.pages.pages.requirements.system-integration.index.61': '收费',
  'auto.pages.pages.requirements.system-integration.index.62': '是',
  'auto.pages.pages.requirements.system-integration.index.63': '否',
  'auto.pages.pages.requirements.system-integration.index.64': '系统对接',
  'auto.pages.pages.requirements.system-integration.index.65':
    '基于プロジェクト“{p1}”認識第三方系统与硬件设备对接要件',
  'auto.pages.pages.requirements.system-integration.index.66': 'AI',
  'auto.pages.pages.requirements.system-integration.index.67': '新增对接件',
  'auto.pages.pages.requirements.system-integration.index.68': '保存',
  'auto.pages.pages.requirements.system-integration.index.69':
    '確認クリア現在プロジェクト系统对接数据？',
  'auto.pages.pages.requirements.system-integration.index.70': 'クリア重置',
  'auto.pages.pages.requirements.system-integration.index.71': '削除选中（',
  'auto.pages.pages.requirements.system-integration.index.72':
    '暂无系统对接数据, 点击“AI系统对接分析”或“新增对接件”開始',
  'auto.pages.pages.requirements.system-integration.index.73': '編集系统对接件',
  'auto.pages.pages.requirements.system-integration.index.74': '新增系统对接件',
  'auto.pages.pages.requirements.system-integration.index.75': '确定',
  'auto.pages.pages.requirements.system-integration.index.76': 'キャンセル',
  'auto.pages.pages.requirements.system-integration.index.77': '/',
  'auto.pages.pages.requirements.system-integration.index.78':
    '请输入系统或设备名称',
  'auto.pages.pages.requirements.system-integration.index.79':
    '例: SAP ERP、金税平台、条码扫描设备',
  'auto.pages.pages.requirements.system-integration.index.80': '类别',
  'auto.pages.pages.requirements.system-integration.index.81': '对接方式',
  'auto.pages.pages.requirements.system-integration.index.82': '（ ）',
  'auto.pages.pages.requirements.system-integration.index.83':
    '例: HTTPS+JSON、AMQP、MQTT、Modbus TCP',
  'auto.pages.pages.requirements.system-integration.index.84': '认证方式',
  'auto.pages.pages.requirements.system-integration.index.85':
    '例: OAuth2、AK/SK、BasicAuth、设备证书',
  'auto.pages.pages.requirements.system-integration.index.86': '/',
  'auto.pages.pages.requirements.system-integration.index.87':
    '例: https://api.partner.com/v1/orders 或 mq://cluster/topic',
  'auto.pages.pages.requirements.system-integration.index.88': '数据方向',
  'auto.pages.pages.requirements.system-integration.index.89': '对接难度',
  'auto.pages.pages.requirements.system-integration.index.90':
    '工作量見積（人天）',
  'auto.pages.pages.requirements.system-integration.index.91':
    '第三方接口ステータス',
  'auto.pages.pages.requirements.system-integration.index.92': '是否收费',
  'auto.pages.pages.requirements.system-integration.index.93':
    '该对接件需要收费',
  'auto.pages.pages.requirements.system-integration.index.94': 'ステータス',
  'auto.pages.pages.requirements.system-integration.index.95': '费用情况',
  'auto.pages.pages.requirements.system-integration.index.96':
    '例: 按调用量计费、按年授权、一次性设备采购等',
  'auto.pages.pages.requirements.system-integration.index.97': '/',
  'auto.pages.pages.requirements.system-integration.index.98': '对接人',
  'auto.pages.pages.requirements.system-integration.index.99': '对接人电话',
  'auto.pages.pages.requirements.system-integration.index.100': '对接人邮箱',
  'auto.pages.pages.requirements.system-integration.index.101': '风险与限制',
  'auto.pages.pages.requirements.system-integration.index.102': '备注',
  'auto.pages.pages.requirements.system-integration.index.103':
    'AI 系统对接分析',
  'auto.pages.pages.requirements.system-integration.index.104': '生成选件',
  'auto.pages.pages.requirements.system-integration.index.105':
    'プロジェクト名',
  'auto.pages.pages.requirements.system-integration.index.106':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.system-integration.index.107':
    'プロジェクト名を入力してください',
  'auto.pages.pages.requirements.system-integration.index.108':
    'プロジェクト概要',
  'auto.pages.pages.requirements.system-integration.index.109':
    'プロジェクト概要を入力してください',
  'auto.pages.pages.requirements.system-integration.index.110':
    'ヒント信息（用于辅助生成）',
  'auto.pages.pages.requirements.system-integration.index.111':
    '例: 重点認識财务平台、物流平台、工业设备、消息中间件等外部依赖',
  'auto.pages.pages.requirements.system-integration.index.112':
    '分解对接件数量',
  'auto.pages.pages.requirements.system-integration.index.113':
    '分解数を入力してください',
  'auto.pages.pages.requirements.system-integration.index.114':
    '数量範囲为 1-30',
  'auto.pages.pages.requirements.system-integration.index.115':
    '参考機能一覧（若プロジェクト已有機能一覧）',
  'auto.pages.pages.requirements.system-integration.index.116':
    'プロジェクト情報を保存',
  'auto.pages.pages.requirements.system-integration.index.117': 'キャンセル',
  'auto.pages.pages.requirements.system-integration.index.118':
    '生成プレビュー',
  'auto.pages.pages.requirements.system-integration.index.119':
    'プレビュー结果',
  'auto.pages.pages.requirements.system-integration.index.120':
    '勾选需要的对接件后添加到列表',
  'auto.pages.pages.requirements.system-integration.index.121':
    '点击“生成プレビュー”后查看候选对接件',
  'auto.pages.pages.requirements.system-integration.index.122':
    '重名时覆盖已有对接件',
  'auto.pages.pages.requirements.system-integration.index.123':
    '添加选中到对接列表（',
  'auto.pages.pages.task-management.index.1': '完成支付模块接口联调',
  'auto.pages.pages.task-management.index.2': '张三',
  'auto.pages.pages.task-management.index.3': '补充用户中心单元测试',
  'auto.pages.pages.task-management.index.4': '李四',
  'auto.pages.pages.task-management.index.5': '发布前回归清单确认',
  'auto.pages.pages.task-management.index.6': '王五',
  'auto.pages.pages.task-management.index.7': '任务',
  'auto.pages.pages.task-management.index.8': '负责人',
  'auto.pages.pages.task-management.index.9': '迭代',
  'auto.pages.pages.task-management.index.10': '优先级',
  'auto.pages.pages.task-management.index.11': '高',
  'auto.pages.pages.task-management.index.12': '中',
  'auto.pages.pages.task-management.index.13': '低',
  'auto.pages.pages.task-management.index.14': '状态',
  'auto.pages.pages.task-management.index.15': '待处理',
  'auto.pages.pages.task-management.index.16': '进行中',
  'auto.pages.pages.task-management.index.17': '已完成',
  'auto.pages.pages.task-management.index.18': '任务管理',
  'auto.pages.pages.task-management.index.19': '任务拆解、分派、跟踪与迭代推进',
  'auto.pages.pages.test-management.bug.index.1': '缺陷标题',
  'auto.pages.pages.test-management.bug.index.2': '严重程度',
  'auto.pages.pages.test-management.bug.index.3': '阻断',
  'auto.pages.pages.test-management.bug.index.4': '严重',
  'auto.pages.pages.test-management.bug.index.5': '主要',
  'auto.pages.pages.test-management.bug.index.6': '次要',
  'auto.pages.pages.test-management.bug.index.7': '优先级',
  'auto.pages.pages.test-management.bug.index.8': '状态',
  'auto.pages.pages.test-management.bug.index.9': '新建',
  'auto.pages.pages.test-management.bug.index.10': '处理中',
  'auto.pages.pages.test-management.bug.index.11': '已解决',
  'auto.pages.pages.test-management.bug.index.12': '已修复',
  'auto.pages.pages.test-management.bug.index.13': '已关闭',
  'auto.pages.pages.test-management.bug.index.14': '创建人',
  'auto.pages.pages.test-management.bug.index.15': '处理人',
  'auto.pages.pages.test-management.bug.index.16': '创建时间',
  'auto.pages.pages.test-management.bug.index.17': '操作',
  'auto.pages.pages.test-management.bug.index.18': '编辑',
  'auto.pages.pages.test-management.bug.index.19': '详情',
  'auto.pages.pages.test-management.bug.index.20': '新建缺陷',
  'auto.pages.pages.test-management.case.index.1': '用例名称',
  'auto.pages.pages.test-management.case.index.2': '用例级别',
  'auto.pages.pages.test-management.case.index.3': '测试类型',
  'auto.pages.pages.test-management.case.index.4': '功能测试',
  'auto.pages.pages.test-management.case.index.5': '性能测试',
  'auto.pages.pages.test-management.case.index.6': '接口测试',
  'auto.pages.pages.test-management.case.index.7': '安全测试',
  'auto.pages.pages.test-management.case.index.8': '状态',
  'auto.pages.pages.test-management.case.index.9': '草稿',
  'auto.pages.pages.test-management.case.index.10': '评审中',
  'auto.pages.pages.test-management.case.index.11': '待执行',
  'auto.pages.pages.test-management.case.index.12': '创建人',
  'auto.pages.pages.test-management.case.index.13': '更新时间',
  'auto.pages.pages.test-management.case.index.14': '操作',
  'auto.pages.pages.test-management.case.index.15': 'Mock: 编辑功能',
  'auto.pages.pages.test-management.case.index.16': '编辑',
  'auto.pages.pages.test-management.case.index.17': 'Mock: 执行用例',
  'auto.pages.pages.test-management.case.index.18': '执行',
  'auto.pages.pages.test-management.case.index.19': '确认删除？',
  'auto.pages.pages.test-management.case.index.20': '已删除（Mock）',
  'auto.pages.pages.test-management.case.index.21': '删除',
  'auto.pages.pages.test-management.case.index.22': 'Mock: 新建用例',
  'auto.pages.pages.test-management.case.index.23': '新建用例',
  'auto.pages.pages.test-management.case-library.index.1': '库名称',
  'auto.pages.pages.test-management.case-library.index.2': '描述',
  'auto.pages.pages.test-management.case-library.index.3': '用例总数',
  'auto.pages.pages.test-management.case-library.index.4': '个',
  'auto.pages.pages.test-management.case-library.index.5': '创建人',
  'auto.pages.pages.test-management.case-library.index.6': '更新时间',
  'auto.pages.pages.test-management.case-library.index.7': '操作',
  'auto.pages.pages.test-management.case-library.index.8': 'Mock: 编辑用例库',
  'auto.pages.pages.test-management.case-library.index.9': '编辑',
  'auto.pages.pages.test-management.case-library.index.10': 'Mock: 管理用例库',
  'auto.pages.pages.test-management.case-library.index.11': '管理',
  'auto.pages.pages.test-management.case-library.index.12': '确认删除用例库？',
  'auto.pages.pages.test-management.case-library.index.13': '已删除（Mock）',
  'auto.pages.pages.test-management.case-library.index.14': '删除',
  'auto.pages.pages.test-management.case-library.index.15': 'Mock: 新建用例库',
  'auto.pages.pages.test-management.case-library.index.16': '新建用例库',
  'auto.pages.pages.test-management.dashboard.index.1': '用例分布',
  'auto.pages.pages.test-management.dashboard.index.2': '严重程度',
  'auto.pages.pages.test-management.dashboard.index.3': '缺陷数量',
  'auto.pages.pages.test-management.dashboard.index.4': '测试名称',
  'auto.pages.pages.test-management.dashboard.index.5': '负责人',
  'auto.pages.pages.test-management.dashboard.index.6': '状态',
  'auto.pages.pages.test-management.dashboard.index.7': '已完成',
  'auto.pages.pages.test-management.dashboard.index.8': '进行中',
  'auto.pages.pages.test-management.dashboard.index.9': '失败',
  'auto.pages.pages.test-management.dashboard.index.10': '排队中',
  'auto.pages.pages.test-management.dashboard.index.11': '进度',
  'auto.pages.pages.test-management.dashboard.index.12': '开始时间',
  'auto.pages.pages.test-management.dashboard.index.13': '测试管理仪表盘',
  'auto.pages.pages.test-management.dashboard.index.14': '用例状态分布',
  'auto.pages.pages.test-management.dashboard.index.15': '缺陷严重程度分布',
  'auto.pages.pages.test-management.dashboard.index.16': '用例执行趋势',
  'auto.pages.pages.test-management.dashboard.index.17': '缺陷发现与修复趋势',
  'auto.pages.pages.test-management.dashboard.index.18': '近期测试任务',
  'auto.pages.pages.test-management.index.1': '项目切换后菜单状态保持',
  'auto.pages.pages.test-management.index.2': '需求概要AI生成结果可保存',
  'auto.pages.pages.test-management.index.3': '代码仓库授权失败回滚',
  'auto.pages.pages.test-management.order.index.1': '测试单标题',
  'auto.pages.pages.test-management.order.index.2': '测试类型',
  'auto.pages.pages.test-management.order.index.3': '全功能测试',
  'auto.pages.pages.test-management.order.index.4': '冒烟测试',
  'auto.pages.pages.test-management.order.index.5': '专项测试',
  'auto.pages.pages.test-management.order.index.6': '性能测试',
  'auto.pages.pages.test-management.order.index.7': '当前进度',
  'auto.pages.pages.test-management.order.index.8': '状态',
  'auto.pages.pages.test-management.order.index.9': '草稿',
  'auto.pages.pages.test-management.order.index.10': '执行中',
  'auto.pages.pages.test-management.order.index.11': '已完成',
  'auto.pages.pages.test-management.order.index.12': '已终止',
  'auto.pages.pages.test-management.order.index.13': '负责人',
  'auto.pages.pages.test-management.order.index.14': '计划完成日期',
  'auto.pages.pages.test-management.order.index.15': '操作',
  'auto.pages.pages.test-management.order.index.16': 'Mock: 编辑测试单',
  'auto.pages.pages.test-management.order.index.17': '编辑',
  'auto.pages.pages.test-management.order.index.18': 'Mock: 进入执行空间',
  'auto.pages.pages.test-management.order.index.19': '执行',
  'auto.pages.pages.test-management.order.index.20': 'Mock: 查看报告',
  'auto.pages.pages.test-management.order.index.21': '报告',
  'auto.pages.pages.test-management.order.index.22': 'Mock: 新建测试单',
  'auto.pages.pages.test-management.order.index.23': '新建测试单',
  'auto.pages.pages.test-management.report.index.1': '报告名称',
  'auto.pages.pages.test-management.report.index.2': '关联测试单',
  'auto.pages.pages.test-management.report.index.3': '通过率',
  'auto.pages.pages.test-management.report.index.4': '缺陷数',
  'auto.pages.pages.test-management.report.index.5': '负责人',
  'auto.pages.pages.test-management.report.index.6': '生成时间',
  'auto.pages.pages.test-management.report.index.7': '操作',
  'auto.pages.pages.test-management.report.index.8': 'Mock: 查看报告详情',
  'auto.pages.pages.test-management.report.index.9': '查看',
  'auto.pages.pages.test-management.report.index.10': 'Mock: 下载 PDF',
  'auto.pages.pages.test-management.report.index.11': '下载',
  'auto.pages.pages.test-management.report.index.12': '确认删除报告？',
  'auto.pages.pages.test-management.report.index.13': '报告已删除（Mock）',
  'auto.pages.pages.test-management.report.index.14': '删除',
  'auto.pages.pages.test-management.suite.index.1': '测试集名称',
  'auto.pages.pages.test-management.suite.index.2': '描述',
  'auto.pages.pages.test-management.suite.index.3': '包含用例数',
  'auto.pages.pages.test-management.suite.index.4': '个用例',
  'auto.pages.pages.test-management.suite.index.5': '创建人',
  'auto.pages.pages.test-management.suite.index.6': '创建时间',
  'auto.pages.pages.test-management.suite.index.7': '操作',
  'auto.pages.pages.test-management.suite.index.8': 'Mock: 编辑功能',
  'auto.pages.pages.test-management.suite.index.9': '编辑',
  'auto.pages.pages.test-management.suite.index.10': 'Mock: 管理用例',
  'auto.pages.pages.test-management.suite.index.11': '管理用例',
  'auto.pages.pages.test-management.suite.index.12': '确认删除？',
  'auto.pages.pages.test-management.suite.index.13': '已删除（Mock）',
  'auto.pages.pages.test-management.suite.index.14': '删除',
  'auto.pages.pages.test-management.suite.index.15': 'Mock: 新建测试集',
  'auto.pages.pages.test-management.suite.index.16': '新建测试集',
  'auto.component.components.Footer.index.1':
    '2026 珊瑚智成（北京）科技有限公司',
  'auto.component.components.Layout.SiderResizeHandle.1': '调整菜单宽度',
  'auto.component.components.LexicalBlockEditor.1': '请输入链接地址',
  'auto.component.components.LexicalBlockEditor.2': '撤销',
  'auto.component.components.LexicalBlockEditor.3': '重做',
  'auto.component.components.LexicalBlockEditor.4': '正文',
  'auto.component.components.LexicalBlockEditor.5': '标题 1',
  'auto.component.components.LexicalBlockEditor.6': '标题 2',
  'auto.component.components.LexicalBlockEditor.7': '标题 3',
  'auto.component.components.LexicalBlockEditor.8': '引用',
  'auto.component.components.LexicalBlockEditor.9': '代码块',
  'auto.component.components.LexicalBlockEditor.10': '无序列表',
  'auto.component.components.LexicalBlockEditor.11': '有序列表',
  'auto.component.components.LexicalBlockEditor.12': '任务列表',
  'auto.component.components.LexicalBlockEditor.13': '加粗',
  'auto.component.components.LexicalBlockEditor.14': '斜体',
  'auto.component.components.LexicalBlockEditor.15': '下划线',
  'auto.component.components.LexicalBlockEditor.16': '删除线',
  'auto.component.components.LexicalBlockEditor.17': '行内代码',
  'auto.component.components.LexicalBlockEditor.18': '取消链接',
  'auto.component.components.LexicalBlockEditor.19': '插入链接',
  'auto.component.components.LexicalBlockEditor.20': '无序列表',
  'auto.component.components.LexicalBlockEditor.21': '有序列表',
  'auto.component.components.LexicalBlockEditor.22': '插入表格',
  'auto.component.components.LexicalBlockEditor.23': '上方插入行',
  'auto.component.components.LexicalBlockEditor.24': '行↑',
  'auto.component.components.LexicalBlockEditor.25': '下方插入行',
  'auto.component.components.LexicalBlockEditor.26': '行↓',
  'auto.component.components.LexicalBlockEditor.27': '左侧插入列',
  'auto.component.components.LexicalBlockEditor.28': '列←',
  'auto.component.components.LexicalBlockEditor.29': '右侧插入列',
  'auto.component.components.LexicalBlockEditor.30': '列→',
  'auto.component.components.LexicalBlockEditor.31': '左对齐',
  'auto.component.components.LexicalBlockEditor.32': '居中',
  'auto.component.components.LexicalBlockEditor.33': '右对齐',
  'auto.component.components.LexicalBlockEditor.34': '请输入链接地址',
  'auto.component.components.LexicalBlockEditor.35': '加粗',
  'auto.component.components.LexicalBlockEditor.36': '斜体',
  'auto.component.components.LexicalBlockEditor.37': '下划线',
  'auto.component.components.LexicalBlockEditor.38': '删除线',
  'auto.component.components.LexicalBlockEditor.39': '下标',
  'auto.component.components.LexicalBlockEditor.40': '上标',
  'auto.component.components.LexicalBlockEditor.41': '行内代码',
  'auto.component.components.LexicalBlockEditor.42': '取消链接',
  'auto.component.components.LexicalBlockEditor.43': '插入链接',
  'auto.component.components.LexicalBlockEditor.44': '正文',
  'auto.component.components.LexicalBlockEditor.45': '段落',
  'auto.component.components.LexicalBlockEditor.46': '标题1',
  'auto.component.components.LexicalBlockEditor.47': '一级标题',
  'auto.component.components.LexicalBlockEditor.48': '标题2',
  'auto.component.components.LexicalBlockEditor.49': '二级标题',
  'auto.component.components.LexicalBlockEditor.50': '标题3',
  'auto.component.components.LexicalBlockEditor.51': '三级标题',
  'auto.component.components.LexicalBlockEditor.52': '有序',
  'auto.component.components.LexicalBlockEditor.53': '序号',
  'auto.component.components.LexicalBlockEditor.54': '无序',
  'auto.component.components.LexicalBlockEditor.55': '圆点',
  'auto.component.components.LexicalBlockEditor.56': '任务',
  'auto.component.components.LexicalBlockEditor.57': '清单',
  'auto.component.components.LexicalBlockEditor.58': '表格',
  'auto.component.components.LexicalBlockEditor.59': '分割线',
  'auto.component.components.LexicalBlockEditor.60': '引用',
  'auto.component.components.LexicalBlockEditor.61': '代码',
  'auto.component.components.LexicalBlockEditor.62': '代码块',
  'auto.component.components.LexicalBlockEditor.63': '拖动排序',
  'auto.component.components.LexicalBlockEditor.64': '放置到此处',
  'auto.component.components.LexicalBlockEditor.65': '请输入概要内容',
  'auto.component.components.RichTextEditor.index.1': '请输入内容...',
  'auto.pages.pages.requirements.concept-analysis.group.index.1':
    '現在プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.group.index.2':
    '現在プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.group.index.3':
    '読み込み概念分组失敗',
  'auto.pages.pages.requirements.concept-analysis.group.index.4':
    '请先选择プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.group.index.5':
    '请输入分组名称（支持一行一个）',
  'auto.pages.pages.requirements.concept-analysis.group.index.6': '作成 失敗',
  'auto.pages.pages.requirements.concept-analysis.group.index.7':
    '作成 {{p1}} , 失敗 {{p2}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.8': '作成 {{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.9': '作成 失敗',
  'auto.pages.pages.requirements.concept-analysis.group.index.10': '作成 失敗',
  'auto.pages.pages.requirements.concept-analysis.group.index.11': '更新',
  'auto.pages.pages.requirements.concept-analysis.group.index.12': '更新 失敗',
  'auto.pages.pages.requirements.concept-analysis.group.index.13': '削除',
  'auto.pages.pages.requirements.concept-analysis.group.index.14': '削除 失敗',
  'auto.pages.pages.requirements.concept-analysis.group.index.15': '先に',
  'auto.pages.pages.requirements.concept-analysis.group.index.16': '保存',
  'auto.pages.pages.requirements.concept-analysis.group.index.17': '保存 失敗',
  'auto.pages.pages.requirements.concept-analysis.group.index.18': '概念分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.19':
    'プロジェクト: {{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.20': '列',
  'auto.pages.pages.requirements.concept-analysis.group.index.21': '作成',
  'auto.pages.pages.requirements.concept-analysis.group.index.22': '暂无分组',
  'auto.pages.pages.requirements.concept-analysis.group.index.23':
    '削除確認该分组？',
  'auto.pages.pages.requirements.concept-analysis.group.index.24': '削除',
  'auto.pages.pages.requirements.concept-analysis.group.index.25': ': {{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.26': '成员维护',
  'auto.pages.pages.requirements.concept-analysis.group.index.27': '保存',
  'auto.pages.pages.requirements.concept-analysis.group.index.28':
    '请选择左侧分组后編集成员',
  'auto.pages.pages.requirements.concept-analysis.group.index.29': '. 現在 .',
  'auto.pages.pages.requirements.concept-analysis.group.index.30':
    '搜索概念中国語名',
  'auto.pages.pages.requirements.concept-analysis.group.index.31': '作成',
  'auto.pages.pages.requirements.concept-analysis.group.index.32': '作成',
  'auto.pages.pages.requirements.concept-analysis.group.index.33':
    '分组名称, 支持一括添加（一行一个）\\n例: \\n核心业务概念\\n业务流程概念',
  'auto.pages.pages.requirements.concept-analysis.group.index.34':
    '分组説明（任意, 一括作成时会適用到每个分组）',
  'auto.pages.pages.requirements.concept-analysis.management.index.1':
    '少なくとも输入一条概念, 支持“概念名｜释义”按行录入',
  'auto.pages.pages.requirements.concept-analysis.management.index.2':
    '已根据人工录入生成 {{p1}} 条概念プレビュー',
  'auto.pages.pages.requirements.concept-analysis.management.index.3':
    '分解モード: （ 100）',
  'auto.pages.pages.requirements.concept-analysis.management.index.4':
    '分解モード: 件数（{{p1}}）',
  'auto.pages.pages.requirements.concept-analysis.management.index.5': '关联',
  'auto.pages.pages.requirements.concept-analysis.management.index.6': 'レベル',
  'auto.pages.pages.requirements.concept-analysis.management.index.7': 'レベル',
  'auto.pages.pages.requirements.concept-analysis.management.index.8': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.9': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.10':
    '其他别称',
  'auto.pages.pages.requirements.concept-analysis.management.index.11': '本质',
  'auto.pages.pages.requirements.concept-analysis.management.index.12':
    '適用场景',
  'auto.pages.pages.requirements.concept-analysis.management.index.13':
    '相关概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.14': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.15': '核心',
  'auto.pages.pages.requirements.concept-analysis.management.index.16':
    '其他别称',
  'auto.pages.pages.requirements.concept-analysis.management.index.17': '本质',
  'auto.pages.pages.requirements.concept-analysis.management.index.18':
    '適用场景',
  'auto.pages.pages.requirements.concept-analysis.management.index.19':
    '相关概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.20':
    '削除確認概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.21':
    '削除確認',
  'auto.pages.pages.requirements.concept-analysis.management.index.22':
    'キャンセル',
  'auto.pages.pages.requirements.concept-analysis.management.index.23':
    '削除 .現在 削除',
  'auto.pages.pages.requirements.concept-analysis.management.index.24': ',',
  'auto.pages.pages.requirements.concept-analysis.management.index.25': '.',
  'auto.pages.pages.requirements.concept-analysis.management.index.26': ':',
  'auto.pages.pages.requirements.concept-analysis.management.index.27':
    '{{p1}}',
  'auto.pages.pages.requirements.concept-analysis.management.index.28': '还有',
  'auto.pages.pages.requirements.concept-analysis.management.index.29':
    '条关系未展示',
  'auto.pages.pages.requirements.concept-analysis.management.index.30': '.',
  'auto.pages.pages.requirements.concept-analysis.management.index.31': '（ ）',
  'auto.pages.pages.requirements.concept-analysis.management.index.32': ',',
  'auto.pages.pages.requirements.concept-analysis.management.index.33':
    '请选择上位概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.34':
    '请选择下位概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.35':
    '是否核心概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.36':
    '核心概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.37':
    '下書き',
  'auto.pages.pages.requirements.concept-analysis.management.index.38':
    '進行中',
  'auto.pages.pages.requirements.concept-analysis.management.index.39':
    '已归档',
  'auto.pages.pages.requirements.concept-analysis.management.index.40':
    '（任意 作成）',
  'auto.pages.pages.requirements.concept-analysis.management.index.41':
    '可直接输入新概念名称',
  'auto.pages.pages.requirements.concept-analysis.management.index.42': '本质',
  'auto.pages.pages.requirements.concept-analysis.management.index.43':
    '適用场景',
  'auto.pages.pages.requirements.concept-analysis.management.index.44':
    '支持粘贴 Markdown 概念表; 系统会优先按资料抽取概念, 指定数量仅作为参考.',
  'auto.pages.pages.requirements.concept-analysis.management.index.45':
    '已检测到 Markdown 表格, 将优先按资料抽取概念',
  'auto.pages.pages.requirements.concept-analysis.management.index.46':
    '分解モード',
  'auto.pages.pages.requirements.concept-analysis.management.index.47':
    'A、尽可能多',
  'auto.pages.pages.requirements.concept-analysis.management.index.48':
    'B、指定数量',
  'auto.pages.pages.requirements.concept-analysis.management.index.49':
    'C、人工录入',
  'auto.pages.pages.requirements.concept-analysis.management.index.50':
    '请输入 1-100 的整数',
  'auto.pages.pages.requirements.concept-analysis.management.index.51':
    '人工录入',
  'auto.pages.pages.requirements.concept-analysis.management.index.52':
    '请输入人工概念一覧',
  'auto.pages.pages.requirements.concept-analysis.management.index.53':
    ', “ ｜ ” ; .',
  'auto.pages.pages.requirements.concept-analysis.management.index.54':
    '例: \\n要件条目｜可被跟踪和验收的最小要件单元\\n機能一覧｜系统能力的结构化列表',
  'auto.pages.pages.requirements.concept-analysis.relation.index.1':
    '現在プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.relation.index.2':
    '現在プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.relation.index.3':
    '読み込み概念关系失敗',
  'auto.pages.pages.requirements.concept-analysis.relation.index.4': '关联',
  'auto.pages.pages.requirements.concept-analysis.relation.index.5': 'レベル',
  'auto.pages.pages.requirements.concept-analysis.relation.index.6': '核心概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.7': '普通概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.8': '核心概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.9': '普通概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.10':
    '来源概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.11':
    '请选择来源概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.12':
    '目标概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.13':
    '请选择目标概念',
  'auto.pages.pages.requirements.concept-analysis.relation.index.14':
    '关系类型',
  'auto.pages.pages.requirements.concept-analysis.relation.index.15': '关联',
  'auto.pages.pages.requirements.concept-analysis.relation.index.16': 'レベル',
  'auto.pages.pages.requirements.concept-analysis.relation.index.17': '操作',
  'auto.pages.pages.requirements.concept-analysis.relation.index.18': '削除',
  'auto.pages.pages.requirements.concept-analysis.relation.index.19':
    '请先选择プロジェクト',
  'auto.pages.pages.requirements.concept-analysis.relation.index.20':
    '第 {p1} 行关系不足合法概念, 请检查再試行してください',
  'auto.pages.pages.requirements.concept-analysis.relation.index.21':
    '{p1} （ = ）,',
  'auto.pages.pages.requirements.concept-analysis.relation.index.22':
    ': “{p1}” （{p2} / {p3}）',
  'auto.pages.pages.requirements.concept-analysis.relation.index.23':
    '关系保存しました',
  'auto.pages.pages.requirements.concept-analysis.relation.index.24':
    '关系保存に失敗しました',
  'auto.pages.pages.requirements.concept-analysis.relation.index.25':
    '概念关系',
  'auto.pages.pages.requirements.concept-analysis.relation.index.26':
    'プロジェクト: {p1}',
  'auto.pages.pages.requirements.concept-analysis.relation.index.27': '关系图',
  'auto.pages.pages.requirements.concept-analysis.relation.index.28': ':',
  'auto.pages.pages.requirements.concept-analysis.relation.index.29': ':',
  'auto.pages.pages.requirements.concept-analysis.relation.index.30': ':',
  'auto.pages.pages.requirements.concept-analysis.relation.index.31':
    '图谱展示“相关概念 +\\n 上下位概念”关系, 支持拖拽、缩放和悬浮查看.',
  'auto.pages.pages.requirements.concept-analysis.relation.index.32':
    '暂无概念数据',
  'auto.pages.pages.requirements.concept-analysis.relation.index.33':
    '表格管理',
  'auto.pages.pages.requirements.concept-analysis.relation.index.34':
    '新增关系',
  'auto.pages.pages.requirements.concept-analysis.relation.index.35': '削除 （',
  'auto.pages.pages.requirements.concept-analysis.relation.index.36': '保存',
  'auto.pages.pages.project.agent-management.index.1':
    'プロジェクトにバインド済みのAgent読み込みに失敗しました',
  'auto.pages.pages.project.agent-management.index.2':
    'バインド可能なAgent読み込みに失敗しました',
  'auto.pages.pages.project.agent-management.index.3': 'Agentを更新しました',
  'auto.pages.pages.project.agent-management.index.4':
    'Agentを作成してバインドしました',
  'auto.pages.pages.project.agent-management.index.5': 'バインドしました',
  'auto.pages.pages.project.agent-management.index.6': 'バインドに失敗しました',
  'auto.pages.pages.project.agent-management.index.7':
    '現在のプロジェクトから解除しました',
  'auto.pages.pages.project.agent-management.index.8': '解除に失敗しました',
  'auto.pages.pages.project.agent-management.index.9':
    'Secret情報の読み込みに失敗しました',
  'auto.pages.pages.project.agent-management.index.10': 'Secretsを更新しました',
  'auto.pages.pages.project.agent-management.index.11': '名称',
  'auto.pages.pages.project.agent-management.index.12': '状態',
  'auto.pages.pages.project.agent-management.index.13': '操作',
  'auto.pages.pages.project.agent-management.index.14': '編集',
  'auto.pages.pages.project.agent-management.index.15':
    'このAgentを現在のプロジェクトから解除しますか？',
  'auto.pages.pages.project.agent-management.index.16': '解除',
  'auto.pages.pages.project.agent-management.index.17': '名称',
  'auto.pages.pages.project.agent-management.index.18': '状態',
  'auto.pages.pages.project.agent-management.index.19': '操作',
  'auto.pages.pages.project.agent-management.index.20':
    '現在のプロジェクトにバインド',
  'auto.pages.pages.project.agent-management.index.21': 'Agent管理',
  'auto.pages.pages.project.agent-management.index.22':
    '現在のプロジェクトでAgentバインドとSecretsを管理',
  'auto.pages.pages.project.agent-management.index.23':
    '名称 / URL / Host を検索',
  'auto.pages.pages.project.agent-management.index.24': '状態',
  'auto.pages.pages.project.agent-management.index.25': '更新',
  'auto.pages.pages.project.agent-management.index.26': '既存Agentをバインド',
  'auto.pages.pages.project.agent-management.index.27': 'Agentをクイック作成',
  'auto.pages.pages.project.agent-management.index.28': '既存Agentをバインド',
  'auto.pages.pages.project.agent-management.index.29':
    '名称 / URL / Host を検索',
  'auto.pages.pages.project.agent-management.index.30': '状態',
  'auto.pages.pages.project.agent-management.index.31': '更新',
  'auto.pages.pages.project.agent-management.index.32': 'Agentを編集',
  'auto.pages.pages.project.agent-management.index.33': 'Agentをクイック作成',
  'auto.pages.pages.project.agent-management.index.34': '名称',
  'auto.pages.pages.project.agent-management.index.35':
    'Agent名を入力してください',
  'auto.pages.pages.project.agent-management.index.36':
    'Providerを選択してください',
  'auto.pages.pages.project.agent-management.index.37':
    'Base URLを入力してください',
  'auto.pages.pages.project.agent-management.index.38': '状態',
  'auto.pages.pages.project.agent-management.index.39': '説明',
  'auto.pages.pages.project.agent-management.index.40': 'Secretsを設定{{p1}}',
  'auto.pages.pages.project.agent-management.index.41':
    '現在のSecret Keys（キー名のみ表示、値は非表示）',
  'auto.pages.pages.project.agent-management.index.42': 'Keyを入力してください',
  'auto.pages.pages.project.agent-management.index.43': '例: OPENAI_API_KEY',
  'auto.pages.pages.project.agent-management.index.44':
    'Valueを入力してください',
  'auto.pages.pages.project.agent-management.index.45':
    '平文Valueを入力してください（保存後は非表示）',
  'auto.pages.pages.project.agent-management.index.46': '削除',
  'auto.pages.pages.project.agent-management.index.47': 'Secretを1件追加',

  // Codebase detail drawer
  'pages.codebase.detail.title': 'コードベース詳細',
  'pages.codebase.detail.tab.token': 'トークン設定',
  'pages.codebase.detail.tab.commits': 'コミット履歴',
  'pages.codebase.detail.tab.readme': 'README プレビュー',
  'pages.codebase.detail.branch.placeholder': 'ブランチを選択',
  'pages.codebase.detail.noProjectId':
    'GitLab プロジェクト ID を設定して詳細を表示',
  'pages.codebase.token.create': 'トークン作成',
  'pages.codebase.token.name': 'トークン名',
  'pages.codebase.token.scopes': 'スコープ',
  'pages.codebase.token.expiresAt': '有効期限',
  'pages.codebase.token.accessLevel': 'アクセスレベル',
  'pages.codebase.token.status': 'ステータス',
  'pages.codebase.token.active': '有効',
  'pages.codebase.token.revoked': '取り消し済み',
  'pages.codebase.token.expired': '期限切れ',
  'pages.codebase.token.createdAt': '作成日時',
  'pages.codebase.token.createdSuccess': 'トークンを作成しました',
  'pages.codebase.token.createdWarning':
    'このトークン値は一度だけ表示されます。閉じる前にコピーしてください。',
  'pages.codebase.token.empty': 'プロジェクトトークンなし',
  'pages.codebase.token.neverExpires': '無期限',
  'pages.codebase.commit.hash': 'コミットハッシュ',
  'pages.codebase.commit.message': 'メッセージ',
  'pages.codebase.commit.author': '作成者',
  'pages.codebase.commit.date': '日付',
  'pages.codebase.commit.stats': '統計',
  'pages.codebase.commit.empty': 'コミットなし',
  'pages.codebase.readme.empty': 'このブランチにREADMEが見つかりません',
  'pages.codebase.readme.loading': 'READMEを読み込み中...',
  'pages.codebase.readme.error':
    'READMEの読み込みに失敗しました。GitLab設定を確認してください。',
  'pages.codebase.detail.viewDetail': '詳細',
};
